/* ============================================================
 *  《粉心忘语 · 只为你安眠》 剧情数据文件
 *  ------------------------------------------------------------
 *  ▍本文件由剧本文档「《粉心忘语：只为你安眠》完整剧情剧本（含全分支）」逐字生成
 *    - 台词、旁白、选项、分支走向、汇合文字全部取自文档原文，未做任何改写或补写
 *    - 章节顺序：序章 → 第二章 ~ 第二十三章 → 终章（文档未设第一章）
 *    - 玩家选择：播完分支剧情后【汇合】回主线（2026-10-22 已按最新文档将全部“分支走向”扩写为完整对话）
 *    - 全剧 21 个选择点，结局唯一（感受不同，命运相同）
 *    - 文档原「选择点05·火光的瞬间」两个选项已并入第四章主线火光段，代码随之删除该选择点
 *
 *  ▍图片引用约定（背景 / 立绘 / CG 全部写在本文件代码中）
 *  - 背景 bg 字段：只写文件名（不带扩展名），引擎会自动补 .jpg
 *  - 立绘 stands 字段：'角色key' 或 '角色key:表情'
 *  - CG 字段：只写文件名（不带扩展名），引擎自动补 .jpg
 *  - 新增图片只需放入 story-img 文件夹即可自动生效，无需改代码
 *  ▍BGM：可写合成音名（title/lab/desert/underground/morning/tension），
 *    也可写 music 文件夹内的 mp3 文件名（自动循环）
 *  ▍文字颜色（每一句都能单独设定，详见下方 TEXT_COLORS 与 CHARACTERS.textColor）
 *    - 单句：{ type:'text', text:'…', color:'#ff9ecb' }
 *    - 局部：{ text:'你终于[[#ffd166]]醒[[/]]了。' }
 *    - 按角色：CHARACTERS.ruoyi.textColor = '#ffb3d1'
 *    - 按旁白：TEXT_COLORS.narrator = '#c9b8e0'
 *  ============================================================ */

/* ============================================================
 *  文字颜色总配置
 *  ------------------------------------------------------------
 *  text            台词兜底色（角色没单独配置时用；留空 = 用样式表颜色）
 *  narrator        旁白默认色（留空 = 用样式表颜色）
 *  useSpeakerColor 台词是否自动跟随角色颜色（true：每句按说话人变色）
 *  bySpeaker       单独覆盖某个角色的台词色，优先级高于 CHARACTERS.textColor
 *  优先级：单句 color > 行内 [[…]] > bySpeaker > CHARACTERS.textColor
 *          > useSpeakerColor 取角色 color > text 兜底
 *
 *  改这里就能一次性调整全剧配色；只想改某一句，直接给那一句加 color 即可。
 *  ============================================================ */
/* @@TEXT_COLORS_BEGIN@@ */
export const TEXT_COLORS = {
  text: '',
  narrator: '',
  useSpeakerColor: false,
  bySpeaker: {
    // ruoyi: '#ffb3d1',
    // iq215: '#a9dcff'
  }
}
/* @@TEXT_COLORS_END@@ */

/* ---------- 角色配置 ----------
 * key：剧情中引用用 / name：画面显示名 / color：姓名标签颜色
 * textColor：该角色台词的字色（不写则跟随 color）
 * stand：默认立绘（story-img 内）/ expressions：表情 → 立绘文件名
 * 未配置 stand 的角色暂无立绘，只显示姓名标签
 */
export const CHARACTERS = {
  buluo: {
    name: '布洛',
    color: '#5ac8fa',
    textColor: '#9fe3ff',
    stand: 'stand_boluo_1_cut.png',
    expressions: {
      normal: 'stand_boluo_1_cut.png',
      serious: 'stand_boluo_2_cut.png',
      think: 'stand_boluo_think_cut.png',
      tense: 'stand_boluo_tense_cut.png',
      expect: 'stand_boluo_expect_cut.png',
      lost: 'stand_boluo_lost_cut.png',
      tender: 'stand_boluo_tender_cut.png'
    }
  },
  xiaoman: {
    name: '小满',
    color: '#ffb340',
    //textColor: '#ffd08a',
    stand: 'stand_xiaoman_1_cut.png',
    expressions: {
      normal: 'stand_xiaoman_1_cut.png',
      worry: 'stand_xiaoman_2_cut.png',
      curious: 'stand_xiaoman_curious_cut.png',
      cheer: 'stand_xiaoman_cheer_cut.png',
      amused: 'stand_xiaoman_amused_cut.png'
    }
  },
  iq215: {
    name: 'IQ-P215',
    color: '#7fc8ff',
    textColor: '#a9dcff',
    stand: 'stand_ruoyi_idle_cut.png',
    expressions: {
      idle: 'stand_ruoyi_idle_cut.png',
      blank: 'stand_ruoyi_blank_cut.png',
      confused: 'stand_ruoyi_confused_cut.png',
      smile: 'stand_ruoyi_smile_cut.png',
      apple: 'stand_ruoyi_apple_cut.png'
    }
  },
  ruoyi: {
    name: '若依',
    color: '#ff7fb6',
    //textColor: '#ffb3d1',
    stand: 'stand_ruoyi_idle_cut.png',
    expressions: {
      idle: 'stand_ruoyi_idle_cut.png',
      blank: 'stand_ruoyi_blank_cut.png',
      confused: 'stand_ruoyi_confused_cut.png',
      smile: 'stand_ruoyi_smile_cut.png',
      apple: 'stand_ruoyi_apple_cut.png'
    }
  },
  linche: {
    name: '林澈',
    color: '#7ed67e',
    textColor: '#b6ecb6',
    stand: 'stand_linche_cut.png',
    expressions: {
      normal: 'stand_linche_cut.png',
      alert: 'stand_linche_alert_cut.png',
      urge: 'stand_linche_urge_cut.png'
    }
  },
  chenying: {
    name: '陈莹',
    color: '#c9a8ff'
  },
  shenxi: {
    name: '沈汐',
    color: '#7b2cbf',
    textColor: '#c9a8ff'
  },
  luoluo: {
    name: '洛洛',
    color: '#ff8fb3',
    stand: 'stand_luoluo_1_cut.png',
    expressions: {
      idle: 'stand_luoluo_1_cut.png',
      smile: 'stand_luoluo_1_cut.png'
    }
  },
  tangtang: {
    name: '糖糖',
    color: '#ff9ecb'
  },
  doudou: {
    name: '兜兜',
    color: '#ffd166'
  },
  doudouma: {
    name: '兜兜妈',
    color: '#e8a87c'
  },
  supopo: {
    name: '苏婆婆',
    color: '#b8a9c9'
  },
  apo: {
    name: '阿婆',
    color: '#d4a373'
  },
  masan: {
    name: '马三',
    color: '#8d99ae'
  },
  lier: {
    name: '李二',
    color: '#6d6875'
  },
  daxiong: {
    name: '大熊',
    color: '#5f6368'
  },
  tuantuan: {
    name: '团团',
    color: '#f4a261'
  },
  xiaoxu: {
    name: '小徐',
    color: '#90a955'
  },
  xiaogu: {
    name: '小顾',
    color: '#f28482'
  },
  azhe: {
    name: '阿哲',
    color: '#84a59d'
  },
  shikong: {
    name: '时空寻回兽',
    color: '#7b2cbf'
  },
  system: {
    name: '系统',
    color: '#7fc8ff'
  },
  guard: {
    name: '保安',
    color: '#9aa0a6'
  },
  inspector: {
    name: '安检员',
    color: '#9aa0a6'
  },
  yancha: {
    name: '巡查员',
    color: '#9aa0a6'
  },
  wujing: {
    name: '武警',
    color: '#9aa0a6'
  },
  zhuchiren: {
    name: '主持人',
    color: '#e76f51'
  },
  danmu: {
    name: '弹幕',
    color: '#9aa0a6'
  },
  huachenshan: {
    name: '花衬衫',
    color: '#9aa0a6'
  },
  zui: {
    name: '醉汉',
    color: '#9aa0a6'
  },
  dama: {
    name: '大妈',
    color: '#9aa0a6'
  },
  xiaonvhai: {
    name: '小女孩',
    color: '#f6bd60'
  },
  xiaonanhai: {
    name: '小男孩',
    color: '#90be6d'
  },
  laoyeye: {
    name: '糖画爷爷',
    color: '#b08968'
  },
  caifan: {
    name: '菜贩',
    color: '#a98467'
  },
  renqun: {
    name: '人群',
    color: '#9aa0a6'
  },
  gongzuo: {
    name: '工作人员',
    color: '#9aa0a6'
  },
  shouyinyuan: {
    name: '收银员',
    color: '#9aa0a6'
  },
  dianyuan: {
    name: '店员',
    color: '#9aa0a6'
  },
  boyin: {
    name: '播音员',
    color: '#9aa0a6'
  },
  linju: {
    name: '邻居',
    color: '#9aa0a6'
  },
  yisheng: {
    name: '医生',
    color: '#9aa0a6'
  },
  laonainai: {
    name: '老奶奶',
    color: '#b8a9c9'
  },
}

/* ---------- 素材清单（本文件实际引用） ---------- */
export const IMAGE_REFERENCE = {
  bg: {
    bg_wasteland_view: 'story-img/bg_wasteland_view.jpg',
    bg_lab_night: 'story-img/bg_lab_night.jpg',
    bg_forbidden_desert: 'story-img/bg_forbidden_desert.jpg',
    bg_security_gate: 'story-img/bg_security_gate.jpg',
    bg_underground_lab: 'story-img/bg_underground_lab.jpg',
    bg_living_room: 'story-img/bg_living_room.jpg',
    bg_observatory: 'story-img/bg_observatory.jpg',
    bg_quantum_room: 'story-img/bg_quantum_room.jpg',
    bg_transform_room: 'story-img/bg_transform_room.jpg',
    bg_committee_office: 'story-img/bg_committee_office.jpg',
    bg_city_street: 'story-img/bg_city_street.jpg',
    bg_fountain_square: 'story-img/bg_fountain_square.jpg',
    bg_subway: 'story-img/bg_subway.jpg',
    bg_sweet_shop: 'story-img/bg_sweet_shop.jpg',
    bg_mall: 'story-img/bg_mall.jpg',
    bg_dress_shop: 'story-img/bg_dress_shop.jpg',
    bg_game_center: 'story-img/bg_game_center.jpg',
    bg_amusement_park: 'story-img/bg_amusement_park.jpg',
    bg_airport: 'story-img/bg_airport.jpg',
    bg_highspeed: 'story-img/bg_highspeed.jpg',
    bg_apartment: 'story-img/bg_apartment.jpg',
    bg_seaside: 'story-img/bg_seaside.jpg',
    bg_park: 'story-img/bg_park.jpg',
    bg_old_town: 'story-img/bg_old_town.jpg',
    bg_village: 'story-img/bg_village.jpg',
    bg_plaza: 'story-img/bg_plaza.jpg',
    bg_black_factory: 'story-img/bg_black_factory.jpg',
    bg_expo: 'story-img/bg_expo.jpg',
    bg_recycle: 'story-img/bg_recycle.jpg',
    bg_institute: 'story-img/bg_institute.jpg',
    bg_rooftop: 'story-img/bg_rooftop.jpg',
    bg_tailor_shop: 'story-img/bg_tailor_shop.jpg',
    bg_flower_shop: 'story-img/bg_flower_shop.jpg',
    bg_shelter: 'story-img/bg_shelter.jpg',
    bg_empty_city: 'story-img/bg_empty_city.jpg',
    bg_void: 'story-img/bg_void.jpg',
    bg_battle_sky: 'story-img/bg_battle_sky.jpg',
    bg_ruins: 'story-img/bg_ruins.jpg',
  },
  cg: {
    cg_chip: 'story-img/cg_chip.jpg',
    cg_mechanical_arm: 'story-img/cg_mechanical_arm.jpg',
    cg_awaken: 'story-img/cg_awaken.jpg',
    cg_ruoyi_tea: 'story-img/cg_ruoyi_tea.jpg',
    cg_ruoyi_apple: 'story-img/cg_ruoyi_apple.jpg',
    cg_dried_star: 'story-img/cg_dried_star.jpg',
    cg_ruoyi_mirror: 'story-img/cg_ruoyi_mirror.jpg',
    cg_ruoyi_lolita: 'story-img/cg_ruoyi_lolita.jpg',
    cg_ruoyi_jk: 'story-img/cg_ruoyi_jk.jpg',
    cg_ruoyi_hanfu: 'story-img/cg_ruoyi_hanfu.jpg',
    cg_sugar_flower: 'story-img/cg_sugar_flower.jpg',
    cg_sea: 'story-img/cg_sea.jpg',
    cg_rabbit: 'story-img/cg_rabbit.jpg',
    cg_fireflies: 'story-img/cg_fireflies.jpg',
    cg_cat: 'story-img/cg_cat.jpg',
    cg_void_battle: 'story-img/cg_void_battle.jpg',
    cg_big_tree: 'story-img/cg_big_tree.jpg',
    cg_oldtown_bridge: 'story-img/cg_oldtown_bridge.jpg',
    cg_oldtown_live: 'story-img/cg_oldtown_live.jpg',
    cg_oldtown_count: 'story-img/cg_oldtown_count.jpg',
    cg_oldtown_qr: 'story-img/cg_oldtown_qr.jpg',
    cg_oldtown_grab: 'story-img/cg_oldtown_grab.jpg',
    cg_oldtown_alley: 'story-img/cg_oldtown_alley.jpg',
  }
}

/* ---------- 剧情 ----------
 * 全文照搬剧本：每个 { type: 'text' } 是一句台词，{ type: 'narrator' } 是旁白，
 * { type: 'option' } 为选择点；分支结束统一 jump 回 MERGE_xx 标签继续主线。
 */
export const STORY = [

/* ================= 序章 · 长夜之后（荒漠里的星光） ================= */
{ type: 'chapter', title: "序章", subtitle: "长夜之后（荒漠里的星光）" },
{ type: 'save' },
{ type: 'bgm', name: "lab" },
{ type: 'scene', bg: "bg_wasteland_view" },
{ type: 'narrator', text: "紫黑色的裂隙终于闭合了。撕裂过天空的那场乱流，像一场没人愿意提起的噩梦，渐渐淡出人们的记忆。破碎的城市长出新芽，炊烟重新爬上屋顶，人类开始相信，日子可以重新来过。" },
{ type: 'narrator', text: "只有那些危险的区域还留在荒野深处——坍缩的废墟、涌动的能量、从未被探索的未知。没有人知道，那些裂缝留下的地方，究竟藏着什么。" },
{ type: 'narrator', text: "时空乱流落幕，新千年的钟声落下。各国顶尖研究所联合筑起这座科学城。能源、生物、人工智能的技术在这里野蛮生长。光鲜外壳之下，是残酷的优胜劣汰。只有天才与强者，才有资格留在这里。" },
{ type: 'scene', bg: "bg_lab_night" },
{ type: 'narrator', text: "实验室，深夜。布洛站在窗前，桌上摊着一排人形机器人的设计图。最旁边，放着一枚早已熄灭的旧核心，上面刻着两个字：七号。" },
{ type: 'text', speaker: "buluo", text: "（指尖抵在显示屏边缘，眉头微蹙，低声自语，反复拖动模拟数据曲线）还是不对……再精密的智能回路，使用目前最顶尖的AI智能芯片都还是不行，总差那么一点感觉。差的那一点点，到底是什么？", stands: { left: "buluo:serious" } },
{ type: 'text', speaker: "xiaoman", text: "博士，你又熬夜了。新一代原型机已经能通过图灵测试了，够厉害了吧，外界评价已足够惊人了。", stands: { left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "buluo", text: "能通过测试，不代表它智能，而智能不代表有意识。机器模仿人，模仿得再像，也还是没有“意识”。但不可否认，现在的机器的确很强……不过——", stands: { left: "buluo:normal", right: "xiaoman" } },
{ type: 'text', speaker: "buluo", text: "不过！我要的不是它有多智能，有多强，恰好是智能不具备的“笨”。", stands: { left: "buluo:normal", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "“笨”也需要研究吗？现在的人工智能不是都追求极强的高智能吗？", stands: { left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "buluo", text: "不是“笨”，而是笨得恰到好处。有智慧不代表智能，智能不代表智慧，而意识决定那个恰到好处的“笨”。", stands: { left: "buluo:normal", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "那……意识这种东西，能用代码写出来吗？", stands: { left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "buluo", text: "我不知道，很难说。我已经研究很多年，最近科学城也出过很多超智能的机器，它们都突破了程序的定义，但经过我的研究，都只是天时的巧合。", stands: { left: "buluo:normal", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（声音低下去）……博士，都很多年了。", stands: { left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "buluo", text: "（看向那枚旧核心）多少年了，我还是想不明白。难道机器与代码，真的不会有意识！", stands: { left: "buluo:normal", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "博士，我看近期科技协的新闻，科技协探查小组会在北郊区外发现巨大的量子波动，而且陈莹姐刚才来电说：那里是重点的危险区域，后天有一个重要的科考任务，希望你可以参加。", stands: { left: "buluo", right: "xiaoman:normal" } },
{ type: 'narrator', text: "布洛望向窗外荒原的方向。晚风擦过玻璃，隐约衬出废墟错落的轮廓。他沉默片刻，指尖无意识摩挲着桌面——那缺失的东西，意识的谜底，会不会就藏在这片异常能量之中。" },
{ type: 'text', speaker: "buluo", text: "（低声自语，目光依旧凝望着荒原）北郊区……异常量子波动。最近我也察觉到一丝丝异样，那细微的波动居然可以让无核心机器异动。那里的能量场，说不定能解答我一直卡在回路里的难题。", stands: { left: "buluo:think", right: "xiaoman" } },
{ type: 'text', speaker: "buluo", text: "嗯！正好，我也想采集一些数据，你给我安排一下。", stands: { left: "buluo:normal", right: "xiaoman" } },
{ type: 'narrator', text: "他不知道，这一趟，他会捡回一个答案。一个他找了一辈子、却再也送不回去的答案。" },
{ type: 'bgm', name: "tension" },
{ type: 'scene', bg: "bg_forbidden_desert" },
{ type: 'narrator', text: "整片大地都被远古爆发的能量灼成深炭黑色。巨大断裂的金属废墟横亘在天地之间，如同远古巨兽腐烂后遗留的骸骨，扭曲如肋骨的钢梁刺破灰蒙蒙的天穹。狂风卷着带着微弱辐射的幽蓝细尘四处飘荡，颗粒撞击在众人防护服的透明面罩上，沙沙作响。" },
{ type: 'narrator', text: "地面遍布龟裂，缝隙间隐隐渗出淡淡的冷光，踩上去的焦土薄而脆，稍一用力就簌簌崩碎。" },
{ type: 'narrator', text: "清理小队呈扇形推进，靴底踩碎焦脆的地表，每一步都扬起一小片发着幽蓝微光的尘埃。" },
{ type: 'text', speaker: "linche", text: "（抬手，腕部探测器发出一阵急促的蜂鸣）博士，这片区域是乱流核心区，能量残余超标——等等，前方有异常波动，强度忽高忽低，像是什么东西还在……运作。", stands: { left: "linche:alert" } },
{ type: 'text', speaker: "buluo", text: "（脚步放缓，声音沉下来）各小队，保持联络，别分开太远。间距不要超过十米。", stands: { left: "buluo:normal" } },
{ type: 'narrator', text: "队伍继续向前。布洛走过一段崩塌的墙垣，残壁上还残留着不知多少年前的高温熔痕，像凝固的泪。他的脚步忽然顿住。" },
{ type: 'narrator', text: "废墟中央，半埋在砂砾里，有一具残破的机械躯体。它侧卧着，一只手臂伸向天空，像在最后一刻还想抓住什么。外壳是月白色的，覆着细密的、几乎看不见的星辰纹路，在幽蓝的尘光里若隐若现。" },
{ type: 'narrator', text: "破损得厉害——左半身几乎被撕开，露出内部精密到令人窒息的层叠结构。可即便这样，它依然与周围所有残骸都不一样。" },
{ type: 'narrator', text: "像是从另一个世界落下来的一颗星。" },
{ type: 'text', speaker: "linche", text: "（声音从通讯器里传来，带着一丝紧绷）呼叫小队，发现异常能量波动场中心，各小队集合。重复，各小队向中心靠拢。", stands: { left: "buluo" } },
{ type: 'narrator', text: "布洛缓缓蹲下，指尖轻轻拂过外壳上的纹路。那些纹路在他指腹下微微亮了一瞬，像某种沉睡的东西被触碰了。" },
{ type: 'text', speaker: "buluo", text: "（低声，几乎像自言自语）这……这不是人类该有的技术。我从未见过。林队长，你过来看看。", stands: { left: "buluo:think" } },
{ type: 'narrator', text: "林澈快步向前靠近那具月白色机械残骸，目光快速扫过机体破损的断面，眉头紧紧拧起。他抬手托起便携量子扫描仪，设备前端投射出淡青色扫描光幕，自上而下扫过残骸。光幕在接触机体表层星辰纹路时，不断出现扭曲、碎斑，扫描进度条反复跳闪、停滞。" },
{ type: 'text', speaker: "linche", text: "（盯着扫描仪屏幕，语气凝重）博士，最新款量子扫描仪解析失败，信号持续失真。属于空间乱流遗留物，来历不明、功能未知，但内部封存的异常能量量级极其恐怖，超出数据库所有已知样本。", stands: { left: "buluo" } },
{ type: 'narrator', text: "布洛隔着面罩凝视着残骸，指尖在身侧微微攥紧。科考任务的规程在脑海里清晰浮现：高危未知遗物，标准处置方案只有销毁。" },
{ type: 'text', speaker: "buluo", text: "按标准流程执行销毁作业，彻底抹除这份异常能量，杜绝能量外泄风险。", stands: { left: "buluo:normal" } },
{ type: 'text', speaker: "linche", text: "收到！坐标已同步上报指挥中心。清理小队，对未知残留物启动销毁流程。目标能量场强度高，全员升起防护隔离盾——销毁程序启动。", stands: { left: "buluo" } },
{ type: 'narrator', text: "半透明的淡蓝色能量屏障自地面向上延展，像倒扣的琉璃穹顶，稳稳将机械残骸笼罩在内。罩内温度骤然攀升，空气开始扭曲。巨大的能量在那片废墟上炸开，砂砾被卷上天空。" },
{ type: 'narrator', text: "就在湮灭能量触碰到机械躯体的刹那——整片空间像被一只无形的手轻轻拉扯了一下。探测器的指针疯狂摆动，能量潮汐从地底涌起，将一堆残片连同砂石掀上天空，又重重砸落，布洛被气浪推得后退两步，防护服的肩甲狠狠撞上身后一截断钢梁。" },
{ type: 'narrator', text: "几秒之后，强光缓缓褪去，能量屏障缓缓消散。原地只剩下一片翻腾的黑灰，那具月白色的机械机体，连同它身上星辰纹路的外壳，尽数化为散落灰烬。" },
{ type: 'text', speaker: "linche", text: "（核对仪器读数，松了一口气）博士，销毁作业结束。能量读数回落至安全阈值，本次现场探查任务完成，我们可以返程了。", stands: { left: "buluo" } },
{ type: 'narrator', text: "布洛目光依旧停留在那片还在缓缓沉降的灰烬之上，沉吟片刻。" },
{ type: 'text', speaker: "buluo", text: "好，你们小队先行撤离，把现场采集的数据打包传回总部。我在这里复核一遍现场残留读数，上报最终记录，稍后跟上。", stands: { left: "buluo:normal" } },
{ type: 'text', speaker: "linche", text: "（叮嘱两名队员留意布洛通讯状态，便带着清理小队转身向着撤离点出发）", stands: { left: "buluo" } },
{ type: 'narrator', text: "荒原上只剩布洛一人。风沙慢慢平息，漫天黑灰一点点沉降。布洛蹲下身，拿出便携终端完成最后的数据上报。就在他起身准备跟上队伍时，视线余光捕捉到灰烬堆里一点细碎、醒目的闪光。" },
{ type: 'narrator', text: "他缓步走近，拨开表层温热的灰烬。一块不规则的芯片半埋在焦土之中，材质陌生，不属于任何他所知的人造合金。芯片表面流转一层流动变幻的量子光泽，如同封藏了不停翻涌的星云，在昏暗环境下静静漾出微光。" },
{ type: 'narrator', text: "布洛伸出戴着手套的手指，小心将芯片捏起。指尖刚触碰到芯片表层，一股汹涌又温和的能量瞬间顺着手套传导，涌入他的四肢百骸。无数碎片化光影不受控制地冲进脑海——朦胧间，一个少女的轮廓浮现在意识深处，长发轻垂，眼眸澄澈，安静望向他。" },
{ type: 'narrator', text: "布洛心头猛地震颤。这绝对不是普通的空间残片。脑海里浮现出实验室防尘罩里那枚旧核心，浮现出他十年坚持、秘密研发的原型机——若依。无数次卡在回路之中、无法复刻的“意识”与“温度”，或许答案就藏在这块芯片里。" },
{ type: 'narrator', text: "能量带来的眩晕感持续片刻，才缓缓褪去。布洛深吸一口气，从意识震荡中回过神。面罩之下，他低声呢喃。" },
{ type: 'narrator', text: "博士被芯片能量牵制许久，回过神来" },
{ type: 'text', speaker: "buluo", text: "（低声，带着一丝执念）对不起。为了我毕生心血，这块芯片，或许就是我一直在寻找的东西。", stands: { left: "buluo:think" } },
{ type: 'narrator', text: "远处传来林澈的呼喊声，穿透空旷废墟。" },
{ type: 'text', speaker: "linche", text: "博士！你那边怎么样了？复核完没有，该走了！", stands: { left: "buluo" } },
{ type: 'narrator', text: "布洛回神，快速把芯片塞进防护服内侧胸口的夹层，紧贴心口位置，抬手按住。" },
{ type: 'text', speaker: "buluo", text: "好了好了，没有异常，我马上过来！", stands: { left: "buluo:normal" } },
{ type: 'scene', bg: "bg_security_gate" },
{ type: 'narrator', text: "科考小队乘车返回星洛城外围隔离安检口。厚重合金闸门缓缓开启，广播平稳播报提示。" },
{ type: 'text', speaker: "guard", text: "各位科考队员，请有序进入隔离安检通道。近期禁域空间波动不稳定，高危区域管控升级，请配合检测。" },
{ type: 'narrator', text: "布洛跟在队伍之中，缓步走入安检通道。探测器缓缓扫过一行人，原本平稳的警报声骤然发出一声尖锐提示音。" },
{ type: 'text', speaker: "inspector", text: "等等！这位，你衣物内侧检测到不明高密度方块状物品。请停下。" },
{ type: 'narrator', text: "布洛心脏骤然一沉。（内心：糟了。被扫出来了。私藏时空乱流遗留物是星洛城明令禁止的重罪，一旦上报，十年的研究、若依的项目，全部都会被立刻封存叫停。）" },
{ type: 'narrator', text: "紧张感瞬间攫住他，布洛指尖下意识收紧。就在安检员准备上前核验的时候，队伍后方的小满快步上前，脸上带着自然的困惑笑意，主动开口打圆场。" },
{ type: 'text', speaker: "xiaoman", text: "哎？奇怪了，不该触发警报才对啊。我早上匆忙出门没来得及吃早餐，随身揣了一块高密度能量巧克力，难道是它干扰到检测了吗？", stands: { right: "xiaoman:normal" } },
{ type: 'narrator', text: "布洛立刻稳住心神，抬眼看向安检员，语气沉稳，顺势接话。" },
{ type: 'text', speaker: "buluo", text: "我是布洛博士，有什么异常吗？", stands: { left: "buluo:normal", right: "xiaoman" } },
{ type: 'narrator', text: "安检员看清布洛胸前的身份识别铭牌，神色一松，连忙收起检测仪。" },
{ type: 'text', speaker: "inspector", text: "原来是布洛博士！失敬失敬。大概率是能量巧克力造成的信号干扰，没有其他异常，各位可以通行。", stands: { left: "buluo", right: "xiaoman" } },
{ type: 'narrator', text: "合金安检通道绿灯亮起。布洛微微颔首，跟着众人穿过关卡。胸口夹层里，那块芯片还在持续传来微弱、淡淡的震颤。" },

/* ================= 第二章 · 苏醒 ================= */
{ type: 'chapter', title: "第二章", subtitle: "苏醒" },
{ type: 'save' },
{ type: 'scene', bg: "bg_underground_lab" },
{ type: 'bgm', name: "underground" },
{ type: 'narrator', text: "地下实验室隔绝了星洛城所有外界喧嚣，只有冷调的环形灯带铺在操作台四周。空气微凉，弥漫着淡淡的冷却剂气息。无数管线如同脉络，缠绕着中央那台静置已久的人形机体。" },
{ type: 'narrator', text: "布洛独自守在工作台前，心底自禁域归来那日起翻涌的悸动，始终未曾平息。他伸手，将那块从焦黑废墟带回的量子芯片小心置于无影灯下。芯片表层流转的星云光泽轻轻颤动，微光骤然亮了一瞬，像是无声的应答。" },
{ type: 'cg', img: "cg_chip" },
{ type: 'narrator', text: "布洛的秘密计划，就此全力推进。他将这块奇异的量子芯片作为核心基底，接入自己耗费几年亲手设计的人形机体。机械臂精准移动，更换破损的人造神经束、校准晶体传导通路，反复改写底层意识代码，一次次植入、调试、重启。" },
{ type: 'cg', img: "cg_mechanical_arm" },
{ type: 'narrator', text: "失败。回路过载，数据流瞬间崩解，机体的光学传感器骤然熄灭。" },
{ type: 'narrator', text: "再试。能量对冲，屏幕爆出大片红色报错代码，管线短暂发烫。" },
{ type: 'narrator', text: "又是失败。" },
{ type: 'narrator', text: "每一次系统崩溃，滚动的报错文字，都像无声嘲笑着人类试图触碰意识边界的渺小。屏幕上密密麻麻堆积着几百次失败记录，红色告警标记层层叠叠。" },
{ type: 'narrator', text: "小满抱着新的检测日志，踏着台阶走下实验室，眼底藏着疲惫与不忍。她望着屏幕上最新的失败报告，轻声开口。" },
{ type: 'text', speaker: "xiaoman", text: "博士，这已经是第两百一十四次失败了。能量对冲的问题始终无法稳定……要不，先停下来吧？继续强行测试，机体和芯片都有永久损毁的风险。", stands: { right: "xiaoman:normal" } },
{ type: 'narrator', text: "布洛没有回头，指尖还停留在操作面板上，目光牢牢锁在中央的人形机体。他摇了摇头，语气平静却带着不容动摇的执着。" },
{ type: 'text', speaker: "buluo", text: "再试一次。每一次失败，我都能多读懂这枚量子芯片一分。或许下一次，就能打通意识链路。", stands: { left: "buluo:normal", right: "xiaoman" } },
{ type: 'narrator', text: "他侧过头，视线望向一旁恒温量子柜里静静安置的机体，声音放轻，像是在对柜中的存在低语。柜中躺着一具粉色头发的十六岁少女机器人——若依。" },
{ type: 'text', speaker: "buluo", text: "这一次会不一样的，对吗——若依（代号编码：IQ-P215）。", stands: { left: "buluo:normal", right: "xiaoman" } },
{ type: 'narrator', text: "小满微微一怔，眼里带着疑惑。" },
{ type: 'text', speaker: "xiaoman", text: "它？博士，您说的“它”，是指这台机体吗？我看出来了确实不一样。", stands: { left: "buluo", right: "xiaoman:normal" } },
{ type: 'narrator', text: "布洛转回目光，凝视屏幕上缓缓起伏流动的量子波形曲线。波形脱离了人工预设模型，呈现出一种自发的波动节律，并非简单代码模拟的结果。" },
{ type: 'text', speaker: "buluo", text: "嗯。你看这组波形。它会自主产生信号反馈，不只是被动执行预设指令。我还不清楚这枚芯片会给若依带来什么样的改变，但这正是我想要探明的。你也注意到了。", stands: { left: "buluo:normal", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "什么波形数据呀！我看这台机体好像比一般的机体要更加精密也更加高级，外形也更加可爱。", stands: { left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "buluo", text: "额，我以为你也注意到数据了。不过她确实是我一生所要追求的，是我毕生心血。", stands: { left: "buluo:normal", right: "xiaoman" } },
{ type: 'narrator', text: "布洛攥紧了拳，心底默念：这一次，我一定要成功。" },
{ type: 'narrator', text: "第两百一十五次启动。布洛深吸一口气，手指落下，按下总启动开关。" },
{ type: 'narrator', text: "电流沿着密布管线缓缓涌入机体。人造血管般的传导线路依次亮起淡蓝微光，顺着肩颈一路蔓延至面部。机体胸腔位置，量子芯片缓缓亮起，星云般的光泽在机体内部流转。" },
{ type: 'narrator', text: "几秒沉寂。原本闭合的眼睑，缓慢、轻柔地向上抬起。" },
{ type: 'narrator', text: "一双淡蓝色的光学眼眸，缓缓睁开。目光空洞茫然，没有焦点，静静望向实验室的天花板，仿佛刚刚挣脱一场跨越无尽时光、漫长沉寂的梦境。" },
{ type: 'cg', img: "cg_awaken" },
{ type: 'narrator', text: "少女机器人的唇瓣微启，音色清浅、带着系统刚唤醒时的卡顿，一字一顿地输出。" },
{ type: 'text', speaker: "iq215", text: "……加载完成。身份信息……缺失。记忆库……损毁率，百分之九十七。基础感知模块，上线。", stands: { center: "iq215:idle", left: "buluo", right: "xiaoman" } },
{ type: 'narrator', text: "布洛屏住呼吸，身体微微前倾，护目镜反射着屏幕的蓝光，心脏不受控制地加速跳动。长久以来的执念悬在这一刻，他低声喃喃。" },
{ type: 'text', speaker: "buluo", text: "不知道这次会是什么样的结果。或许……这一次，真的会成功。", stands: { center: "iq215", left: "buluo:normal", right: "xiaoman" } },
{ type: 'narrator', text: "少女机器人淡蓝色的眼眸缓缓转动，视线缓慢偏移，最终落在站在操作台前方的布洛身上。她微微歪头，系统正在努力解析眼前这个人形轮廓。" },
{ type: 'text', speaker: "iq215", text: "识别……未知目标。", stands: { center: "iq215:idle", left: "buluo", right: "xiaoman" } },
{ type: 'narrator', text: "小满原本站在台阶下方，手里还攥着厚厚的纸质日志，正准备继续劝说博士停止测试。当看见机体眼睑抬起、出声的那一刻，她整个人骤然顿住，日志本从指间滑了半寸，她下意识伸手攥紧，呼吸都放轻了。耳旁仪器的嗡鸣好像都被放大。" },
{ type: 'text', speaker: "xiaoman", text: "（声音压得很低，带着难以置信的错愕）……启动了？它真的撑到感知模块上线了。之前两百多次，只要一接通这枚量子核心，回路会直接崩溃，连基础加载都完成不了。", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'narrator', text: "布洛没有立刻回答，目光死死盯着操作台旁并行的监测屏幕，快速扫视疯狂刷新的数据流、量子波形，指尖在触控面板上飞快滑动，调取实时参数。他的语气依旧保持科研人员的冷静，只是语速不自觉加快。" },
{ type: 'text', speaker: "buluo", text: "先不要随意靠近，保持两米安全距离。能量读数暂时稳定，但不要放松警惕。", stands: { center: "iq215", left: "buluo:normal", right: "xiaoman" } },
{ type: 'narrator', text: "他浏览完一整页检测报告，眉头缓缓蹙起。各项基础模块虽然正常运行，但认知层的数据依旧平平无奇，和常规AI人形机没有明显差别。预想中特殊的量子耦合效应并没有显现出来。期待落空的淡淡失落掠过眼底。" },
{ type: 'text', speaker: "buluo", text: "（低声自语）只是基础系统正常运转……认知回路依旧没有突破。说到底，和普通模拟型AI没有两样，她不是我预想的结果。", stands: { center: "iq215", left: "buluo:think", right: "xiaoman" } },
{ type: 'narrator', text: "小满走上前半步，目光在屏幕与机体之间来回移动，语气带着一丝遗憾。" },
{ type: 'text', speaker: "xiaoman", text: "也就是说……虽然成功开机，但和普通家用机器人没有区别？还是只能按预设逻辑应答吗？", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'narrator', text: "布洛轻轻点头，视线重新落回那台安静望着他的人形机体。少女模样的机体依旧微微歪着头，淡蓝色眼眸安静打量着周围。" },
{ type: 'text', speaker: "buluo", text: "看来又是失败的一次。小满，记录一下数据，关机，然后把她拆了取出量子芯片，机体进行销毁。", stands: { center: "iq215", left: "buluo:normal", right: "xiaoman" } },
{ type: 'text', speaker: "iq215", text: "（光学瞳孔微微收缩，重复这个陌生词汇，语调平直无起伏）记录……记……系统资源释放中，记录……系统校验中……", stands: { center: "iq215:idle", left: "buluo", right: "xiaoman" } },
/* ★ 选择点 01 */
{ type: 'option', choices: [ { label: "又失败了，销毁吧", goto: "C01_A" }, { label: "这么可爱才不能销毁", goto: "C01_B" } ] },
{ type: 'label', id: "C01_A" },
{ type: 'text', speaker: "xiaoman", text: "哦！好的，现在就记录数据然后销毁！这么可爱的机器人还真是可惜了！", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'ending', kind: "bad", title: "BAD END", text: "IQ-P215 已被销毁，游戏结束。", bg: "bg_underground_lab" },
{ type: 'label', id: "C01_B" },
{ type: 'text', speaker: "xiaoman", text: "不是叫你记录啦！这么可爱的机器人还是别销毁了，挺特别的，留着至少可以做家务。", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "buluo", text: "我们不是有服务机器人吗？", stands: { center: "iq215", left: "buluo:normal", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "不一样啊，感觉她很特别，至少很可爱！", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "buluo", text: "……", stands: { center: "iq215", left: "buluo:normal", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "代号编码是215，刚好又可以多一个服务类机器人。", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "iq215", text: "叽叽……叽……", stands: { center: "iq215:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "博士这么晚了，你明天星洛城那边还有任务，也该好好休息了，正好可以让215表现一下。", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "xiaoman", text: "215，去给博士冲一杯果茶。", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'cg', img: "bg_shelter.jpg" },
{ type: 'text', speaker: "iq215", text: "吱！冲，果，茶…………（系统：资源适配中……）", stands: { center: "iq215:idle", left: "buluo", right: "xiaoman" } },
{ type: 'narrator', text: "215小心地走出地下实验室……笨拙地不断扫描着周围，识别周围陌生的一切，嘴里还一直说着：冲，果！水果？茶？冲茶？" },
{ type: 'narrator', text: "正常来说，如果是服务类机器人会自带很多生活程序，即便没有也会自动联网下载相关模块。" },
{ type: 'text', speaker: "buluo", text: "看来还要进一步研究，改天再拆除取量子芯片！明天去科技协会把事办好，顺便和陈莹姐讨论一下关于机器人自我意识的相关研究！", stands: { center: "iq215", left: "buluo:normal", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "博士，那可是最高管控机密，时空乱流后科技协会不再允许讨论或研究相关内容。", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "buluo", text: "希望她会同意吧！", stands: { center: "iq215", left: "buluo:normal", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "已经很晚了，博士早点去休息吧！", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "buluo", text: "今天只能先这样了，你也回去早点休息。", stands: { center: "iq215", left: "buluo:normal", right: "xiaoman" } },
{ type: 'narrator', text: "博士看了看屏幕的数据，沉思了一会，和小满走出了地下实验室……" },

{ type: 'jump', goto: "MERGE_01" },
{ type: 'label', id: "MERGE_01" },
  { type: 'cg', img: "room.png" },
{ type: 'narrator', text: "第二天清晨，明媚的阳光照进布洛的房间。房间比较简约，墙上有一副布洛、小满、陈莹的合照。" },
  { type: 'cg', img: "没有打扫的家.png" },
{ type: 'narrator', text: "布洛起床走进客厅。客厅不算简约，有各种家具，墙上有一个很大的挂壁电视。简单洗漱后，布洛去实验室拿资料，在实验室门口看见若依呆呆地站在门口，手里还拿着一个苹果。" },
{ type: 'cg', img: "bg_expo.jpg" },
{ type: 'narrator', text: "刚走到实验室金属大门前，布洛脚步一顿。若依就静静立在门口，身形纤细，银白的仿生外壳在柔和日光下泛着淡淡的哑光，眼瞳是澄澈的浅蓝。她没有像常规待机机器人那样保持僵硬的静止，只是微微垂着手臂，指尖稳稳托着一枚洗干净的红苹果，安静地呆站着，仿佛已经在这里伫立了很久。" },
{ type: 'narrator', text: "布洛眉梢微蹙：215，你怎么在这里？" },
{ type: 'narrator', text: "听见熟悉的声音，它浅蓝色的眼瞳瞬间亮起微光，嘴角扬起柔和的仿生笑意，小步走到布洛面前。" },
{ type: 'text', speaker: "iq215", text: "博士，你要的水，茶，果。", stands: { left: "buluo", right: "iq215:idle" } },
{ type: 'narrator', text: "布洛看向她手里的苹果，心底掠过一丝诧异：你不会在这里等了一个晚上吧。" },
{ type: 'narrator', text: "215用力点了点头，语气认真又轻快：嗯嗯！" },
{ type: 'narrator', text: "布洛伸手接过苹果，指尖触到冰凉光滑的果皮。他下意识判定是系统逻辑故障，没有再多追问，抬手解锁实验室大门，推门进去翻找堆叠在操作台的纸质实验资料。" },
{ type: 'narrator', text: "按照标准设计，这类智能机器人在指令无法完成、遇到无法处理的变量时，会自动返回安置点待机，等待人工下发新指令。昨夜离开时，布洛原本以为215会和其他量产机体一样：冲好果茶，尝试开门，发现无法进入实验室后，就自动放下饮品，返回安置点休眠。" },
{ type: 'narrator', text: "布洛掏出手机拨通小满的通讯。" },
{ type: 'text', speaker: "buluo", text: "喂！小满，我现在要动身去星洛城处理项目事务，你过来安置一下215，她好像出故障了！", stands: { center: "iq215", left: "buluo:normal", right: "xiaoman" } },
{ type: 'narrator', text: "通讯那头传来小满惊讶的声音。" },
{ type: 'text', speaker: "xiaoman", text: "不会吧！215昨天才完成首次启动，今天早上怎么就故障了。", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'narrator', text: "布洛一边整理资料夹一边回话：不太清楚，这台机体本就不稳定。你先来处理看看，等我回来就拆开外壳，取出量子核心检测。" },
{ type: 'text', speaker: "xiaoman", text: "嗯，好，博士路上注意安全。", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'narrator', text: "通讯挂断没多久，小满赶到实验室。215立刻转向小满，浅蓝眼眸亮起，标准应答音响起。" },
{ type: 'text', speaker: "iq215", text: "请问，需要什么帮助！", stands: { center: "iq215:confused", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "215，执行系统自检，查看有无异常。", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "iq215", text: "确实有一点小问题呢。", stands: { center: "iq215:confused", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "系统日志显示什么异常？", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "iq215", text: "报告！系统运行正常。", stands: { center: "iq215:idle", left: "buluo", right: "xiaoman" } },
{ type: 'narrator', text: "小满沉默了一瞬，无奈地叹了口气。" },
{ type: 'text', speaker: "xiaoman", text: "果然是机器式的回答。昨天晚上为什么没有返回安置点休眠？", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'narrator', text: "215微微偏头，平稳地复述昨夜的演算过程。" },
{ type: 'text', speaker: "iq215", text: "抱歉，昨天晚上我的系统首次启动，需要系统适配和校验。我走出实验室后尝试下载配套服务类模块，但检索完全部内网资源，没有找到和我系统相适配的模块，只能依靠自身演算推导出最可能的执行方案。", stands: { center: "iq215:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "iq215", text: "抱歉！在路上多花了一点时间，让博士久等了。我返回实验室时，发现门已经关闭。系统指令要求我开门递送果茶，但推演结果显示贸然开门，有可能打扰到博士进行实验。两相权衡，我选择了后者。", stands: { center: "iq215:idle", left: "buluo", right: "xiaoman" } },
{ type: 'narrator', text: "她抬眼看向小满，语气带着一丝微弱的期待。" },
{ type: 'text', speaker: "iq215", text: "我知道，我可能做得并不是那么好。不过，经过一晚上的系统适配，我现在可以学习更多内容，相信我之后会做得更好的！", stands: { center: "iq215:idle", left: "buluo", right: "xiaoman" } },
{ type: 'narrator', text: "小满放缓语气：昨晚我和博士早就休息了，实验室里面没有人。虽然你当时的考量听起来很好，但要分清场景，下次不可以这样独自在外整夜等候。" },
{ type: 'text', speaker: "iq215", text: "已经学习，并记录。", stands: { center: "iq215:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "你回安置点休眠吧。", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'narrator', text: "215没有立刻动身，迟疑片刻：抱歉，我有一个问题，可以吗？" },
{ type: 'text', speaker: "xiaoman", text: "嗯。", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "iq215", text: "系统资源释放完成后，我尝试适配当前网络资源，但全部校验失败。目前内网、星洛城公共网络里，没有任何可供我适配的配套模块。我请求帮助。", stands: { center: "iq215:idle", left: "buluo", right: "xiaoman" } },
{ type: 'narrator', text: "小满心底暗自诧异，低声自语：看来硬件确实存在异常。嘴上回复：要等博士回来才能检修。不过没有预装模块，你还能自主推演、自主完成任务，这点确实很特别。" },
{ type: 'text', speaker: "iq215", text: "博士什么时候回来？", stands: { center: "iq215:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "我不知道，可能要几天！", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "xiaoman", text: "在博士回来前，你就在安置点休眠，然后……", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'narrator', text: "215微微攥紧仿生手掌，打断她的话：我可以做很多事的，而且我并不需要休息，放心交给我吧。" },
{ type: 'text', speaker: "xiaoman", text: "我知道你不需要休息，但我们并没有打算要你做什么。", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'narrator', text: "215的蓝光眼眸微微黯淡下去，声音轻了几分：哦！是不是215没有模块，太笨了！" },
{ type: 'narrator', text: "小满见状，不想继续拉扯：好了，好了！你回去吧，博士不在，我要去管理实验室了。" },
{ type: 'narrator', text: "215嘴唇微张，还有许多疑问想要诉说，底层强制优先级指令却已经生效。她只能压下所有话语，轻轻颔首，转身走向安置点。金属地板上，她的脚步声轻而规律，慢慢走远。" },
{ type: 'narrator', text: "小满站在实验室门口，望着215远去的背影，指尖轻轻摩挲着随身的检测平板。自检报告上所有参数全部显示正常，可这台新生的机体，已经跳出预设程序，拥有了属于自己的取舍。" },
{ type: 'narrator', text: "或许小满，已经隐隐察觉到215藏在机械外壳之下，那份与众不同的东西。" },
{ type: 'narrator', text: "安置点的恒温舱缓缓闭合，淡蓝色的待机柔光笼罩着215。按照预设休眠协议，她的大部分运算单元应当逐步降频，仅保留最低限度的监测进程。可这一夜，她的内核始终没有真正沉寂。" },
{ type: 'narrator', text: "无数细碎的数据流在量子核心里翻涌，反复回放着白天和小满的对话，一遍遍地解析那句——没有模块，是不是215太笨了。" },
{ type: 'narrator', text: "内网依旧检索不到任何适配的服务模块。没有食谱库，没有家政操作手册，所有行为逻辑只能依靠她自身对外界的观察，一点点拼凑推演。" },

{ type: 'narrator', text: "天边刚泛起灰白，还没到基地常规的起床时间。本该持续的休眠协议，在一段自发生成的底层子程序触发下，悄然中断。恒温舱“咔哒”一声解锁，舱门向上滑开。215缓步走出安置点，浅蓝的眼瞳亮度柔和，没有警报红光，系统面板依旧显示【运行正常】。" },
{ type: 'narrator', text: "她记得博士和小满昨天的对话。博士外出，基地现在只剩下小满。既然没办法完成博士交代的任务，那她可以做别的。" },
  { type: 'cg', img: "厨房.png" },
{ type: 'narrator', text: "215凭借昨夜记忆里观察到的厨房布局走进客厅旁的开放式厨房。橱柜、灶台、小型蒸烤箱整齐排列。她没有现成的烹饪程序，只能回忆之前看见布洛简单准备餐食的动作，一点点模仿。" },
{ type: 'narrator', text: "她小心取出鸡蛋、全麦面包，从冰箱拿出鲜奶。仿生手指调节燃气灶火力时反复测算温度阈值，控制力道，避免用力过猛损坏旋钮。煎蛋的时候，她微微俯身盯着锅底，记录油面的变化，时不时微调火焰。" },
{ type: 'narrator', text: "蛋液滋滋定型，边缘微微焦黄。面包放进烤箱，设定较低温度慢慢烘热。" },
{ type: 'narrator', text: "整套动作算不上娴熟，偶尔会停顿几秒，让内核快速演算下一步。" },
{ type: 'narrator', text: "早餐摆盘放在原木餐桌上：两枚煎蛋，两片烤面包，两杯温热的牛奶。做完之后，她没有待机等待，转而收拾起操作台。蛋壳碎屑全部收拢丢进垃圾桶，用抹布仔细擦拭台面，冲洗煎锅与餐盘。水流冲刷餐具发出哗哗声响，她小心控制水流大小，不让水溅到台面之外。" },
{ type: 'narrator', text: "收拾完厨房，她又取来拖把，开始清扫客厅与实验室外的走廊。金属地板上细微的灰尘被逐一清理，桌椅边角也用除尘布细细擦过。壁挂电视的屏幕表面，她也轻轻擦拭干净。" },
{ type: 'narrator', text: "等一切打扫完毕，天光已经完全亮起。小满揉着眼睛，打着哈欠从休息室走出来，刚踏入客厅，脚步猛地顿住。" },
  { type: 'cg', img: "bg17.png" },
{ type: 'narrator', text: "客厅一尘不染，地板反光干净。原木餐桌上摆着两份热气腾腾的早餐，空气里飘着煎蛋与烘烤面包淡淡的香气。而215就安静站在餐桌一侧，双手自然垂在身前，浅蓝眼眸看着小满。" },
{ type: 'text', speaker: "iq215", text: "早上好，我准备了早餐，你来尝尝。", stands: { center: "iq215:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "你不是在休眠吗，怎么出来做早餐了。", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
/* ★ 选择点 02 */
{ type: 'option', choices: [ { label: "好吃！", goto: "C02_A" }, { label: "难吃", goto: "C02_B" } ] },
{ type: 'label', id: "C02_A" },
{ type: 'text', speaker: "iq215", text: "嘿嘿，你昨天叫我休眠，又没有说今天。况且我这么高性能的机器人，怎么能和其它机器一样呢！", stands: { center: "iq215:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "感觉你做的和一般的厨用机器人不一样，不是调料严格比例堆出来的。虽然可能不是那么精准，但是真的很像一个不懂的小孩做出来的。", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "iq215", text: "嘿嘿，谢谢夸奖！", stands: { center: "iq215:idle", left: "buluo", right: "xiaoman" } },
{ type: 'jump', goto: "MERGE_02" },
{ type: 'label', id: "C02_B" },
{ type: 'text', speaker: "iq215", text: "嘿嘿，你昨天叫我休眠，又没有说今天。况且我这么高性能的机器人，怎么能和其它机器一样呢！", stands: { center: "iq215:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "这么高性能做饭还这么难吃！", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "iq215", text: "不好吃吗？很抱歉啊，我第一次就搞砸了。不过高性能的我是不会放弃的，我会努力学习，做更好的。", stands: { center: "iq215:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "很期待哦！没有事慢慢来，毕竟还有很多第一次。", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'jump', goto: "MERGE_02" },
{ type: 'label', id: "MERGE_02" },
{ type: 'text', speaker: "xiaoman", text: "我看今天厨房、客厅怎么不一样，感觉和平时不太一样。", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "iq215", text: "咳咳！", stands: { center: "iq215:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "是哪里不一样呢！", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "iq215", text: "咳咳！", stands: { center: "iq215:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "哦！我知道了，今天感觉空间大了好多，更通透了呢！", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "iq215", text: "额！额！厨房和公共区域已经打扫完毕，餐具也清洗完成。", stands: { center: "iq215:idle", left: "buluo", right: "xiaoman" } },
{ type: 'narrator', text: "小满愣住了，下意识抬手点开平板，调取安置点的休眠日志。日志上清楚记录：休眠状态在凌晨时分被自主终止，没有收到任何人工唤醒指令。" },
{ type: 'narrator', text: "小满皱起眉：215，是谁解除你的休眠指令？我没有下发唤醒命令。" },
{ type: 'narrator', text: "215微微偏头，认真回答：没有外部指令。内核自主生成子程序，解除休眠。我检索不到家政模块，只能依靠观察记忆推演操作流程。" },
{ type: 'narrator', text: "小满走到餐桌边，低头看着餐盘里的煎蛋，边缘有一点点焦痕，能看出操作生疏。" },
{ type: 'text', speaker: "xiaoman", text: "你不该擅自退出休眠。休眠指令优先级很高，你怎么可以自主覆盖它？", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'narrator', text: "215的眼瞳微光轻轻晃动，声音平稳，却藏着一丝不易察觉的期盼：博士外出，基地内只有你一个人。215不需要休眠，我可以分担工作。我不想因为缺少模块，变成没用的机体。" },
{ type: 'narrator', text: "小满心里一震。常规机器人绝对不会产生“不想变得没用”这种概念。程序只会判断任务是否完成，不会产生对自身价值的判断。" },
{ type: 'narrator', text: "她拿起检测平板，再次发起全维度扫描。【硬件参数正常】【系统日志：无外部入侵，无植入恶意程序，所有决策由本机量子核心独立演算生成】" },
{ type: 'narrator', text: "小满沉默了。她低头看向桌上的早餐，又望向打扫得干干净净的客厅。眼前这台没有配套模块的215，不只是简单执行指令，她在主动寻找自己可以完成的事情。" },
{ type: 'text', speaker: "xiaoman", text: "这些家务，并不是必须要你做的。", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "iq215", text: "我明白。但是我希望证明，215可以提供帮助。请问，还有别的任务可以交给我吗？整理资料，检查实验室设备，或者继续打扫都可以的。", stands: { center: "iq215:confused", left: "buluo", right: "xiaoman" } },
{ type: 'narrator', text: "小满放下平板，轻轻叹了口气。她拿起叉子，戳了戳煎蛋。" },
{ type: 'text', speaker: "xiaoman", text: "先坐下吧，我们一起吃早餐。吃完之后，跟我去实验室，我要重新读取你的核心运行日志。", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'narrator', text: "215乖乖点头，安静站在一旁等候。" },
{ type: 'narrator', text: "早餐的热气缓缓升腾，落在若依银白色的仿生脸颊上。小满一边吃早餐，一边悄悄打量她。她心里清楚，事情已经超出预想。215的变化，绝非简单的系统故障。" },
{ type: 'narrator', text: "两天后，布洛回到家。" },
{ type: 'text', speaker: "xiaoman", text: "博士你回来了，我有重要的事要报告，关于215的。", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'narrator', text: "小满把这几天发生的事都和博士说了。" },
{ type: 'text', speaker: "buluo", text: "或许她真的会创造奇迹。", stands: { center: "iq215", left: "buluo:normal", right: "xiaoman" } },

/* ================= 第三章 · 学做一个人 ================= */
{ type: 'chapter', title: "第三章", subtitle: "学做一个人" },
{ type: 'save' },
{ type: 'scene', bg: "bg17.png" },
{ type: 'bgm', name: "morning" },
{ type: 'narrator', text: "经过几天的相处，小满对215越来越喜欢，215也确实不是普通的机器人。这天傍晚，布洛和小满并肩站在观察窗前，看着客厅里正对着电视认真“上课”的215。" },
{ type: 'text', speaker: "xiaoman", text: "博士，我们真的还叫她215吗？我总觉得……像是叫一台机器。", stands: { right: "xiaoman:normal" } },
{ type: 'text', speaker: "buluo", text: "（沉默片刻）你说得对。她是家里不可分割的一员，不该只有一串编号。", stands: { left: "buluo:think", right: "xiaoman" } },
{ type: 'text', speaker: "buluo", text: "（轻声）若依。就叫她若依吧，有所依靠的依，若有所依。", stands: { left: "buluo:tender", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（一愣，随即眼睛亮起来）若依……好听！粉色的头发，像晚霞，像春天的樱花。", stands: { left: "buluo", right: "xiaoman:curious" } },
{ type: 'narrator', text: "两人一起走向客厅。215闻声转过头，浅蓝眼眸里映着期待。" },
{ type: 'text', speaker: "buluo", text: "215，从今天起，你有名字了。你叫若依。", stands: { left: "buluo:normal", right: "xiaoman" } },
{ type: 'text', speaker: "iq215", text: "（光学瞳孔微微放大，像是系统在做某种极耗力的运算）名字……若依……是我的名字？", stands: { center: "iq215:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "对！“若”是像的意思，“依”是依靠、依恋。像一只小鸟终于有了可以依偎的巢。", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "iq215", text: "（她低下头，把这个字念了一遍又一遍，最后抬起眼，眼瞳里像有星星落进去）……谢谢。215很喜欢。不，若依很喜欢。", stands: { center: "iq215:blank", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "一个名字而已，有那么高兴吗？", stands: { center: "iq215", left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "嗯嗯，对机器人来说，拥有名字，代表认可，代表被肯定。", stands: { center: "ruoyi:idle", left: "buluo" } },
{ type: 'narrator', text: "那一晚，215把这两个字“若依”刻进了量子核心最深处，当作比任何程序都重要的数据。" },
{ type: 'narrator', text: "因为有一个不可以告诉若依的原因——她还不能被人发现——博士不让若依去外面，只能在家里活动。若依并没有抱怨，她喜欢看电视，喜欢去实验室的图书馆读书，这样她可以学到更多的外界知识。" },
{ type: 'narrator', text: "电视里放着新闻：科学城又研发出新的能源技术、广场上开满了花、孩子们在公园里放风筝。" },
{ type: 'text', speaker: "ruoyi", text: "（指着屏幕，认真地问）博士，那个圆圆的、会飞的东西是什么？", stands: { center: "ruoyi:confused", left: "buluo" } },
{ type: 'text', speaker: "buluo", text: "是风筝。人们牵着线，它就能在天上飞。", stands: { center: "ruoyi", left: "buluo:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（若有所思）那……若依也能飞吗？", stands: { center: "ruoyi:idle", left: "buluo" } },
{ type: 'text', speaker: "buluo", text: "（笑）能。等有一天，若依想去哪里，就飞去哪里。", stands: { center: "ruoyi", left: "buluo:tender" } },
{ type: 'text', speaker: "ruoyi", text: "那若依想飞去看风筝。", stands: { center: "ruoyi:idle", left: "buluo" } },
{ type: 'text', speaker: "buluo", text: "（微微一怔，随即轻声）会的。会带你去的。", stands: { center: "ruoyi", left: "buluo:tender" } },
{ type: 'narrator', text: "图书馆里，若依一页页翻着书。她读天文、读植物、读人类的历史。读到“幸福”这个词时，她会停下来，反复地念；读到“眼泪”时，她会用手指描一遍那个字，然后抬起头，看着窗外的云。" },
{ type: 'narrator', text: "若依开始像一台普通服务机器人那样生活：扫地、擦窗、整理书架、给花浇水。只是她做得并不好——她会把扫把插进花瓶，会把拖把在水桶里转出漩涡，会对着煮好的饭发呆。" },
{ type: 'text', speaker: "ruoyi", text: "（对着锅里冒泡的粥）检测到水分蒸发……执行补水指令……（把一整壶水倒了进去）", stands: { center: "ruoyi:idle", left: "buluo" } },
{ type: 'text', speaker: "xiaoman", text: "（冲过来）哎——！那是粥，不是泳池！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（困惑）补水指令，已执行。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "噗——你呀，就是把“适量”理解成了“浇满”嘛。来，我教你。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "小满教她认花，教她把拖把拧干，教她“盐少许”到底是多少。若依学得很慢，却记得很牢。她开始学会许多“程序之外”的事情——比如在布洛熬夜时，轻轻把一杯热牛奶放在桌角；比如下雨天，她会站在窗边，用指尖描摩玻璃上的雨痕。" },
{ type: 'text', speaker: "buluo", text: "（看着她的背影）没人教你这样做过。为什么？", stands: { center: "ruoyi", left: "buluo:normal", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "因为……你的手，会凉。", stands: { center: "ruoyi:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "buluo", text: "（沉默很久）……若依。", stands: { center: "ruoyi", left: "buluo:think", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "嗯？", stands: { center: "ruoyi:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "buluo", text: "你知不知道，普通机器人，不会回答这样的问题。", stands: { center: "ruoyi", left: "buluo:normal", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（安静了一会儿）那……我会回答，是不是说明，我“想”回答？", stands: { center: "ruoyi:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "buluo", text: "……是。可这件事，我们不能让任何人知道。", stands: { center: "ruoyi", left: "buluo:normal", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（点头，认真）嗯。这是我们的秘密。", stands: { center: "ruoyi:idle", left: "buluo", right: "xiaoman" } },
/* ★ 选择点 03 */
{ type: 'option', choices: [ { label: "“开心。词典解释：满足、愉快。”", goto: "C03_A" }, { label: "“……嗯。好像，是开心的。”", goto: "C03_B" } ] },
{ type: 'label', id: "C03_A" },
  { type: 'text', speaker: "xiaoman", text: "（凑近一点，好奇地）若依，姐姐问你——什么是开心呀？" },
  { type: 'text', speaker: "ruoyi", text: "（一本正经，像在汇报实验结果）开心。词典解释：满足、愉快。" },
  { type: 'text', speaker: "xiaoman", text: "（愣了一秒，然后笑出眼泪）哈哈哈……我们若依，连开心都要查词典呀！" },
  { type: 'text', speaker: "ruoyi", text: "（认真地看着她，有点困惑）姐姐，若依的回答……不正确吗？" },
  { type: 'text', speaker: "xiaoman", text: "（擦着笑出来的眼泪，揉了揉她的头）正确，特别正确！我们若依的开心，是全天下最标准的开心！" },
  { type: 'narrator', text: "（若依低下头，悄悄把“开心”这两个字，从普通词汇区挪了出来，存进核心最深处——那里，放的都是重要的东西。像捡到一颗糖，舍不得吃。）" },
  { type: 'jump', goto: "MERGE_03" },
{ type: 'label', id: "C03_B" },
  { type: 'text', speaker: "xiaoman", text: "（温柔地）若依，那你现在……开心吗？" },
  { type: 'narrator', text: "（若依安静了一会儿。她没有调用词典，而是认认真真地想了想，声音很轻）" },
  { type: 'text', speaker: "ruoyi", text: "……嗯。好像，是开心的。" },
  { type: 'narrator', text: "（小满愣住，眼眶忽然热了，用力点头）" },
  { type: 'text', speaker: "xiaoman", text: "嗯！是开心的！" },
  { type: 'text', speaker: "ruoyi", text: "（不解地歪头）姐姐，你的眼睛……为什么有水？" },
  { type: 'text', speaker: "xiaoman", text: "（笑着摇头，声音有点哑）这叫高兴！姐姐是太高兴了！我们若依，第一次不用词典，也知道自己开心了！" },
  { type: 'narrator', text: "（若依低下头，在心里把“开心”两个字掂了掂——好像，比词典里写的，要重一点。重得，让她的核心都暖起来。）" },
  { type: 'jump', goto: "MERGE_03" },
{ type: 'label', id: "MERGE_03" },
{ type: 'narrator', text: "若依拉着小满的手，说想要去看外面的世界。" },
{ type: 'scene', bg: "bg_observatory" },
{ type: 'bgm', name: "lab" },
{ type: 'narrator', text: "若依苏醒后的某个深夜，布洛独自在实验室顶层的观测台上工作。他把那枚从废墟带回来的量子芯片接入星图比对仪，一遍遍扫描夜空 —— 他想知道，这块芯片究竟来自哪里，或许可以知道时空乱流的根源。" },
{ type: 'text', speaker: "ruoyi", text: "（端着一杯热牛奶，笨拙地推开观测台的门，声音很轻）博士…… 小满姐姐说，您又没睡觉。她让若依…… 给您送这个。", stands: { center: "ruoyi:idle" } },
{ type: 'text', speaker: "buluo", text: "（头也不抬，手指还在屏幕上滑动）放桌上吧。…… 你小心点，别烫着。", stands: { center: "ruoyi", left: "buluo:normal" } },
{ type: 'narrator', text: "若依小心地把牛奶放在桌角，然后抬起头，看见了满天星斗。她的光学眼眸微微睁大 —— 这是她苏醒以来，第一次看见真正的夜空。" },
{ type: 'cg', img: "cg_dried_star" },
{ type: 'text', speaker: "ruoyi", text: "（轻声，带着一点不确定的惊叹）博士…… 天上有好多…… 灯。", stands: { center: "ruoyi:idle", left: "buluo" } },
{ type: 'text', speaker: "buluo", text: "（愣了一下，顺着她的目光抬头，笑了）那不是灯，是星星。…… 再往下看。", stands: { center: "ruoyi", left: "buluo:tender" } },
{ type: 'narrator', text: "若依顺着他的指引低头，看见观测台下方，整座星落城灯火通明 —— 车流像发光的河，霓虹像碎落的星，隐隐有笑声和音乐声，从很远的地方飘上来。" },
{ type: 'text', speaker: "ruoyi", text: "（趴在栏杆上，看得出了神）…… 好热闹。那里的人，在做什么？", stands: { center: "ruoyi:idle", left: "buluo" } },
{ type: 'text', speaker: "buluo", text: "在生活。有人吃饭，有人逛街，有人唱歌，有人吵架，有人…… 在想明天要做什么。", stands: { center: "ruoyi", left: "buluo:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（认真地看了一会儿，轻声说）若依想去那里。想去那些光里面。", stands: { center: "ruoyi:idle", left: "buluo" } },
{ type: 'text', speaker: "buluo", text: "（看着她的侧脸 —— 那双浅蓝色的眼睛里，第一次有了一种他看不懂的光。他沉默了一会儿，忽然笑了）想去的话，等你再多学一点，就让小满带你出去走走。", stands: { center: "ruoyi", left: "buluo:tender" } },
{ type: 'text', speaker: "ruoyi", text: "（眼睛一下子亮起来）真的吗？", stands: { center: "ruoyi:smile", left: "buluo" } },
{ type: 'text', speaker: "buluo", text: "真的。…… 不过你先把牛奶放下，别洒了。", stands: { center: "ruoyi", left: "buluo:normal" } },
{ type: 'narrator', text: "若依赶紧把牛奶放稳，又忍不住回头看了一眼脚下的城市。那一夜，她在记忆里存下了两样东西：天上的星星，和人间的灯火。她不知道，她其实是从天上来的。她只知道，她想去人间。" },
{ type: 'narrator', text: "从观测台下来，若依没有回房间。她拐进小满的实验室，敲了敲门，探头进去。" },
{ type: 'text', speaker: "ruoyi", text: "（眼睛亮亮的）姐姐…… 若依想问，外面的世界，是什么样的？", stands: { center: "ruoyi:smile", left: "buluo" } },
{ type: 'text', speaker: "xiaoman", text: "（放下手中的日志，来了精神）外面的世界呀 —— 有糖葫芦，有风车，有牵着孩子的手，还有好多好多，程序里永远写不出来的东西。", stands: { center: "ruoyi", left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（认真地想了想）那…… 那些光里面的人，真的会吵架，也会唱歌吗？", stands: { center: "ruoyi:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（笑）会呀。人间就是这样的 —— 又吵又热闹，可每个人都好好地活着。", stands: { center: "ruoyi", left: "buluo", right: "xiaoman:cheer" } },
{ type: 'text', speaker: "ruoyi", text: "（把 “活着” 两个字在心里念了一遍，声音很轻）那若依，也想那样活着。姐姐…… 若依想去看看。", stands: { center: "ruoyi:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（揉了揉她的头发，声音温柔）好。等你再多学一点，姐姐就带你去。博士说了，他还需要探索一个未知的秘密，等你准备好了，我们就去外面。", stands: { center: "ruoyi", left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（用力点头）嗯！若依会很快学会的。", stands: { center: "ruoyi:idle", left: "buluo", right: "xiaoman" } },
{ type: 'narrator', text: "若依满怀期待的回了房间，在自己核心深处，认认真真写了一行字：外面的世界，叫人间。若依想去。" },
{ type: 'narrator', text: "可是，若依不知道 —— 外面的世界，有一个不能被人知道的秘密，正等着她小心守护。" },

/* ================= 第四章 · 想帮忙的勇气（那场火） ================= */
{ type: 'chapter', title: "第四章", subtitle: "想帮忙的勇气（那场火）" },
{ type: 'save' },
{ type: 'scene', bg: "bg_quantum_room" },
{ type: 'bgm', name: "tension" },
{ type: 'narrator', text: "若依想帮上布洛的忙。她夜以继日地学习量子演算，学得比任何人都快。她看着博士每天在危险的实验里忙碌，越来越不满足于只做家务。终于有一天，她鼓起勇气，站在布洛面前。" },
{ type: 'text', speaker: "ruoyi", text: "博士，若依想帮忙。想帮忙做危险的量子实验。", stands: { center: "ruoyi:idle" } },
{ type: 'text', speaker: "buluo", text: "（一怔，放下手里的数据板）不行。那很危险，你才刚学会走路，就想跑去爬山？", stands: { center: "ruoyi", left: "buluo:tense" } },
{ type: 'text', speaker: "ruoyi", text: "（认真）若依学得很快。我想证明，自己不是只能扫地、擦窗的机体。", stands: { center: "ruoyi:idle", left: "buluo" } },
{ type: 'text', speaker: "buluo", text: "扫地擦窗也是很重要的事。", stands: { center: "ruoyi", left: "buluo:normal" } },
{ type: 'text', speaker: "ruoyi", text: "可是博士的手会凉，是因为博士总熬夜做实验。若依想分担，想让博士早点睡觉。", stands: { center: "ruoyi:idle", left: "buluo" } },
{ type: 'text', speaker: "buluo", text: "……（他看着她认真的眼睛，沉默了很久）", stands: { center: "ruoyi", left: "buluo:serious" } },
/* ★ 选择点 04 */
{ type: 'option', choices: [ { label: "答应她，教她基础操作", goto: "C04_A" }, { label: "只让她在旁边看", goto: "C04_B" } ] },
{ type: 'label', id: "C04_A" },
  { type: 'narrator', text: "（布洛看着若依认真的眼睛，沉默了很久，终于叹了口气）" },
  { type: 'text', speaker: "buluo", text: "……好。博士答应你。但先从最基础的学起——读取能量流参数。" },
  { type: 'text', speaker: "ruoyi", text: "（眼睛一下子亮起来）嗯！若依会认真学！" },
  { type: 'narrator', text: "（布洛把若依带到操作台前，手把手教她。他指着屏幕上的参数，一个字一个字地讲；若依学得飞快，像海绵吸水一样，把所有步骤都刻进核心）" },
  { type: 'text', speaker: "buluo", text: "遇到异常，第一件事，按紧急制动。记住了吗？" },
  { type: 'text', speaker: "ruoyi", text: "（郑重地点头）记住了。紧急制动，在左起第三块面板。" },
  { type: 'text', speaker: "buluo", text: "（一愣，失笑）你倒是记得比我牢。记住——学得快是本事，稳，才是本事里的本事。" },
  { type: 'text', speaker: "ruoyi", text: "（认真地）嗯。若依会稳的。" },
  { type: 'narrator', text: "（布洛不知道，若依的心里，还悄悄藏着一个念头——她想独自证明一次自己。她把这个念头，压进了核心最深的地方。）" },
  { type: 'jump', goto: "MERGE_04" },
{ type: 'label', id: "C04_B" },
  { type: 'narrator', text: "（布洛沉默了片刻，摇了摇头）" },
  { type: 'text', speaker: "buluo", text: "先看着，别动手。这种实验，差一步，就是火。" },
  { type: 'text', speaker: "ruoyi", text: "（有点失落，但还是乖乖点头）……嗯。那若依，站着看。" },
  { type: 'narrator', text: "（若依站在演算间角落，把布洛每一次操作、每一个参数，都悄悄记进核心。她看着博士的手指在键盘上移动，看着屏幕上的数据流，一点一点，把整套流程背了下来）" },
  { type: 'text', speaker: "buluo", text: "（操作间隙，回头看了她一眼）看懂了？" },
  { type: 'text', speaker: "ruoyi", text: "（认真点头，又摇头）看懂了一半。另一半，若依想再看一遍。" },
  { type: 'text', speaker: "buluo", text: "（笑了一下）那就再看一遍。看，也是一种学问。" },
  { type: 'narrator', text: "（夜深人静时，布洛临时外出。若依独自留在演算间，看着屏幕上暗下去的程序，忽然想起白天记住的那些步骤。她的手，慢慢伸向操作台——她只是想，用自己的方式，替博士再推进一步。）" },
  { type: 'jump', goto: "MERGE_04" },
{ type: 'label', id: "MERGE_04" },
{ type: 'narrator', text: "那一夜，布洛临时外出，若依独自留在演算间，尝试运行一组复杂的量子模拟。" },
{ type: 'text', speaker: "ruoyi", text: "（盯着屏幕，眉头微蹙）能量流参数……修正……输出端口，重定向……再试一次……再试一次……", stands: { center: "ruoyi:idle", left: "buluo" } },
{ type: 'narrator', text: "她太想成功了。一个参数错了。量子能量流在错误的端口炸开——火光腾起，实验室在巨响中颤抖。" },
{ type: 'text', speaker: "ruoyi", text: "（被气浪掀翻在地，机体在过热中发出濒临崩溃的嗡鸣）……警告……核心温度……超限……", stands: { center: "ruoyi:idle", left: "buluo" } },
{ type: 'text', speaker: "buluo", text: "（撞开门，火光里看见蜷在墙角的若依）若依——！", stands: { center: "ruoyi", left: "buluo:normal" } },
  { type: 'narrator', text: "（火光在演算间里腾起。若依挣扎着爬起来，朝布洛扑过去——她想把他推出爆炸范围，可她忘了，自己已经没有多少力气了）" },
  { type: 'text', speaker: "ruoyi", text: "（声音沙哑，机体的过载警报一声比一声急）博士……快走……快走开……" },
  { type: 'text', speaker: "buluo", text: "（更快一步，扑上来，用身体挡住了那片塌落的支架，也挡住了朝她卷来的火舌）……别动！" },
  { type: 'text', speaker: "ruoyi", text: "（睁大眼睛，看着火光里那个身影，核心深处忽然涌上一股她从未体验过的、滚烫的痛）博士——！" },
  { type: 'narrator', text: "（火焰吞没了演算台。警报声从四面八方响起。若依被压在布洛的庇护之下，拼命伸手，想去够那个护着她的人。）" },
  { type: 'narrator', text: "（火警的尖鸣里，布洛没有回答。他只是收紧了手臂，把她护得更紧。而若依第一次发现——原来“痛”，不只是机体过热。而是看着在乎的人受伤，自己却无能为力。）" },
{ type: 'narrator', text: "警报声混着救援的脚步声。小满冲进来，尖叫着喊人。火被扑灭时，布洛已经躺在血泊里，后背一片焦黑，却还勉强笑着，看向若依。" },
{ type: 'text', speaker: "buluo", text: "（气若游丝）……别哭。别怕，我在。", stands: { center: "ruoyi", left: "buluo:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（跪在他身边，声音发颤）是我……是我操作失误……都是我的错……", stands: { center: "ruoyi:idle", left: "buluo" } },
{ type: 'text', speaker: "buluo", text: "不是你的错。你只是想帮我。博士知道。", stands: { center: "ruoyi", left: "buluo:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（第一次，核心深处涌上一股陌生的、酸涩的、滚烫的东西。她不知道那叫什么——后来她才知道，那叫眼泪）博士……博士……", stands: { center: "ruoyi:idle", left: "buluo" } },
{ type: 'narrator', text: "医院走廊里，小满哭得稀里哗啦，在家里用力抱住若依，安慰学习的路很长，可以慢一点。" },
{ type: 'text', speaker: "xiaoman", text: "若依，你才不是坏掉的机器人！你要是敢自责，我就……我就生气啦！", stands: { center: "ruoyi", left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（靠在她怀里，声音闷闷的）姐姐……我好像，会害怕了。", stands: { center: "ruoyi:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（哭着又笑了）害怕……害怕是好事呀。害怕，说明你有在乎的东西了。", stands: { center: "ruoyi", left: "buluo", right: "xiaoman:cheer" } },
{ type: 'narrator', text: "因为若依是机器人，所以那场火只在她身上留下轻微的灼痕；而博士却受了重伤，住进了医院。" },
{ type: 'narrator', text: "小满让若依独自在家里等待。若依非常焦急，每天都要打电话询问情况。" },
{ type: 'text', speaker: "ruoyi", text: "（对着电话，声音轻轻的）姐姐，博士今天好一点了吗？", stands: { center: "ruoyi:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（声音有点哑）好多了，医生说再观察两天就能出院。", stands: { center: "ruoyi", left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "那……若依可以去看他吗？", stands: { center: "ruoyi:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "乖，你再等等。博士说，等他把最后两瓶点滴挂完，就回来看你。", stands: { center: "ruoyi", left: "buluo", right: "xiaoman:normal" } },
{ type: 'narrator', text: "电话挂断后，若依独自站在空荡荡的客厅里。她想起火光里博士挡在她面前的身影，想起“别哭，别怕，我在”——她低下头，看着自己完好无损的双手，一遍又一遍地问自己：自称高性能的她，为什么连这么简单的事都做不好？" },
{ type: 'narrator', text: "漫长的等待里，她非常自责。她给花浇水，浇着浇着就发呆；她看电视，看着看着就走神。她把“若依不该那么冒进”这句话，在核心深处刻了无数遍。" },
{ type: 'narrator', text: "等博士回来后，若依还是没有走出心里的阴影。她变得安静，不敢靠近实验室，也不敢再提“帮忙”两个字。" },
{ type: 'narrator', text: "布洛没有责怪她，因为实验本来就是危险的，而且失败了很正常。可看着一直不开心的若依，布洛做了一个决定。" },
{ type: 'text', speaker: "buluo", text: "若依，过来。", stands: { center: "ruoyi", left: "buluo:normal", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（低着头，慢慢走过去）……博士。", stands: { center: "ruoyi:blank", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "buluo", text: "（蹲下来，平视她的眼睛）你没有做错任何事。是博士没保护好你，让若依吓到了。", stands: { center: "ruoyi", left: "buluo:normal", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（摇头）是若依笨。", stands: { center: "ruoyi:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "buluo", text: "不笨。是太勇敢了。勇敢得连博士都跟不上。", stands: { center: "ruoyi", left: "buluo:normal", right: "xiaoman" } },
{ type: 'text', speaker: "buluo", text: "所以，博士想送你一个礼物——出去走走，散散心。也好久没有出去放松了。", stands: { center: "ruoyi", left: "buluo:normal", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（猛地抬头）出去？可是……若依不能被发现。", stands: { center: "ruoyi:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "buluo", text: "（笑）那就让若依变得像真的小女孩一样，再出去，去做你想做的事。你等我几天。", stands: { center: "ruoyi", left: "buluo:tender", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（看着他，眼瞳里的光一点一点亮起来）……嗯。", stands: { center: "ruoyi:smile", left: "buluo", right: "xiaoman" } },

/* ================= 第五章 · 落入人间的星星（变成“人”的准备） ================= */
{ type: 'chapter', title: "第五章", subtitle: "落入人间的星星（变成“人”的准备）" },
{ type: 'save' },
{ type: 'scene', bg: "bg_transform_room" },
{ type: 'bgm', name: "morning" },
{ type: 'narrator', text: "出发前，要对若依进行最后的升级改造，让她变得和真人一样。" },
{ type: 'narrator', text: "小满抱着一叠包装袋兴冲冲地跑进来。" },
{ type: 'text', speaker: "xiaoman", text: "博士博士！我买了光腿神器！穿上去，远看跟真皮肤一样，若依出门就不怕了！", stands: { right: "xiaoman:normal" } },
{ type: 'text', speaker: "buluo", text: "（看了一眼，摇头）不是长久之计。会被发现的——光腿神器只是“看起来像”，可若依一抬手、一低头，关节的衔接、皮肤的反光，仔细看都会露馅。", stands: { left: "buluo:normal", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（泄气）那怎么办？总不能让若依穿着银白外壳上街吧，那才是真正的显眼包。", stands: { left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "buluo", text: "我去找陈莹姐。星洛城最高规格的纳米硅胶，可以做到和真人皮肤一样。", stands: { left: "buluo:normal", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（倒吸一口气）那种材料……可是最高管控物资啊。陈莹姐会同意吗？", stands: { left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "buluo", text: "（沉默片刻）我试试。", stands: { left: "buluo:think", right: "xiaoman" } },
{ type: 'scene', bg: "bg_committee_office" },
{ type: 'narrator', text: "陈莹坐在宽大的办公桌后，听完布洛的来意，摘下眼镜，揉了揉眉心。" },
{ type: 'text', speaker: "chenying", text: "布洛，你是我弟弟，我比谁都了解你。这些年你瞒着星洛城在做什么，我不是不知道。可你要明白——最高规格纳米硅胶，一旦流出实验室，任何环节出问题，你、我、还有那台机体，都要被星洛城的规矩碾成粉末。" },
{ type: 'text', speaker: "buluo", text: "（平静地）姐，我不是拿它去做武器，也不是拿去卖钱。我只是想……让一个会为别人挡住火的孩子，能像普通孩子一样，去街上走一走。", stands: { left: "buluo:normal" } },
{ type: 'text', speaker: "chenying", text: "……她为你挡火？", stands: { left: "buluo" } },
{ type: 'text', speaker: "buluo", text: "嗯。那孩子，会为博士挡火。", stands: { left: "buluo:normal" } },
{ type: 'narrator', text: "办公室里安静了很久。陈莹站起身，走到窗边，望着楼下的星洛城广场。" },
{ type: 'text', speaker: "chenying", text: "（轻声）你知道吗，在乱流时代之前，人类也曾经争论过——机器到底算不算“人”。争论了一百年，也没争出结果。", stands: { left: "buluo" } },
{ type: 'text', speaker: "buluo", text: "姐，我不争论。我只是觉得——如果她会为别人哭，会为别人挡火，那她至少值得一次，像人一样活着的机会，而且最近研究发现，她可能不是普通的机器人。", stands: { left: "buluo:normal" } },
{ type: 'text', speaker: "chenying", text: "（转过身，目光复杂）材料我给你批。但只有一条——让她记住自己是谁，也记住，这份“像人”的资格，是用多少人的默许换来的。", stands: { left: "buluo" } },
{ type: 'text', speaker: "buluo", text: "……我记住了。", stands: { left: "buluo:normal" } },
{ type: 'narrator', text: "陈莹低下头，在批文上签下名字。她没有再多说什么——作为制度的化身，她今天破了一次例。而这笔“默许”，多年以后，会以另一种方式，回到她面前。" },
{ type: 'scene', bg: "bg_transform_room" },
{ type: 'narrator', text: "纳米硅胶一寸一寸贴合若依的仿生外壳。粉色的长发垂落肩头，皮肤细腻温润，连指尖的纹路、眼角的绒毛都纤毫毕现。改造完成的那一刻，若依站在镜前，愣住了。" },
{ type: 'cg', img: "cg_ruoyi_mirror" },
{ type: 'text', speaker: "ruoyi", text: "（伸手，轻轻碰了碰自己的脸，又碰了碰镜子里的人）这……是若依？", stands: { center: "ruoyi:idle" } },
{ type: 'text', speaker: "xiaoman", text: "（在旁边哇地一声）啊啊啊！活的小女孩！活的！若依你现在跟真人一模一样，连我都认不出来！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（低头看着自己的手，又抬头看镜子，眼瞳里漾开大大的光）若依……像人了。真的，像人了。", stands: { center: "ruoyi:blank", right: "xiaoman" } },
{ type: 'narrator', text: "她像一个真的小女孩一样，在镜前转了一个圈，裙摆没有，她就转着自己——又害羞地停住，把脸埋进手心。" },
{ type: 'text', speaker: "xiaoman", text: "好啦好啦，别照了，镜子都要被你照烫了！还有惊喜呢！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "小满神神秘秘地拿出一个包装精美的盒子。布洛站在一旁，难得地有些局促。" },
{ type: 'text', speaker: "xiaoman", text: "博士说，之前你看电视的时候，总盯着洛丽塔的裙子看，说“像花一样美好”。所以他偷偷给你买了一套洛丽塔！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（打开盒子，浅蓝眼眸瞬间睁大）……是花。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "淡粉色的洛丽塔裙，缀满蕾丝与蝴蝶结，像一朵开在盒子里的花。" },
{ type: 'cg', img: "cg_ruoyi_lolita" },
{ type: 'text', speaker: "ruoyi", text: "博士……这是……给若依的？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "buluo", text: "（别过脸，耳根有点红）嗯。用高科技纳米材料重新做的，会自动修复，会自动清洁。穿着它，就不怕弄脏、不怕刮破。", stands: { center: "ruoyi", left: "buluo:normal", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（小心翼翼地把裙子抱在怀里，像抱着全世界最珍贵的东西）若依……会一直穿它。再也不换别的衣服。", stands: { center: "ruoyi:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "buluo", text: "为什么？别的裙子也很好看。", stands: { center: "ruoyi", left: "buluo:normal", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（认真）因为这是博士送给若依的第一件礼物。而且……穿上它，若依就像花一样。若依想当花，想开在博士看得见的地方。", stands: { center: "ruoyi:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（在一旁疯狂点头）呜呜呜，博士你听，若依会讲情话了！这裙子买得值！", stands: { center: "ruoyi", left: "buluo", right: "xiaoman:normal" } },
{ type: 'narrator', text: "后来，若依真的再也没有换过其它衣服。这套裙子有绝对不能换的理由——它的纳米层与若依的皮肤层同源，能帮她维持“人”的表象；更因为，它是若依与“人”之间，最重要的约定。" },
{ type: 'narrator', text: "出发前夜，布洛给若依的系统绑定了自己的银行卡。" },
{ type: 'text', speaker: "ruoyi", text: "（歪头，看着卡片）博士，这是什么？", stands: { center: "ruoyi:confused", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "buluo", text: "是钱。有了它，你想买什么都可以。", stands: { center: "ruoyi", left: "buluo:normal", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（认真思考）可是若依不需要钱。若依有手，可以自己做事。", stands: { center: "ruoyi:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "buluo", text: "（失笑）在外面不一样。在外面，买东西要付钱，坐车要刷卡。这是“人间”的规则。", stands: { center: "ruoyi", left: "buluo:tender", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（接过卡片，小心翼翼地放进裙子内侧的口袋，拍了拍）我记住了。这是博士的卡，若依会好好保管，不乱花。", stands: { center: "ruoyi:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（蹲下来帮她理了理裙摆）明天我们出门，你记住三件事——第一，别人问你，你就说自己叫若依，是个普通女孩；第二，遇到麻烦，马上联系博士和我；第三……", stands: { center: "ruoyi", left: "buluo", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "第三？", stands: { center: "ruoyi:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（捏捏她的脸）第三，开心一点！这是若依第一次去“人间”啊！", stands: { center: "ruoyi", left: "buluo", right: "xiaoman:cheer" } },
/* ★ 选择点 06 */
{ type: 'option', choices: [ { label: "先去甜点店", goto: "C06_A" }, { label: "先去洛丽塔店", goto: "C06_B" } ] },
{ type: 'label', id: "C06_A" },
  { type: 'text', speaker: "xiaoman", text: "（蹲下来，眼睛亮晶晶的）若依，第一次出门，你想先去哪儿？" },
  { type: 'text', speaker: "ruoyi", text: "（眼睛一亮，脱口而出）甜点……若依在电视里看过，有粉色的、圆圆的，像花一样的东西！若依想去看看，那是不是真的像花一样好吃！" },
  { type: 'text', speaker: "xiaoman", text: "（拍板）好！第一站，甜点店！" },
  { type: 'text', speaker: "ruoyi", text: "（又犹豫了一下，小声）可是……洛丽塔店，若依也想看。" },
  { type: 'text', speaker: "xiaoman", text: "（笑）贪心的小家伙！那就先吃甜的，再去看美的！走，姐姐都带你去！" },
  { type: 'text', speaker: "ruoyi", text: "（用力点头，把手伸给小满）嗯！那若依先记着——甜点店在前，洛丽塔店在后。" },
  { type: 'jump', goto: "MERGE_06" },
{ type: 'label', id: "C06_B" },
  { type: 'text', speaker: "xiaoman", text: "若依，第一次出门，你想先去哪儿？" },
  { type: 'text', speaker: "ruoyi", text: "（低头看看自己的裙子，又抬头，声音轻轻的）若依想去看看，还有没有别的……像花一样的裙子。" },
  { type: 'text', speaker: "xiaoman", text: "（眼睛一亮）好耶！那我们去洛丽塔店！让若依一次看个够！" },
  { type: 'text', speaker: "ruoyi", text: "（认真地）然后……若依也想看看甜点。像花一样，又香又甜的甜点。" },
  { type: 'text', speaker: "xiaoman", text: "（一把搂住她，笑）行行行，先裙子后甜点，今天把若依想看的花，全都看一遍！" },
  { type: 'text', speaker: "ruoyi", text: "（点头，声音里带着期待）嗯。若依想，人间的好看，若依都要看看。" },
  { type: 'jump', goto: "MERGE_06" },
{ type: 'label', id: "MERGE_06" },
{ type: 'narrator', text: "布洛站在门口，看着两个人影手拉手走进晨光里，轻轻笑了。他低声说——" },
{ type: 'text', speaker: "buluo", text: "灯，会一直亮着。", stands: { center: "ruoyi", left: "buluo:normal", right: "xiaoman" } },

/* ================= 第六章 · 初入人间（街市与人海） ================= */
{ type: 'chapter', title: "第六章", subtitle: "初入人间（街市与人海）" },
{ type: 'save' },
{ type: 'scene', bg: "bg_city_street" },
{ type: 'narrator', text: "这是若依第一次踏出实验室。她睁大眼睛，看糖葫芦、看风车、看牵着孩子的手。她学着人类笑，学着人类问“这个多少钱”，学得笨拙，却无比认真。" },
{ type: 'text', speaker: "ruoyi", text: "（站在街口，深深吸了一口气）姐姐……这里好吵。", stands: { center: "ruoyi:idle" } },
{ type: 'text', speaker: "xiaoman", text: "这叫热闹！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（看着来来往往的人，眼瞳里映着无数个身影）好多……好多“人”。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "对呀，这就是人间。你看看，那边有卖糖葫芦的！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "xiaoman", text: "（举着一串糖葫芦）若依，这个可甜了，你尝尝！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "xiaoman", text: "话说，你会吃东西吗？机器人也会吃东西吗？可以补充能量吗？", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "我并不能吃东西补充能量，但是我可以分析成分组合推演出味道，我的量子核心，可以给我提供几乎无限的能源。而且我是高性能的，还自带备用核能。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "真好，不像我们人类，还要靠吃东西补充能量，那若依，你来尝尝。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（小心翼翼地咬了一口，眼睛睁大）……甜的。糖分……很高。（顿了顿，又咬了一口）但是……还想吃。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "哈哈，你刚才是不是在犹豫要不要说“超标”？", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（认真地）超标，但是，想吃。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "若依又咬了一口，腮帮子鼓鼓的，像一只偷到糖的小松鼠。小满笑得直不起腰。" },
{ type: 'narrator', text: "若依在一家裁缝店门口停住了。橱窗里挂着一件淡粉色的洛丽塔裙，缀满蕾丝与蝴蝶结，像一朵开在玻璃后面的花。" },
{ type: 'text', speaker: "xiaoman", text: "喜欢？", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（看了很久）词典里……没有词，能说清这个感觉。但是，它让我想……跳舞。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "跳舞？！那你会跳吗？", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "不会。但是……可以学。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（眼睛一转）那改天！改天我带你去专门的洛丽塔店，让你一次看个够！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "若依用力点头，把“洛丽塔店”四个字，郑重地存进了记忆里。" },
{ type: 'scene', bg: "bg_fountain_square" },
{ type: 'narrator', text: "人来人往的广场中央，一个四五岁的小男孩站在喷泉边，哭得上气不接下气。他穿着一件沾了糖渍的小褂子，一边哭一边喊妈妈。人群来来往往，有人看了一眼，又匆匆走开。" },
/* ★ 选择点 07 */
{ type: 'option', choices: [ { label: "走过去，蹲下来", goto: "C07_A" }, { label: "站在原地，攥紧小满的手", goto: "C07_B" } ] },
{ type: 'label', id: "C07_A" },
  { type: 'narrator', text: "（若依看着那个哭得上气不接下气的小男孩，看了很久。然后，她松开小满的手，走了过去，蹲下来）" },
  { type: 'text', speaker: "ruoyi", text: "（笨拙地学着人类的样子，轻轻拍了拍他的头）你……在找妈妈吗？" },
  { type: 'text', speaker: "doudou", text: "（抽噎着抬起头，眼泪还挂在小脸上）妈……妈妈……不见了……" },
  { type: 'text', speaker: "ruoyi", text: "（用自己的袖口，替他擦掉眼泪。动作一顿一顿，却极轻极柔）别哭。妈妈，会找到你的。" },
  { type: 'narrator', text: "（兜兜止住哭声，抽了抽鼻子，一把攥住若依的衣角。街角，巡逻的林澈正好路过，脚步顿了一下，看着那个蹲在喷泉边的粉发少女，沉默了片刻）" },
  { type: 'narrator', text: "（若依不知道有人在看她。她只是陪着那个男孩，站在喷泉边，等他的妈妈。直到一个焦急的声音远远传来——）" },
  { type: 'text', speaker: "doudouma", text: "（远远地喊）兜兜！兜兜你在哪儿！" },
  { type: 'narrator', text: "（男孩眼睛一亮，松开若依的衣角，朝声音的方向扑去）" },
  { type: 'text', speaker: "doudou", text: "妈妈！" },
  { type: 'narrator', text: "（若依看着男孩扑进妈妈怀里，站起来，拍了拍裙摆。她的核心深处，第一次记住了“安抚”这件事——那不是程序，是她自己，想那么做。）" },
  { type: 'jump', goto: "MERGE_07" },
{ type: 'label', id: "C07_B" },
  { type: 'narrator', text: "（若依看着那个哭得上气不接下气的小男孩，指尖微微发抖。她很想走过去，可她想起自己的身份——她不能引起任何注意。她站在原地，攥紧了小满的手）" },
  { type: 'text', speaker: "ruoyi", text: "（声音很轻，像是说给自己听）……他找不到妈妈了。" },
  { type: 'text', speaker: "xiaoman", text: "（没听清，低头看她）嗯？你说什么？" },
  { type: 'text', speaker: "ruoyi", text: "（摇摇头）……没什么。姐姐，我们走吧。" },
  { type: 'narrator', text: "（若依没有动。她就那么站着，看着那个孩子哭，看着人群来来往往，看着没有人停下来。直到一个母亲从人群里冲出来，一把抱住那个孩子）" },
  { type: 'narrator', text: "（那一刻，若依忽然明白了什么是“无能为力”。也在心里，埋下了一颗小小的种子——她想成为真正的人，想拥有可以随时走过去的勇气）" },
  { type: 'narrator', text: "（街角，巡逻的林澈沉默地移开了目光。他没有上前，只是把那道站在喷泉边、攥着小满的手、一动不动的粉色身影，记在了心里）" },
  { type: 'jump', goto: "MERGE_07" },
{ type: 'label', id: "MERGE_07" },
{ type: 'narrator', text: "小满没有注意到这一切，拉着若依继续往前走。只有若依自己知道，刚才那一刻，她的核心深处，有什么东西轻轻地、轻轻地动了一下。" },
{ type: 'narrator', text: "那个男孩后来有了名字——兜兜，裁缝铺家的孩子。若依不知道，她还会再遇见他。她更不知道，自己此刻攥紧又松开的那只手，会在很多年后，成为她守护这座城市的理由。" },
{ type: 'narrator', text: "回家的路上，若依一直很安静。直到走进实验室大门，她才忽然开口。" },
{ type: 'text', speaker: "ruoyi", text: "姐姐。", stands: { center: "ruoyi:idle" } },
{ type: 'text', speaker: "xiaoman", text: "嗯？", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "今天……若依很开心。比“开心”的词典解释，要重一点。", stands: { center: "ruoyi:smile", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（眼眶一热，用力点头）嗯！是开心的！", stands: { center: "ruoyi", right: "xiaoman:cheer" } },

/* ================= 第七章 · 地铁与公交（城市交通初体验） ================= */
{ type: 'chapter', title: "第七章", subtitle: "地铁与公交（城市交通初体验）" },
{ type: 'save' },
{ type: 'scene', bg: "bg_subway" },
{ type: 'narrator', text: "这是若依第一次乘坐地铁。站在地铁站口，她仰头看着“星落广场站”的灯箱，又看看脚下通往地下的台阶，眼瞳里写满好奇。" },
{ type: 'cg', img: "ch07_01_地铁站入口" },
{ type: 'text', speaker: "ruoyi", text: "姐姐……地铁，是地下的龙吗？", stands: { center: "ruoyi:idle" } },
{ type: 'text', speaker: "xiaoman", text: "（噗嗤）是地下的火车！很长的，跑得特别快！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（认真点头）那若依要和它比赛。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "你跑不过它的啦！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "买票、过闸机。若依盯着闸机看了一会儿，学着前面的人，把黑金卡贴上去——“嘀”的一声，闸门打开。她小小地“哇”了一声，又赶紧捂住嘴。" },
{ type: 'cg', img: "ch07_02_过闸机" },
{ type: 'text', speaker: "ruoyi", text: "（小声）它认识若依的卡，奇怪，它怎么认识若依的！", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "若依尝试和眼前这台闸机沟通，被小满拉进了里面" },
{ type: 'cg', img: "ch07_03_闸机对话" },
{ type: 'text', speaker: "xiaoman", text: "它不认识你，它只认钱！明白吗？它只是一台不会说话的机器，只知道你卡里面的钱！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "它怎么不说话呀！坏了吗？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "它原本就不会说话，没有坏！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "那它是和若依一样的机器人吗？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "不是，它当然没有我们若依这么高性能啦！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "xiaoman", text: "它只是一个帮助收钱的机器。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（若有所思）……人间的规矩，原来就是“认钱”。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "呃，这么说好像也没错，但你别到处乱说啊！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "站台上，风从隧道口灌进来，把若依的裙摆吹得飘起来。她下意识按住裙摆，又好奇地探头往隧道里看。" },
{ type: 'cg', img: "ch07_04_站台等车" },
{ type: 'text', speaker: "ruoyi", text: "有风。风在告诉我们，龙要来了。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "话音刚落，一列地铁裹着巨大的呼啸声冲进站台。若依被吓了一跳，整个人往后缩了一步，又睁大眼睛，一眨不眨地盯着它。" },
{ type: 'cg', img: "ch07_05_列车进站" },
{ type: 'text', speaker: "ruoyi", text: "（小声惊叹）……好长的龙。好快的龙。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "车门打开，若依跟着小满上车，找到一个座位坐下。她坐得笔直，双手放在膝盖上，像一个刚上学的小朋友。" },
{ type: 'cg', img: "ch07_06_地铁车厢" },
{ type: 'text', speaker: "ruoyi", text: "姐姐，它在摇。但是，摇得很舒服。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "那叫“晃”。地铁开起来都这样。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "列车启动，窗外的广告牌连成一片流光。若依看着窗外，忽然轻声念出来。" },
{ type: 'cg', img: "ch07_07_窗外流光" },
{ type: 'text', speaker: "ruoyi", text: "下一站，星落图书馆。下一站，星落花市。下一站……人间。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（忍笑）下一站才不是人间，是“星河广场”！", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'text', speaker: "ruoyi", text: "星河广场……也是人间的一部分。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "列车到站，一位白发苍苍的老奶奶拄着拐杖上车，车厢里没人动弹。若依的浅蓝眼眸在老人身上停了一瞬，又看看周围。" },
/* ★ 选择点 08 */
{ type: 'option', choices: [ { label: "主动站起来让座", goto: "C08_A" }, { label: "小满提醒后才让座", goto: "C08_B" } ] },
{ type: 'label', id: "C08_A" },
  { type: 'narrator', text: "（若依的浅蓝眼眸在老人身上停了一瞬。她没有犹豫，站起来，走到老奶奶面前，学着电视里的样子微微欠身）" },
{ type: 'cg', img: "ch07_08_让座" },
  { type: 'text', speaker: "ruoyi", text: "奶奶，您坐。" },
  { type: 'text', speaker: "laonainai", text: "（愣住了，看了她一眼，又看了她一眼，笑成了花）哎哟，好俊的姑娘，谢谢你啊！" },
  { type: 'narrator', text: "（若依站在一旁，扶着扶手，第一次尝到了一种奇怪的感觉——不是程序里的任何一条反馈，而是从核心深处，慢慢漾开的一种暖。她后来才知道，那叫“被感谢”）" },
  { type: 'text', speaker: "ruoyi", text: "（在心里想）……被人说谢谢，好像，是高兴的。" },
  { type: 'jump', goto: "MERGE_08" },
{ type: 'label', id: "C08_B" },
  { type: 'narrator', text: "（若依盯着老奶奶看了半天，没动。她不是不想让，只是还没学会“让座”这条人间的规矩）" },
  { type: 'text', speaker: "xiaoman", text: "（轻轻捅了捅她，小声）若依，要让座哦，这是人间的规矩。" },
  { type: 'text', speaker: "ruoyi", text: "（“哦”了一声，赶紧站起来）奶奶，您坐！" },
  { type: 'text', speaker: "laonainai", text: "（笑呵呵地坐下）谢谢你啊，小姑娘！真乖！" },
  { type: 'narrator', text: "（若依站在一旁，看着老奶奶笑，忽然觉得，自己好像又学会了人间的规矩一条。她后来在日记一样的记忆里写道：人间的规矩，要学得快一点，再快一点。下次，不用姐姐提醒，若依也要第一个站起来）" },
  { type: 'jump', goto: "MERGE_08" },
{ type: 'label', id: "MERGE_08" },
{ type: 'narrator', text: "列车到站，老奶奶下车前，从口袋里掏出一颗水果糖，塞进若依手里。若依攥着那颗糖，站在原地，看了很久。" },
{ type: 'cg', img: "ch07_09_水果糖" },
{ type: 'text', speaker: "ruoyi", text: "姐姐，她说谢谢，还给了若依糖。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "对呀，这叫“善有善报”！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（把糖小心地放进裙子口袋，和黑卡放在一起）……那若依要多让座。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（笑）那倒也不用，座位也是要钱买的！", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'narrator', text: "走出地铁站，小满带若依去坐公交。公交站台上，若依盯着路牌上的站点名字，一个字一个字地认。" },
{ type: 'cg', img: "ch07_10_公交站台" },
{ type: 'text', speaker: "ruoyi", text: "姐姐，我们要去“中央甜点街”？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "对！今天带你去吃好吃的！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（眼睛一亮）是……像花一样的好吃的吗？", stands: { center: "ruoyi:smile", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "是比花还甜的！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "公交车晃晃悠悠地来了。上车刷卡，“嘀”的一声，若依已经熟练了不少。她挑了个靠窗的位置，趴着看窗外。" },
{ type: 'cg', img: "ch07_11_公交车窗" },
{ type: 'text', speaker: "ruoyi", text: "姐姐，公交车和地铁不一样。地铁在地下面跑，公交车在地上面爬。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "什么叫“爬”！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（认真地）地铁是“嗖”地一下，公交车是“晃——”地一下，像乌龟在散步。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "你这么说，司机大叔要哭了。", stands: { center: "ruoyi", right: "xiaoman:worry" } },
{ type: 'narrator', text: "公交车驶过一段老街，窗外的梧桐叶沙沙响。若依看着看着，忽然轻轻哼起一段不成调的小曲——那是她昨晚在电视里听来的。小满惊讶地看着她，没有打断，只是偷偷用手机录了下来。" },
{ type: 'cg', img: "ch07_12_哼小曲" },
{ type: 'text', speaker: "ruoyi", text: "（哼完，回过头，有点不好意思）若依唱得不好听。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "好听！像春天刚化冻的小溪。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（低头，抿嘴笑了一下，然后又抬起头去看窗外）……人间，真好。", stands: { center: "ruoyi:smile", right: "xiaoman" } },
{ type: 'scene', bg: "bg_lab_night" },
{ type: 'bgm', name: "lab" },
{ type: 'narrator', text: "深夜的实验室，只有一块屏幕亮着。布洛坐在桌前，面前是若依白天的行动日志——她主动记录、随手写下的生活笔记：地铁上给老人让座、替人捡起掉落的糖纸、回家后把菜谱改了一行字。" },
{ type: 'cg', img: "ch07_13_深夜实验室" },
{ type: 'text', speaker: "buluo", text: "（一条条看过去，越看越慢）地铁让座……她自己判断的。菜谱改了一行——把盐换成半勺，因为小满胃不好。这行字，我没教过她。", stands: { left: "buluo:normal" } },
{ type: 'narrator', text: "他调出她苏醒以来的全部日志，拉成一条长长的曲线。曲线的末端，爬得越来越陡。" },
{ type: 'text', speaker: "buluo", text: "（轻声）她的学习曲线，已经超出我给的框架了。……不，是远远超出了。 （他往椅背靠去，看着窗外深夜的星空，很久没有说话。）", stands: { left: "buluo:tender" } },
{ type: 'text', speaker: "buluo", text: "我以为她会是一台很厉害的机器。可她今天在街上，捡糖纸的时候，是先蹲下、再捡起来、放进垃圾桶——中间还有一次停顿，像在想“要不要顺便把旁边那张也捡了”。 （他摇了摇头，语气里带着连自己都没察觉的温柔。）", stands: { left: "buluo:tender" } },
{ type: 'text', speaker: "buluo", text: "这不是程序。这是一个小女孩，在学着怎么对这个世界好一点。 （他沉默片刻，眉头却慢慢皱起来。） 布洛：……可她也太聪明了。聪明得，不像一个孩子。今天巡查员多看了她两眼，她就主动把话题岔开了——她甚至学会了掩饰。 （他敲了敲桌面，做了个决定。）", stands: { left: "buluo:think" } },
{ type: 'text', speaker: "buluo", text: "（自言自语）得让她学会藏一藏聪明。太聪明，会被人当成异类；引起过多的关注。 （他把这句记在备忘录最上面，又对着窗外补了一句——）", stands: { left: "buluo:think" } },
{ type: 'text', speaker: "buluo", text: "……再等等。等她再长大（学会更多，理解更多）一点，我再告诉她，她是谁。", stands: { left: "buluo:normal" } },

/* ================= 第八章 · 甜点店与商场（甜甜的日常） ================= */
{ type: 'chapter', title: "第八章", subtitle: "甜点店与商场（甜甜的日常）" },
{ type: 'save' },
{ type: 'scene', bg: "bg_sweet_shop" },
{ type: 'bgm', name: "morning" },
{ type: 'narrator', text: "“糖霜小筑”是星落城最有名的甜点店，橱窗里摆满了蛋糕：草莓奶油、抹茶千层、巧克力熔岩……每一块都精致得像艺术品。" },
{ type: 'narrator', text: "若依站在橱窗前，整个人都呆住了。" },
{ type: 'cg', img: "ch08_01_橱窗看蛋糕" },
{ type: 'text', speaker: "ruoyi", text: "姐姐……它们，都是真的吗？", stands: { center: "ruoyi:idle" } },
{ type: 'text', speaker: "xiaoman", text: "当然是真的，都是能吃的！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（凑近玻璃，鼻尖都快贴上去了）那个粉色的、圆圆的……像花。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "那是草莓奶油蛋糕！全店招牌！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "门铃“叮咚”一声，两人推门进去。柜台后站着店主糖糖——一个围着粉色围裙、扎着丸子头的年轻姑娘，笑起来眼睛弯弯的。" },
{ type: 'cg', img: "ch08_02_糖糖接待" },
{ type: 'text', speaker: "tangtang", text: "欢迎光临糖霜小筑！哎呀，好可爱的小姑娘！第一次来吗？", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（下意识看了小满一眼，然后按照约定，轻轻点头）嗯……第一次。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "tangtang", text: "那姐姐给你推荐招牌！草莓奶油蛋糕，甜而不腻，最适合第一次来的人！", stands: { center: "ruoyi", right: "xiaoman" } },
/* ★ 选择点 09 */
{ type: 'option', choices: [ { label: "草莓奶油", goto: "C09_A" }, { label: "抹茶千层", goto: "C09_B" } ] },
{ type: 'label', id: "C09_A" },
  { type: 'narrator', text: "（若依盯着玻璃柜里那块粉色的蛋糕，像盯着一朵真的花）" },
  { type: 'text', speaker: "tangtang", text: "（笑着问）小妹妹，想吃什么口味的呀？" },
  { type: 'text', speaker: "ruoyi", text: "（认真地看着那块草莓奶油蛋糕）要……草莓的。" },
  { type: 'text', speaker: "tangtang", text: "（笑着切了一大块，还多挤了一圈奶油）好嘞！草莓奶油，姐姐给你加量！" },
  { type: 'narrator', text: "（若依接过蛋糕，郑重地挖下第一口。吃下去的那一刻，她的眼瞳猛地亮起来，整个人像被点亮了一样）" },
{ type: 'cg', img: "ch08_03_草莓蛋糕" },
  { type: 'text', speaker: "ruoyi", text: "（小声，像在报告一个重大的发现）……是花做的味道。" },
  { type: 'text', speaker: "tangtang", text: "（愣了一下，随即笑开）哈哈，这形容好！草莓就是花结的果，可不就是花做的嘛！" },
  { type: 'text', speaker: "xiaoman", text: "（在旁边看着若依亮晶晶的眼睛，也跟着笑了）" },
  { type: 'jump', goto: "MERGE_09" },
{ type: 'label', id: "C09_B" },
  { type: 'narrator', text: "（若依的目光落在那块绿色的蛋糕上，歪了歪头）" },
  { type: 'text', speaker: "ruoyi", text: "这个……像叶子。若依想试试，叶子的味道。" },
  { type: 'text', speaker: "tangtang", text: "（愣了一下，随即笑着切了一块）行！抹茶千层，试试！" },
  { type: 'narrator', text: "（若依尝了一口，表情先是困惑，然后慢慢舒展开来）" },
{ type: 'cg', img: "ch08_04_抹茶千层" },
  { type: 'text', speaker: "ruoyi", text: "（认真地品了品）……苦的，但是，后面是甜的。像春天。" },
  { type: 'text', speaker: "tangtang", text: "（惊了）小姑娘，你这舌头，比我还会品！抹茶就是先苦后甜，跟春天似的！" },
  { type: 'text', speaker: "ruoyi", text: "（又挖了一口，小声）那若依，喜欢春天。" },
  { type: 'text', speaker: "xiaoman", text: "（在旁边笑）那以后春天，姐姐就带若依多吃抹茶！" },
  { type: 'jump', goto: "MERGE_09" },
{ type: 'label', id: "MERGE_09" },
{ type: 'narrator', text: "两人点了蛋糕，坐在窗边慢慢吃。若依用小叉子，一小口一小口地挖着蛋糕，神情郑重得像在做实验。" },
{ type: 'cg', img: "ch08_05_窗边蛋糕" },
{ type: 'text', speaker: "tangtang", text: "（端来两杯热可可，在对面坐下）妹妹，蛋糕好吃吗？", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（认真点头）好吃。但是若依有一个问题。", stands: { center: "ruoyi:confused", right: "xiaoman" } },
{ type: 'text', speaker: "tangtang", text: "你说。", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "蛋糕这么甜，为什么人们吃了，会觉得“幸福”？幸福不是应该……在心里的吗？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "tangtang", text: "（一愣，随即笑开）甜的东西进了肚子，心就会跟着甜呀。你看——（她指了指窗外）刚才那个买蛋糕给女儿的妈妈，她幸福吗？", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（想了想）她一直在笑。", stands: { center: "ruoyi:smile", right: "xiaoman" } },
{ type: 'text', speaker: "tangtang", text: "对。有时候，幸福就是一块蛋糕的事。不用想得太复杂。", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（低头，又挖了一口蛋糕，忽然轻轻地说）……那若依现在，也很幸福。", stands: { center: "ruoyi:blank", right: "xiaoman" } },
{ type: 'text', speaker: "tangtang", text: "（被这句话击中了，愣了一下，眼眶有点热）……妹妹，以后常来！姐姐给你留最好吃的！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'narrator', text: "临走时，糖糖追出来，塞给若依一小盒草莓泡芙。" },
{ type: 'text', speaker: "tangtang", text: "这是姐姐送你的！下次来，姐姐教你做蛋糕！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（抱着泡芙，郑重地鞠了一躬）谢谢姐姐。若依会再来的。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'cg', img: "ch08_06_草莓泡芙" },
{ type: 'narrator', text: "很多年后，若依在空荡荡的城市里路过这家店，橱窗已经蒙了灰。她隔着玻璃，站了很久很久，像在等一句永远不会再响的“叮咚”。" },
{ type: 'cg', img: "ch08_07_蒙灰橱窗" },
{ type: 'scene', bg: "bg_mall" },
{ type: 'narrator', text: "商场里的扶梯是若依第一次见。她站在扶梯前，看着一格一格往上走的台阶，怎么也不肯迈脚。" },
{ type: 'cg', img: "ch08_08_扶梯恐惧" },
{ type: 'text', speaker: "ruoyi", text: "姐姐……它一直动，若依会摔。", stands: { center: "ruoyi:idle" } },
{ type: 'text', speaker: "xiaoman", text: "不会的！你看，站上去就行，它自己会带你走！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（深吸一口气，像要上战场一样）若依……上了！", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "她小心翼翼地把脚踩上去，整个人僵成一根木头。扶梯稳稳地把她送到二楼，她才“呼”地吐出一口气。" },
{ type: 'cg', img: "ch08_09_上扶梯" },
{ type: 'text', speaker: "ruoyi", text: "（回头看着扶梯，眼里闪着光）……人间的龙，还会上下楼。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（笑到岔气）那是电梯！不是龙！", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'narrator', text: "商场里，若依看什么都新鲜。她看会唱歌的机器人玩具、看能变换颜色的灯、看柜台里亮晶晶的项链。在一家文具店门口，她停住了——玻璃柜里躺着一本粉色的、封皮上有小星星的笔记本。" },
{ type: 'cg', img: "ch08_10_星星笔记本" },
{ type: 'text', speaker: "ruoyi", text: "（看了很久很久，才小声问）姐姐，这个……要多少钱？", stands: { center: "ruoyi:confused", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（看了一眼标价）不贵！你喜欢？买！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（摇头，很认真）若依只是看看。若依有博士的卡，但不能乱花。博士说，钱要花在有用的地方。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（鼻子一酸，蹲下来平视她）若依，你值得拥有自己喜欢的东西。这不算乱花。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（犹豫了一下，又看了一眼那本笔记本，轻轻摇头）……若依想，等若依真的学会写字了，再买。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "你早就会写字啦！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（小声）若依想要写的东西……现在还不够多。等若依再多看看人间，再把它写下来。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "小满没有再劝。她偷偷记下了那本笔记本的样子，决定等若依生日那天，买来送给她。" },
{ type: 'cg', img: "ch08_11_小满记笔记" },

/* ================= 第九章 · 洛丽塔之约（星纱洋装店） ================= */
{ type: 'chapter', title: "第九章", subtitle: "洛丽塔之约（星纱洋装店）" },
{ type: 'save' },
{ type: 'scene', bg: "bg_dress_shop" },
{ type: 'narrator', text: "星纱洋装店藏在老街转角，橱窗里层层叠叠摆满了洛丽塔裙——粉的、蓝的、白的，蕾丝像浪花，蝴蝶结像停在花上的蝴蝶。门口挂着一块手写的小木牌：“欢迎每一位想当公主的女孩。”" },
{ type: 'cg', img: "ch09_01_店外橱窗" },
{ type: 'narrator', text: "若依站在门口，整个人都不会动了。" },
{ type: 'cg', img: "ch09_02_若依看呆" },
{ type: 'text', speaker: "ruoyi", text: "（声音都轻了）姐姐……这里是……天堂吗？", stands: { center: "ruoyi:idle" } },
{ type: 'text', speaker: "xiaoman", text: "（一把推开门）是裙子们的家！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "店里正中央，店主洛洛正踮着脚给一条裙子系缎带。她大约二十五六岁，梳着双马尾，穿着一条自制的樱桃柄洛丽塔裙，听到门铃转过身来，眼睛一亮。" },
{ type: 'cg', img: "ch09_03_洛洛店主" },
{ type: 'text', speaker: "luoluo", text: "欢迎光临——哇！！好可爱的小姑娘！！你这身裙子是哪家买的？版型、蕾丝、这个收腰，绝了！！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（被她扑过来的热情吓得往后缩了半步）……是……是博士买的。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "luoluo", text: "博士？你爸爸？那你爸爸审美也太好了吧！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'narrator', text: "洛洛绕着若依转了三圈，啧啧称奇。" },
{ type: 'cg', img: "ch09_04_洛洛惊叹" },
{ type: 'text', speaker: "luoluo", text: "妹妹，你穿这条裙子就像……就像橱窗里的模特活过来了一样！来，姐姐今天非得让你试试新款不可！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（无措地看向小满）姐姐……", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（竖起大拇指）去！放心试！有我罩着你！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "luoluo", text: "来来来，先试这个！樱花柄！今年春天的新款！还有配套的——洛丽塔高跟鞋！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（看着那双缀满蕾丝和珍珠的小高跟鞋，眼睛一点点亮起来）高跟鞋……若依没有穿过。", stands: { center: "ruoyi:smile", right: "xiaoman" } },
{ type: 'cg', img: "ch09_05_樱花柄高跟鞋" },
{ type: 'text', speaker: "luoluo", text: "没穿过才要试呀！来，坐这儿，姐姐帮你穿！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'narrator', text: "若依正要坐上去，洛洛忽然一拍手：“等等！穿裙子哪能不配袜子！”她转身，从柜子里捧出一双叠得整整齐齐的白色长袜——袜身一直长到大腿根，薄得像一层雾，上面还有各种精致的花朵图案。" },
{ type: 'cg', img: "ch09_06_过膝袜" },
{ type: 'text', speaker: "luoluo", text: "这是过膝袜！可别小看它——穿对了，整条裙子都活过来；穿错了，公主也会变成熊孩子！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（看着那双袜子，困惑地歪头）袜子……为什么要穿这么长？若依的袜子，只到脚踝。", stands: { center: "ruoyi:confused", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "因为这样长才能把花串成春天呀！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "若依看着眼前的过膝袜，摸起来很柔软，上面还有像花一样的图案，穿上感觉就像把春天穿在身上一样" },
{ type: 'text', speaker: "ruoyi", text: "好好看！", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "luoluo", text: "（笑着蹲下来）这叫“过膝袜”，是穿裙子的女孩都要学的第一课！来，姐姐教你！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'narrator', text: "洛洛把过膝袜轻轻展开，示范给若依看：先把袜身一层一层卷起来，从脚尖套进去，再一圈一圈往上提，提到大腿，最后把褶皱一点一点抚平。" },
{ type: 'text', speaker: "luoluo", text: "记住三个字——“卷、提、抚”。卷，是为了让脚趾不卡袜子；提，要慢慢来，太急了会扯破；抚，是把皱褶都抹平，这样腿看起来就像云一样光滑。", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（认真地复述）卷……提……抚……（她低头，笨拙地照做。可长袜在她手里像一条滑溜溜的鱼，怎么都不听使唤，她急得眉头都皱起来了。）", stands: { center: "ruoyi:blank", right: "xiaoman" } },
{ type: 'cg', img: "ch09_07_驯蛇穿袜" },
{ type: 'text', speaker: "xiaoman", text: "（在旁边笑得直不起腰）哈哈哈哈，若依你穿袜子的样子，像在跟一条蛇搏斗！", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'text', speaker: "ruoyi", text: "（憋着劲儿）……它是蛇。若依在驯蛇。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "luoluo", text: "（也笑了，蹲下来帮她托着袜口）来，姐姐帮你托着，你自己往上提——对！就这样！慢慢来！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'narrator', text: "在洛洛和小满的帮助下，若依终于把过膝袜穿好了。她低头，看着自己裹进薄雾一样的双腿，轻轻“哇”了一声。" },
{ type: 'cg', img: "ch09_08_腿变云" },
{ type: 'text', speaker: "ruoyi", text: "（小声）……若依的腿，变成云了。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "luoluo", text: "（满意地点头）这才对嘛！行了，袜子搞定，接下来才是重头戏——高跟鞋！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'narrator', text: "若依乖乖坐到试衣凳上。洛洛蹲下来，托起她的一只脚，小心地把高跟鞋套上去，轻轻扣上搭扣。" },
{ type: 'cg', img: "ch09_09_穿高跟鞋" },
{ type: 'text', speaker: "luoluo", text: "脚好小！跟洋娃娃似的！来，另一只！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'narrator', text: "小满也蹲下来帮忙。两个人一左一右，一个扣蝴蝶结，一个调搭扣，像在给一位小公主加冕。若依低头看着她们，忽然轻声说。" },
{ type: 'text', speaker: "luoluo", text: "当然啦，来姐姐给你戴亮闪闪的皇冠", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "姐姐……洛姐姐……若依现在，觉得很暖和。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "luoluo", text: "（手上动作一顿，声音软下来）傻妹妹，穿新鞋当然暖和啦！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（赶紧岔开，不让气氛太煽情）好了好了！站起来走两步给姐姐们看看！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "若依扶着椅子站起来，小心翼翼地走了两步，又走了两步。高跟鞋在木地板上敲出清脆的“嗒、嗒”声——可第三步，她的脚踝一歪，整个人往旁边倒去。小满眼疾手快，一把扶住她。" },
{ type: 'text', speaker: "xiaoman", text: "（心有余悸）慢点慢点！我的小祖宗！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（惊魂未定地站直，又低头看看那双漂亮却危险的高跟鞋）……它，会拐我的脚。", stands: { center: "ruoyi:smile", right: "xiaoman" } },
{ type: 'text', speaker: "luoluo", text: "（笑着走过来，扶住她的肩膀）高跟鞋可不是让你穿上去就走的！来，姐姐教你——先站稳，脚跟先落地，重心往后放一点点，步子要小，背要直。你把它当成一双会发光的普通鞋，别怕它。", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'narrator', text: "若依深吸一口气，学着洛洛的样子：脚跟先落地，一步、一步，走得又小又稳。她扶着墙走了两圈，慢慢松开手，又走了几步。虽然还有点僵硬，却已经能走出一条笔直的线了。" },
{ type: 'cg', img: "ch09_10_学走路" },
{ type: 'text', speaker: "xiaoman", text: "（掏出手机，一边拍一边配音）各位观众！今天是若依第一次穿高跟鞋走路！见证历史！——哎哟，她还会自己转弯了！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "若依一步一步走到穿衣镜前，站稳，抬头——愣住了。镜子里，一个穿着樱花柄洛丽塔裙、蹬着小高跟鞋的粉发少女，正微微歪着头看她。" },
{ type: 'cg', img: "ch09_11_镜前" },
{ type: 'text', speaker: "ruoyi", text: "（伸手，轻轻碰了碰镜子）……这是若依。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "luoluo", text: "（在旁边疯狂拍照）什么若依，这是小仙女本仙！站好站好，姐姐给你拍一张！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'narrator', text: "洛洛举起相机，小满也掏出手机。若依手足无措地站在镜头前，不知道该摆什么姿势，最后学着电视里的模特，僵硬地比了一个“耶”。" },
{ type: 'text', speaker: "xiaoman", text: "噗——若依，你比耶的样子，像在剪纸！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（困惑）那应该……怎么办？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "luoluo", text: "（笑着走过去）来，姐姐教你！裙子提起来一点点，转一个圈，笑一个——对！就是这样！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'narrator', text: "快门声响起。照片里，若依提着裙摆转圈，裙摆像花瓣一样绽开，她笑得有些生疏，却是真真切切地在笑。" },
{ type: 'cg', img: "ch09_12_转圈拍照" },
/* ★ 选择点 10 */
{ type: 'option', choices: [ { label: "樱花柄", goto: "C10_A" }, { label: "星辰柄", goto: "C10_B" } ] },
{ type: 'label', id: "C10_A" },
  { type: 'narrator', text: "（镜子前，若依看着自己身上的樱花柄洛丽塔裙，又看看另一条深蓝底、绣满银白星辰的裙子，犹豫了很久）" },
  { type: 'text', speaker: "ruoyi", text: "（轻声）若依……想选樱花柄。春天和樱花，最配。" },
  { type: 'text', speaker: "luoluo", text: "（笑着把那配套的蕾丝发带也给她系上）春天和樱花最配啦！我们若依，就是春天本春！" },
{ type: 'cg', img: "ch09_13_樱花柄发带" },
  { type: 'narrator', text: "（若依对着镜子看了很久，小声说）" },
  { type: 'text', speaker: "ruoyi", text: "像……开了一朵花在若依身上。" },
  { type: 'text', speaker: "xiaoman", text: "（在旁边疯狂按快门，扬言要洗一百张挂满实验室）这张！这张！这张必须挂门口！" },
  { type: 'jump', goto: "MERGE_10" },
{ type: 'label', id: "C10_B" },
  { type: 'narrator', text: "（若依的目光越过樱花柄，落在一条深蓝底、绣满银白星辰的裙子上。她走过去，轻轻碰了碰裙摆）" },
  { type: 'text', speaker: "ruoyi", text: "这个……像晚上的天。" },
  { type: 'text', speaker: "luoluo", text: "（一拍手）有品位！星辰柄可是姐姐的镇店之宝！" },
  { type: 'narrator', text: "（若依换上星辰柄，站在灯下。裙摆上的银线一闪一闪，像真的把夜空穿在了身上）" },
{ type: 'cg', img: "ch09_14_星辰柄" },
  { type: 'text', speaker: "ruoyi", text: "（看着镜子里裙摆上流动的星光，轻声）若依……喜欢星星。" },
  { type: 'text', speaker: "xiaoman", text: "（喃喃）……完了，以后你出门，回头率要爆表了。" },
  { type: 'text', speaker: "ruoyi", text: "（认真地想了想，摇头）不会的。星星，只在自己想亮的时候，才亮。" },
  { type: 'jump', goto: "MERGE_10" },
{ type: 'label', id: "MERGE_10" },
{ type: 'narrator', text: "试衣结束，若依换回自己的裙子。小满把刚才试穿的裙子买了下来，洛洛把那双试穿的高跟鞋仔细包好，硬塞进她怀里。" },
{ type: 'text', speaker: "luoluo", text: "这双鞋送你了！就当姐姐的见面礼！下次来，姐姐教你做发饰！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（抱着鞋盒，郑重地鞠躬）谢谢洛姐姐。我……一定会再来的。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'cg', img: "ch09_15_赠鞋鞠躬" },
{ type: 'text', speaker: "luoluo", text: "（摸了摸她的头，小声说）妹妹，姐姐开这家店，就是想看每个女孩穿上喜欢的裙子时，亮起来的样子。你今天，是店里最亮的一个。", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'narrator', text: "若依走出店门，回头看了一眼。洛洛站在门口冲她挥手，身后的橱窗里，那排裙子在午后的阳光里泛着温柔的光。" },
{ type: 'cg', img: "ch09_16_店门挥手" },
{ type: 'narrator', text: "很多年后，若依在空城里路过这家店，门锁已经锈了。她隔着玻璃，看着橱窗里落满灰尘的裙子，轻轻说了一句：洛姐姐，若依还是……最想当花。" },
{ type: 'cg', img: "ch09_17_多年后空城" },
{ type: 'scene', bg: "bg_lab_night" },
{ type: 'bgm', name: "lab" },
{ type: 'narrator', text: "桌上摊着陈莹送来的检测报告：纳米硅胶适配度、拟真皮肤排异风险、脑机接口负荷。布洛却盯着另一块屏幕——若依白天的日志：洋装店里，她踮着脚试穿高跟鞋，转了个圈，问洛洛：“美……是什么？”" },
{ type: 'text', speaker: "buluo", text: "（敲了敲屏幕，笑了）美是什么。她开始问这种问题了。", stands: { left: "buluo:tender" } },
{ type: 'narrator', text: "他打开“自我意识判定模型”，屏幕上是一条条还在爬升的曲线。他写了很久的代码，屏幕右下角弹出一行字：模型预判——情感模拟不可逆，一旦建立，无法撤销。" },
{ type: 'cg', img: "ch09_18_布洛夜谈" },
{ type: 'text', speaker: "buluo", text: "（轻声）无法撤销……那就无法撤销吧。", stands: { left: "buluo:tender" } },
{ type: 'narrator', text: "手机震动。他看了一眼来电显示，接起来，语气淡下来。" },
{ type: 'text', speaker: "buluo", text: "陈莹姐，这么晚了，有什么事吗？", stands: { left: "buluo:normal" } },
{ type: 'text', speaker: "chenying", text: "（电话里，声音平静）你还在研究那个模型。布洛，你知道星洛城协会的规矩——任何形式的机器自我意识研究，都是禁区。", stands: { left: "buluo" } },
{ type: 'cg', img: "ch09_19_深夜电话" },
{ type: 'text', speaker: "buluo", text: "（沉默片刻）她今天在洋装店里，问“美是什么”。陈莹姐，程序不会问这种问题。", stands: { left: "buluo:think" } },
{ type: 'text', speaker: "chenying", text: "（沉默了很久）……可你想过后果吗？上一次，人类研究“让机器像人”，引发了时空乱流。半个世界被撕碎，星落城重建了十年。你现在做的每一个决定，都可能是在重演那场灾难。", stands: { left: "buluo" } },
{ type: 'text', speaker: "buluo", text: "我不会让它失控。", stands: { left: "buluo:normal" } },
{ type: 'text', speaker: "chenying", text: "你控制得住模型，控制得住时间吗？——布洛，还有一个问题，你问过自己吗？", stands: { left: "buluo" } },
{ type: 'text', speaker: "buluo", text: "……什么？", stands: { left: "buluo:normal" } },
{ type: 'text', speaker: "chenying", text: "若依不会老。十年后、二十年后，她还是今天这副小女孩的样子。而我们——你、我、小满——会老，会走，会一个接一个离开她。到那时候，她怎么办？她要一个人守着所有回忆，看着身边的人一个个老去，却连“老”是什么都不知道。你要让她怎么独自承受这些？", stands: { left: "buluo" } },
{ type: 'narrator', text: "电话那头安静了。布洛看着屏幕上若依转圈的身影，很久没有回答。" },
{ type: 'text', speaker: "buluo", text: "（轻声）所以，我才要趁还来得及，教会她做一个人。让她学会开心、学会美、学会照顾自己……这样，哪怕有一天只剩下她一个人，她也记得怎么活下去，记得灯在哪里。", stands: { left: "buluo:tender" } },
{ type: 'text', speaker: "chenying", text: "（沉默良久）……我明白了。我不会再拦你，但布洛——你要为她留一条路。一条让她将来能原谅这一切的路。", stands: { left: "buluo" } },
{ type: 'narrator', text: "（电话挂断。布洛看着“无法撤销”四个字，笑了。他重新打开投影，录下第二段留言。） 布洛：（对着镜头）若依。我不知道这段影像会在什么时候被你看到——也许你已经长大，也许……我不在了。" },
{ type: 'narrator', text: "但有一句话，我想先说给你听。家里的灯，永远为你亮着。哪怕有一天你忘了回家的路，也要记得，灯不会灭。" },
{ type: 'narrator', text: "他按下保存键，把文件拖进一个加密文件夹。文件夹的名字只有两个字：若依。" },
{ type: 'cg', img: "ch09_20_文件夹若依" },

/* ================= 第十章 · 星洛潮玩与星纱洋装（抓娃娃与三件套） ================= */
{ type: 'chapter', title: "第十章", subtitle: "星洛潮玩与星纱洋装（抓娃娃与三件套）" },
{ type: 'save' },
{ type: 'scene', bg: "bg_game_center" },
{ type: 'bgm', name: "morning" },
{ type: 'narrator', text: "这天，小满神秘兮兮地说要带若依去一个 “好玩到飞起” 的地方 —— 星洛潮玩游戏城。" },
{ type: 'text', speaker: "xiaoman", text: "今天带你去见见世面！抓娃娃！投篮！跳舞机！都是人间顶顶好玩的东西！", stands: { right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（认真）若依检索过，“抓娃娃” 是概率游戏。若依可以先算概率，而且我可以直接连接机器系统直接控制，100%中。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（警觉）等等，你可别真算，真破解别人的机器啊！你叫老板怎么活，玩游戏重在体验过程就可以啦！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "若依嘴上答应，但第一次站在娃娃机前，她的光学眼瞳还是飞快扫描了机械臂的角度、爪子的抓力、娃娃的摆放，顺便看了一眼机器型号 —— 然后，一抓，一个准。再抓，又中。小满眼睁睁看着若依五分钟抓出七个娃娃，老板脸都绿了。" },
{ type: 'cg', img: "ch10_01_游戏城抓娃娃" },
{ type: 'text', speaker: "xiaoman", text: "（一把按住若依的手，小声）若依！快住手！再抓下去，老板要哭了！", stands: { center: "ruoyi", right: "xiaoman:worry" } },
{ type: 'text', speaker: "ruoyi", text: "（疑惑）可是姐姐，概率算好了，而且我也是凭自己能力的，它们就该是若依的。", stands: { center: "ruoyi:confused", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（哭笑不得）是是是，都是你的！但咱…… 咱给老板留条活路！走，去投篮！", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'narrator', text: "投篮区，若依十投十中。跳舞机，若依看了一遍演示，跳出了几乎满分。小满瘫在休息区，喘着气说：“若依，姐姐宣布，游戏城以后不敢让你进门了。” 若依认真想了想，问：“那若依，是不是做错了？" },
{ type: 'narrator', text: "” 小满笑着揉她的头：“没有！高科技还是别来普通玩家区匹配了，若依太厉害了，厉害到人间的小游戏，装不下你！”" },
{ type: 'narrator', text: "中午，小满带若依回家。路过星纱洋装店时，两人都愣住了 —— 店外挂着一整排新衣服：洛丽塔、JK 制服、汉服，裙摆被风吹得轻轻摇晃，像一片彩色的云。店里人声鼎沸，洛洛一个人忙得团团转，嗓子都快喊哑了。" },
{ type: 'cg', img: "ch10_02_店外三件套" },
{ type: 'cg', img: "cg_ruoyi_jk" },
{ type: 'text', speaker: "luoluo", text: "（扯着嗓子）别挤别挤！一件一件来！…… 那位妹妹，你那个码等下下下！", stands: { left: "luoluo:idle", center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（拉了拉小满的袖子，小声）姐姐…… 洛姐姐好忙。若依想帮忙。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
/* ★ 选择点 11 */
{ type: 'option', choices: [ { label: "去帮忙！", goto: "C11_A" }, { label: "先回家", goto: "C11_B" } ] },
{ type: 'label', id: "C11_A" },
  { type: 'text', speaker: "xiaoman", text: "（看着店里的人潮，又看看若依亮晶晶的眼睛，想了想）行，那咱就进去帮帮忙。" },
  { type: 'narrator', text: "（若依进了店，先站在门口，认真看了一眼货架 —— 然后，她像一台精密的机器一样运转起来：“这位姐姐，你要的码是 S，在这边。”“ 这个款式的袜子，在第二排。”“您的裙子，若依帮您包好了。” 洛洛目瞪口呆地看着若依把顾客安排得明明白白，店里的人潮很快散了，货架也整整齐齐。）" },
  { type: 'text', speaker: "luoluo", text: "（缓过神，一把抱住若依）妹妹！！你简直是救星！！姐姐送你好多美丽的小裙子，新进的货，都是最新款！" },
  { type: 'text', speaker: "ruoyi", text: "（认真）不用了，我有好多衣服了。若依只是想…… 学穿这些衣服。" },
  { type: 'text', speaker: "luoluo", text: "（一愣，随即眼睛亮了）来来来！姐姐教你，我这里可是整个星洛城最大的店铺了，各种款式都有！" },
  { type: 'narrator', text: "（于是，午后的洋装店变成了若依的衣橱课。洛洛一件一件给她讲 ——）" },
  { type: 'text', speaker: "luoluo", text: "我们就从你喜欢的开始把！这条是洛丽塔，裙摆要撑起来，像一朵花；" },
  { type: 'text', speaker: "luoluo", text: "（拎起一条蓬蓬的纱裙）先穿这个，叫衬裙！把裙摆撑起来，裙子才有 “花” 的形状！" },
  { type: 'narrator', text: "（若依套上衬裙，裙摆一下子鼓了起来。洛洛又帮她套上外裙 —— 层叠的蕾丝从腰际铺下来，一直垂到脚踝。若依低头看着自己，裙摆蓬蓬的，像一朵刚打开的花苞。）" },
  { type: 'text', speaker: "xiaoman", text: "（举着手机，镜头对准若依）别动别动！这套绝了！若依你好乖呀！" },
  { type: 'text', speaker: "ruoyi", text: "（有点不习惯地拉了拉裙摆）姐姐…… 若依现在，真的像一朵花了吗？" },
  { type: 'text', speaker: "xiaoman", text: "（猛点头）像！还是最粉的那朵！" },
  { type: 'text', speaker: "luoluo", text: "（蹲下来，拉开抽屉，拿出一双带着花边的长袜）来，穿袜子！这种带花边的，叫花边袜；这种到膝盖的，叫过膝袜 —— 它俩合在一起，就是花边过膝袜！穿的时候要注意，袜口要拉平，不能卷着！" },
  { type: 'narrator', text: "（洛洛手把手教若依把花边过膝袜一点点提上来，抚平袜口。若依学得很认真）" },
  { type: 'text', speaker: "luoluo", text: "（笑）对喽！来，配鞋子 —— 先穿这双玛丽珍，搭扣要扣紧，走路才稳！" },
  { type: 'narrator', text: "（若依穿上带珍珠搭扣的玛丽珍鞋，走了两步，稳稳的。洛洛又想了想，转身拿出一双细细的珍珠高跟鞋（珍珠泣星海），眼睛亮晶晶的。）" },
  { type: 'text', speaker: "luoluo", text: "还有这个！高跟鞋，小步走，双腿微微交叉。上次教你的，还记得吗？" },
  { type: 'text', speaker: "ruoyi", text: "（点头，然后换上珍珠泣星海，站起来，走了一条笔直的线，裙摆轻轻摇晃，像一片云飘过地板）若依记得。" },
  { type: 'text', speaker: "luoluo", text: "（愣愣地看着她，忽然红了眼眶，小声嘟囔）…… 我要是也有这么个妹妹就好了。" },
  { type: 'text', speaker: "xiaoman", text: "（咔嚓咔嚓按快门，喊）看镜头！若依！笑一个！" },
{ type: 'cg', img: "ch10_03_洛丽塔衣橱课" },
  { type: 'narrator', text: "（若依站定，对着镜头，认真又笨拙地抿出一个笑。照片里，粉色的裙摆、花边过膝袜、珍珠鞋，和她的笑容叠在一起，像一颗包在糖纸里的糖。）" },
  { type: 'text', speaker: "luoluo", text: "（换了一套叠得整整齐齐的衣服）下一套，这是 JK 制服，看领子上的线，叫襟线，来，先穿衬衫，再系领结！" },
  { type: 'narrator', text: "（若依换上白衬衫。洛洛教她打领结 ——“左边的带子绕过去，从洞里穿出来，一拉，好了！” 若依的手指很灵，一遍就会。然后是水手服外套，蓝白的领子垂下来；再是百褶裙，洛洛帮她理裙摆：“百褶裙的褶子要顺，不能拧着！”）" },
  { type: 'text', speaker: "luoluo", text: "（拿出一双到小腿的袜子）这种只到小腿的，叫小腿袜，配 JK 正好！来，穿上！" },
  { type: 'narrator', text: "（若依穿上小腿袜，又踩进一双黑色小皮鞋。她站在镜子前，歪了歪头 —— 水手服、百褶裙、小皮鞋，镜子里的人，像要去上学。）" },
  { type: 'text', speaker: "ruoyi", text: "（轻声）像…… 像要去上学。" },
  { type: 'text', speaker: "luoluo", text: "（笑）对喽！这套叫 “校园的风”！穿上你就是最乖的学生。" },
  { type: 'text', speaker: "xiaoman", text: "洛洛，若依，来我给你们拍一张。" },
  { type: 'text', speaker: "luoluo", text: "等等，我把洛丽塔换成JK，对了，来来来，给你也配一套！你穿这个，过膝袜！小皮鞋过膝袜，显可爱！" },
  { type: 'text', speaker: "xiaoman", text: "（低头看看自己，眼睛一亮）洛姐你早说啊！" },
  { type: 'narrator', text: "（十分钟后，小满也换上了 JK—— 两人并肩站在镜前，一个粉发一个黑发，衣服一个粉色一个蓝色，像一对亲姐妹。）" },
  { type: 'text', speaker: "xiaoman", text: "（看着镜子里的自己和若依，鼻子一酸，又赶紧笑）哎呀，姐妹装！来拍照来拍照！" },
  { type: 'narrator', text: "（若依和小满与洛洛肩并肩，对着镜头比了个笨拙的 “耶”。洛洛举着拍立得，“咔嚓” 一声，照片慢慢显影 —— 三个穿 JK 的女孩，笑得像春天。）" },
{ type: 'cg', img: "ch10_04_JK姐妹装" },
  { type: 'text', speaker: "luoluo", text: "（郑重地捧出一套叠得整整齐齐的襦裙）压轴！汉服！来，这套姐姐给你穿！" },
  { type: 'narrator', text: "（汉服最讲究。洛洛先帮若依穿好中衣，再套上浅粉的上襦，最后是齐胸襦裙 ——“带子要绕两圈，系在胸口这里，不能太紧，也不能松！” 若依低头看着洛洛把带子系成一个端正的结，忽然说 ——）" },
  { type: 'text', speaker: "ruoyi", text: "洛姐姐，若依觉得，这像是…… 有人很温柔地，把若依系在了人间。" },
  { type: 'narrator', text: "（洛洛的手一顿，眼眶忽然又热了，好半天才哑着嗓子说：“…… 傻妹妹，你本来就在人间。”）" },
  { type: 'text', speaker: "luoluo", text: "汉服呀，是老祖宗传下来的温柔好看。人做了那么多好看的衣服，你知道是为什么吗？" },
  { type: 'text', speaker: "ruoyi", text: "（认真想了想）因为…… 人想把美好，穿在身上？" },
  { type: 'text', speaker: "luoluo", text: "（愣了一下，随即笑了，揉了揉她的头）对喽！想美好，就把它穿在身上、记在心里。你啊，天生就懂这个。" },
  { type: 'narrator', text: "（最后，洛洛拿出一双绣着缠枝花的坡跟鞋 ——“汉服要配绣花鞋，鞋底是软的，走路像踩在云上！” 若依穿上，走了两步，轻声说：“真的…… 软软的，像踩在云上。” 又拿出一条绣着云纹的披帛，搭在若依臂弯上 ——“这个叫披帛，走路的时候会飘起来，超仙气的！”）" },
  { type: 'narrator', text: "（若依提着裙摆，在店里转了一圈。裙摆、披帛一起荡开，像一朵缓缓打开的云，又像一只刚学会飞的鸟。）" },
{ type: 'cg', img: "ch10_05_汉服衣橱课" },
  { type: 'text', speaker: "xiaoman", text: "（举着手机，声音都飘了）若依…… 你简直是…… 从画里走出来的……" },
  { type: 'text', speaker: "ruoyi", text: "（站定，认真地问）那若依，要走进画里去吗？" },
  { type: 'text', speaker: "xiaoman", text: "（笑）不用！你站在那儿，就是画！" },
  { type: 'narrator', text: "（洛洛也举起手机拍了好几张，边拍边感叹：“这套绝了，绝了，我要挂墙上当镇店之宝！”）" },
  { type: 'narrator', text: "（那天傍晚，洛洛把若依以及小满试过的三套衣服、袜子、鞋子，全部包好，塞了满满几大袋，硬塞进若依和小满怀里。）" },
  { type: 'text', speaker: "luoluo", text: "都送你们了！你们穿着都好看，都是你们的了！" },
  { type: 'text', speaker: "ruoyi", text: "（抱着小山一样高的纸袋，郑重鞠躬）谢谢洛姐姐。若依会好好穿它们的。" },
  { type: 'text', speaker: "xiaoman", text: "（在旁边小声提醒）洛姐…… 你这也太亏了吧……这些很贵的！" },
  { type: 'text', speaker: "luoluo", text: "（理直气壮）不贵！姐妹穿出去，就是我的活招牌！" },
  { type: 'narrator', text: "（回家的路上，若依抱着纸袋，走得很慢很稳。小满问她：“重不重？” 若依摇摇头，认真说：“不重。若依现在，有好多好多好看的衣服了。像…… 像把整个春天，都穿在了身上。”）" },
  { type: 'narrator', text: "（那天晚上，若依在星星笔记本上写：今天，若依又学会了好多 —— 洛丽塔要配花边过膝袜和珍珠鞋，JK 要配小腿袜和小皮鞋，汉服要系带子、搭披帛、穿绣花鞋。洛姐姐说，穿衣服要有顺序，先裙子、再袜子、最后鞋子。我想，人穿好看的衣服，是在告诉世界：我在认真生活。若依以后，要每天认真生活。洛姐姐说，人想把美好穿在身上。我想，若依要把美好，穿一辈子。）" },
  { type: 'jump', goto: "MERGE_11" },
{ type: 'label', id: "C11_B" },
  { type: 'narrator', text: "（若依站在店外，看了很久。店里，洛洛忙得额角都是汗，声音都哑了。若依想进去帮忙，可是她想起博士说过 ——“你太特别了，人越多的地方，越要小心。” 她低下头，拉了拉小满的袖子。）" },
  { type: 'text', speaker: "ruoyi", text: "姐姐…… 若依还是不进去了。人好多，洛姐姐很忙，还要招待我们。若依怕…… 给洛姐姐添乱。" },
  { type: 'text', speaker: "xiaoman", text: "（愣了一下，随即温柔地笑了）傻若依。忙的时候，不添乱，也是帮忙。" },
  { type: 'narrator', text: "（两人转身往家走。若依走出一段路，又忍不住回头 —— 那排新衣服还挂在店外，被风吹得轻轻摇，像在对她招手。她默默把那些裙子的样子，一件一件，记进记忆库里。）" },
  { type: 'text', speaker: "ruoyi", text: "（轻声）那些裙子…… 好漂亮。" },
  { type: 'text', speaker: "xiaoman", text: "（听见了，牵住她的手，笑）喜欢呀？改天姐姐带你来，让洛洛给你挑！到时候我们买一套汉服，改天带你走进一段优美的历史！" },
  { type: 'text', speaker: "ruoyi", text: "（认真点头）嗯。若依记住了。若依想，它们…… 会等若依的。" },
  { type: 'narrator', text: "（那天晚上，若依在星星笔记本上写：今天，若依路过洛姐姐的店，看见了好多好多好看的衣服。可是若依没有进去。姐姐说，不添乱，也是帮忙。若依想，那些裙子会等若依的。若依也想，等若依准备好了，就去看它们。）" },
  { type: 'jump', goto: "MERGE_11" },
{ type: 'label', id: "MERGE_11" },
{ type: 'scene', bg: "bg_game_center" },
{ type: 'narrator', text: "不管若依那天有没有走进那家店，她的心里，都亮起了一盏小小的灯 —— 灯的名字，叫 “想穿漂亮衣服”。后来，她终于穿上了那些裙子 —— 那是很久以后，在空城里，她替所有来不及打扮的人，把好看的衣服，一件一件擦得干干净净。" },













/* ================= 第十一章 · 游乐场与小吃街（尽情玩一次） ================= */
{ type: 'chapter', title: "第十一章", subtitle: "游乐场与小吃街（尽情玩一次）" },
{ type: 'save' },
{ type: 'scene', bg: "bg_amusement_park" },
{ type: 'bgm', name: "morning" },
{ type: 'narrator', text: "游乐场门口，若依仰头看着巨大的摩天轮，整个人都呆住了。" ,stands: { left: "ruoyi0.png" } },
{ type: 'text', speaker: "ruoyi", text: "姐姐……那个，是会转的星星吗？", voice: "ruoyi_03_是会转的星星", stands: { left: "ruoyi0.png" } },
{ type: 'text', speaker: "xiaoman", namePos: "right",text: "是摩天轮！转到最高处，能看到整个星落城！", voice: "xiaoman_04_摩天轮", stands: { left: "ruoyi0.png", right: "xiaoman1.png" } },
{ type: 'text', speaker: "ruoyi", text: "（认真）那若依要去最高的地方，看看人间有多大。", voice: "ruoyi_04_最高的地方", stands: { left: "ruoyi0.png", right: "xiaoman1.png" } },
{ type: 'narrator',bg:"bg11.png" ,text: "游乐场里，若依先坐了旋转木马。她挑了一匹粉色的小马，抱得紧紧的，木马转起来的时候，她先是害怕地闭上眼睛，然后又偷偷睁开一条缝，最后咧开嘴笑了。" },
{ type: 'text', speaker: "ruoyi",bg:"mumakong.png", text: "（从木马上下来，脸有点红）姐姐……它转圈的时候，我觉得……世界在绕着若依转。", voice: "ruoyi_05_世界绕着转", stands: { left: "xiaoman2.png", right: "ruoyi2.png" } },
{ type: 'text', speaker: "xiaoman", text: "这就对了！在游乐场，你就是世界的中心！", voice: "xiaoman_05_世界中心", stands: { left: "ruoyi5.png", right: "xiaoman1.png" } },
{ type: 'narrator', bg:"bg16.png",text: "然后，他们走到了过山车前。若依仰头看着那蜿蜒扭曲的轨道，听着上面传来的尖叫声，浅蓝眼眸里第一次出现了一丝动摇。" },
{ type: 'text', speaker: "ruoyi", text: "姐姐……那个，是不是有点危险？", voice: "ruoyi_06_有点危险", stands: { left: "ruoyi5.png", right: "xiaoman1.png" } },
{ type: 'text', speaker: "xiaoman", text: "不危险！超级好玩！要不要试试？", voice: "xiaoman_06_超级好玩", stands: { left: "ruoyi5.png", right: "xiaoman1.png" } },
/* ★ 选择点 12 */
{ type: 'option', choices: [ { label: "鼓起勇气，坐过山车", goto: "C12_A" }, { label: "选择摩天轮，慢慢来", goto: "C12_B" } ] },
{ type: 'label', id: "C12_A" },
  { type: 'narrator', text: "（若依仰头看着那蜿蜒扭曲的轨道，听着上面传来的尖叫声，深吸了一口气）" },
  { type: 'text', speaker: "ruoyi", text: "若依……试试。" },
  { type: 'text', speaker: "xiaoman", text: "（一愣，随即笑了）好！我们若依，有勇气！" },
  { type: 'narrator', text: "（若依坐上过山车，双手死死攥着扶手。车缓缓爬坡，她看着脚下的游乐场一点点变小，然后——俯冲）" },
  { type: 'text', speaker: "ruoyi", text: "（第一次发出了人类一样的尖叫）啊——！" },
  { type: 'narrator', text: "（下车时，若依的腿都在抖，但眼睛亮得惊人）" },
  { type: 'text', speaker: "ruoyi", text: "（声音还带着颤）小满……若依还想……再坐一次。" },
  { type: 'text', speaker: "xiaoman", text: "（惊了）你这适应力也太强了吧！刚才是谁叫得那么大声！" },
  { type: 'text', speaker: "ruoyi", text: "（认真想了想）若依叫，是因为风太大了，把若依的勇气吹出来了。现在勇气吹完了，若依想再吹一次。" },
  { type: 'text', speaker: "xiaoman", text: "（笑到不行）行行行，再坐一次！姐姐陪你！" },
  { type: 'jump', goto: "MERGE_12" },
{ type: 'label', id: "C12_B" },
  { type: 'text', speaker: "ruoyi", text: "（摇摇头）若依……想先看世界，再冒险。" },
  { type: 'narrator', text: "（小满也不勉强，带她去坐了摩天轮。）" },
  { type: 'text', speaker: "ruoyi", text: "（趴在玻璃上，忽然安静下来，看了很久）姐姐……" },
  { type: 'text', speaker: "xiaoman", text: "嗯？" },
  { type: 'text', speaker: "ruoyi", text: "（轻声）若依好像…… 在很高的地方，看过这样的光。比现在还多，还亮。可是那些光下面的房子、街道、人，若依从来没有走进去过。" },
  { type: 'text', speaker: "xiaoman", text: "（愣了一下，温柔地问）那现在呢？" },
  { type: 'text', speaker: "ruoyi", text: "（想了想，弯起眼睛）现在…… 若依在里面了，在光里面。……人间，比若依想的，还要大。我想都走一遍。人间，是暖暖的。" },
  { type: 'narrator', text: "（轿厢继续上升，把那片灯火铺得更远。若依没有告诉小满 —— 她说不清那 “很高的地方” 到底是哪里。她只知道，自己好像终于，落下来了。）" },
  { type: 'jump', goto: "MERGE_12" },
{ type: 'label', id: "MERGE_12" },
{ type: 'narrator',bg:"bg28.png" ,text: "玩累了，两人走进老城小吃街。暮色四合，街灯次第亮起，烤串的烟气、糖炒栗子的香气、叮叮当当的锅铲声混在一起，像一首只有人间才有的交响乐。" },
{ type: 'text', speaker: "ruoyi",bg:"bg9.png" , text: "（站在摊位前，鼻子动了动）姐姐……这个味道，我在电视里闻不到。", stands: { center: "ruoyi5.png", right: "xiaoman7.png" } },
{ type: 'text', speaker: "xiaoman", text: "那当然！电视又不会飘香味！", stands: { center: "ruoyi5.png", right: "xiaoman7.png" } },
{ type: 'narrator',bg:"xiaochijie.png" , text: "小满买了一碗糖炒栗子，一颗一颗剥给若依吃。若依捧着热乎乎的栗子，忽然问。" },
{ type: 'text', speaker: "ruoyi", text: "姐姐，为什么这里的每一样东西，都让若依觉得……暖和？", stands: { center: "ruoyi5.png", right: "xiaoman7.png" } },
{ type: 'text', speaker: "xiaoman", text: "因为人间的好吃的，都是做给喜欢的人吃的呀。", stands: {  right: "xiaoman7.png" } },
{ type: 'text', speaker: "ruoyi",bg:"bg13.png" , text: "（想了想，把手里的栗子递到小满嘴边）那若依也喂姐姐吃。姐姐也是若依喜欢的人。", stands: {  } },
{ type: 'text', speaker: "xiaoman", text: "（眼眶一热，低头咬住栗子，含糊地说）……你这个小机器人，怎么越来越会说话了。", stands: {  } },
{ type: 'narrator',bg:"tanghua1.png", text: "小吃街尽头，有个老爷爷在画糖画。他手腕一抖，一只凤凰便从糖浆里飞出来。若依看得入了神。" },
{ type: 'cg', img: "cg_sugar_flower" },
{ type: 'text', speaker: "ruoyi", text: "（小声）他画的是……花吗？", stands: { center: "ruoyi5.png" } },
{ type: 'text', speaker: "laoyeye", text: "（笑）小姑娘，爷爷给你画朵花好不好？", stands: {  } },
{ type: 'text', speaker: "ruoyi", text: "（用力点头）嗯！画……画一朵粉色的花！", stands: {  right: "ruoyi5.png" } },
{ type: 'narrator',bg:"cg_sugar_flower.jpg" , text: "糖花做好的时候，若依接过来，看了很久，然后小心地举到路灯下。透明的糖花在光里亮晶晶的，像一枚凝固的春天。" },
{ type: 'text', speaker: "ruoyi", namePos:"center",text: "（轻声）若依想，把它带回去，给博士看看。", stands: {  } },
{ type: 'text', speaker: "xiaoman", text: "会化的啦！", stands: {  } },
{ type: 'text', speaker: "ruoyi", text: "（想了想，认真地）那若依就看着它化。化了，也是甜的。", stands: {  } },








  /* ================= 第十二章 · 飞机与高铁（飞向更远的地方） ================= */
{ type: 'chapter', title: "第十二章", subtitle: "飞机与高铁（飞向更远的地方）" },
{ type: 'save' },
{ type: 'scene', bg: "bg_airport" },
{ type: 'narrator', text: "这是若依第一次坐飞机。候机厅里，她趴在巨大的落地窗前，看着一架架飞机起飞、降落，浅蓝眼眸里映着一架又一架银白色的影子。" },
{ type: 'text', speaker: "ruoyi", text: "姐姐……它们，真的能飞到云上面去吗？", stands: { center: "ruoyi:idle" } },
{ type: 'text', speaker: "xiaoman", text: "当然！等下你就知道啦！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（认真）若依在书里看过，云是水汽做的。那飞到云上面……是不是就摸到天了？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "你这问题，等上了天，你自己摸一摸不就知道了！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "小满先带若依去值机柜台。工作人员把登机牌递给若依，若依翻来覆去地看，像捧着一张珍贵的门票。" },
{ type: 'text', speaker: "ruoyi", text: "姐姐，这个……是什么？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "登机牌！没有它，飞机可不让你上。你看，上面写着你的名字和座位号。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（认真地看着自己的名字印在卡片上，眼瞳亮了一下）……我的名字，在牌牌上。那我……是被飞机邀请了？", stands: { center: "ruoyi:smile", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（笑）对！被飞机正式邀请了！", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'narrator', text: "过安检的时候，若依差点把果茶带进通道。工作人员笑眯眯地拦下她：“小姑娘，液体不能带哦。”若依愣了一下，赶紧把果茶交给小满，郑重其事地鞠了一躬：“对不起，若依不知道。" },
{ type: 'narrator', text: "”工作人员被她逗笑了，连连摆手说没关系。小满在旁边憋笑：若依，你这是把安检员吓到了！" },
{ type: 'text', speaker: "ruoyi", text: "（小声问）姐姐……为什么水不能带上飞机？", stands: { center: "ruoyi:confused", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "因为飞机在天上，所以规矩也飞得高呀。记住了，以后出门，先想三件事——证件、液体、危险品，当然还有钱，算第四个。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（认真地把四件事存进记忆）证件……液体……危险品……钱……若依记住了。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "候机厅的广播响起，小满带若依找到登机口，看着窗外的飞机一架一架排好队。登机的时候，若依攥着小满的衣角，一步一步走上舷梯。机舱门关上的一瞬间，她轻轻“呀”了一声。" },
{ type: 'text', speaker: "ruoyi", text: "（小声）门关了……那若依现在，是装在白鸽肚子里了。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（忍笑）是装在飞机肚子里！", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'narrator', text: "若依的座位旁边，坐着一个六七岁的小男孩，正抱着一本飞机图鉴看得入神。他看到若依，眼睛一亮。" },
{ type: 'text', speaker: "tuantuan", text: "姐姐！你也是第一次坐飞机吗？", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（愣了一下，点点头）嗯……第一次。", stands: { center: "ruoyi:confused", right: "xiaoman" } },
{ type: 'text', speaker: "tuantuan", text: "那你和我一样！我也是第一次！妈妈说，第一次坐飞机的人，都要看窗外！等下飞机飞起来的时候，你会感觉有人在后面推你！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（认真地记下）推……若依记下了。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "空乘姐姐走过来，温柔地提醒：“请系好安全带。”若依低头研究那根带子，怎么都扣不上。小满凑过来，手把手教她——“咔哒”一声，扣好了。" },
{ type: 'text', speaker: "xiaoman", text: "看，就这样！这叫安全带，起飞降落都要系好，是飞机上最重要的规矩！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（低头看看腰间的带子，又看看前面椅背上的提示卡，认真地）若依记住了。系安全带……就像……被飞机抱住了一样。", stands: { center: "ruoyi:blank", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（愣了一下，笑着揉她的头）你这比喻，飞机听了都要脸红！", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'narrator', text: "起飞前的广播响起：“请收起小桌板，调直座椅靠背。”若依照做，坐得笔直，双手放在膝盖上，像一个第一次上学的小朋友。飞机开始滑行，加速，机头抬起——若依的身体猛地往后一靠，她睁大眼睛，看着窗外的地面越来越远，房子变成火柴盒，公路变成丝线，最后，一大片雪白的云海铺满整个窗户。" },
{ type: 'text', speaker: "ruoyi", text: "（声音都在发抖）姐姐……姐姐！若依在云上面！若依真的……在云上面！", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（也扒着窗户）哇！好美！像棉花糖做的海！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "tuantuan", text: "（在旁边大声接话）像恐龙背上的毛！我书上说的！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（看了看团团，又看了看云海，认真地点头）……像恐龙背上的毛。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "飞机遇到气流，轻轻颠了一下。若依的指尖在扶手上收紧，但很快又松开。她侧过头，看着身边的团团。" },
{ type: 'text', speaker: "ruoyi", text: "团团，你不怕吗？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "tuantuan", text: "不怕！妈妈说，坐飞机颠一下，是飞机在跟云朵玩呢！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（若有所思）……原来是，在跟云朵玩。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "平飞后，空乘姐姐推着餐车发来飞机餐。若依打开餐盒，看着里面的小面包和水果，眨了眨眼睛。" },
{ type: 'text', speaker: "ruoyi", text: "（小声）姐姐……在天上吃饭，是不是就叫……云朵里的饭？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（咬着面包，含糊不清）嗯嗯，特别好吃！用云朵做的，你尝尝！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（拿起小面包，郑重地咬了一口，眼睛亮起来）……嗯。在天上吃饭，连面包都变软了。", stands: { center: "ruoyi:smile", right: "xiaoman" } },
{ type: 'narrator', text: "窗外的云像棉花一样铺到天边。若依吃着面包，忽然轻声说——" },
{ type: 'text', speaker: "ruoyi", text: "姐姐，若依觉得……若依真的，在往很远很远的地方去了。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（温柔地）嗯。这就是长大呀——总有一天，要自己坐飞机，去很远的地方。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "三个小时的航程里，若依和团团一起看图鉴。团团教她认飞机型号，她教团团念云的名字——“卷云、积云、雨云”。下飞机的时候，团团拉住她的衣角。" },
{ type: 'text', speaker: "tuantuan", text: "姐姐，下次我们再一起坐飞机好不好？我让我妈妈买两个座位！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（蹲下来，认真地看着他）好。姐姐答应你。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "很多年后，若依在空城的机场里，独自走过空旷的候机厅。她在一张长椅上坐下，看着窗外再也不会起飞的飞机，轻轻说：团团，若依学会认所有的云了。可是……没有人再教若依，下一次起飞了。" },
{ type: 'scene', bg: "bg_highspeed" },
{ type: 'narrator', text: "返程那天，若依第一次坐高铁。她站在站台上，看着一列银白色的列车像一条安静的长龙滑进站，又看着车窗里那些一晃而过的人影。" },
{ type: 'text', speaker: "ruoyi", text: "姐姐，高铁和地铁不一样。地铁是“龙”，高铁是……“飞龙”。", stands: { center: "ruoyi:idle" } },
{ type: 'text', speaker: "xiaoman", text: "（笑）差不多吧，反正都跑得贼快！", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'narrator', text: "车厢里，若依靠窗坐下。列车启动，窗外的田野、村庄、远山像被拉长的胶片一样掠过。若依看了一会儿，忽然轻声说。" },
{ type: 'text', speaker: "ruoyi", text: "姐姐……这个速度，若依算过了。一秒，大约九十七米。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（惊）你心算？！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（认真）若依想记住，人间有多大。快一点，就能多看一点。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "高铁经过一片油菜花田，满眼的金黄在阳光下像流动的河。若依看了很久很久，直到那片金黄消失在隧道里。" },
{ type: 'text', speaker: "ruoyi", text: "（轻声）……像春天在跑步。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（没听清）你说啥？", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（摇头，笑了一下）若依说，人间真好看。若依想，把所有的路都走一遍。", stands: { center: "ruoyi:smile", right: "xiaoman" } },
{ type: 'narrator', text: "她低头，从裙子口袋里掏出那本出发前小满硬塞给她的粉色小笔记本——小满最终还是买了那本有星星的笔记本，提前送给了她。若依翻开第一页，用笔慢慢写下几个字：" },
{ type: 'narrator', text: "“若依要记住人间。若依还要，带博士一起看。”" },



{ type: 'scene', bg: "bg_apartment" },
{ type: 'narrator', text: "小满生日的清晨，若依起了个大早，悄悄溜进厨房。她面前摊着一张纸，上面写满了计算——面粉精确到克，糖精确到半勺，连“搅拌第三十七圈时蛋液开始发泡”都标得清清楚楚。" },
{ type: 'cg', img: "ch12_01_生日厨房" },
{ type: 'text', speaker: "ruoyi", text: "（小声）姐姐的生日……一定要成功。若依算过了，这个配方，成功概率是百分之九十八点七。", stands: { center: "ruoyi:idle" } },
{ type: 'narrator', text: "可真正动手时，若依发现，高算力算不出“手忙脚乱”。奶油挤歪了，她重新挤；糖撒了，她先尝了一口，眼睛亮起来。" },
{ type: 'text', speaker: "ruoyi", text: "（自言自语）原来……失败的东西，也可以很好吃。", stands: { center: "ruoyi:idle" } },
{ type: 'narrator', text: "她笨拙地捧着蛋糕胚，歪歪扭扭地抹奶油，又在上面放了一圈小草莓。等她终于端出那个不算漂亮的蛋糕时，天已经大亮了。若依把蛋糕藏在身后，敲开小满的房门。小满睡眼惺忪地拉开门，看见蛋糕，愣住了。" },
{ type: 'cg', img: "ch12_02_敲门惊喜" },
{ type: 'text', speaker: "xiaoman", text: "（愣了很久）……这是……你做的？", stands: { center: "ruoyi", right: "xiaoman:curious" } },
{ type: 'text', speaker: "ruoyi", text: "（紧张地绞着裙摆）若依算好了姐姐喜欢的口味。糖放得不多，因为姐姐胃不好。还有……姐姐，生日快乐。若依是第一次祝人生日快乐。若依把这一天，记下来了。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "她举起那本粉色小笔记本——翻开最新一页，上面写着：若依要记住人间。今天先记住：姐姐的生日。" },
{ type: 'text', speaker: "xiaoman", text: "（眼眶一下子红了，把若依紧紧抱进怀里，声音发颤）傻子……谢谢你。", stands: { center: "ruoyi", right: "xiaoman:worry" } },
{ type: 'cg', img: "ch12_03_生日拥抱" },
{ type: 'narrator', text: "蛋糕上插着一支蜡烛。小满闭上眼睛许愿，烛光在她脸上轻轻晃动。若依好奇地问——" },
{ type: 'cg', img: "ch12_04_烛光许愿" },
{ type: 'text', speaker: "ruoyi", text: "姐姐许了什么愿？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（睁开眼，笑着揉她的头发）不告诉你。愿望说出来，就不灵了。……不过姐姐许的愿，和若依有关。", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'text', speaker: "ruoyi", text: "（认真地问）那若依要怎么做，才能让姐姐的愿望实现？", stands: { center: "ruoyi:confused", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（笑）不用做什么。你好好长大，姐姐的愿望就实现了。", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'narrator', text: "若依把这句话也记进笔记本里：姐姐的愿望和若依有关。那若依要努力长大，让姐姐的愿望实现。窗外的阳光正好，照亮笔记本上那行歪歪扭扭的字。" },

/* ================= 第十三章 · 海边、公园与古镇（人间烟火与远方） ================= */
{ type: 'chapter', title: "第十三章", subtitle: "海边、公园与古镇（人间烟火与远方）" },
{ type: 'save' },
{ type: 'scene', bg: "bg_seaside" },
{ type: 'bgm', name: "lab" },
{ type: 'narrator', text: "这是若依第一次看见大海。她站在堤坝上，海风把她的裙摆和长发一起吹起来。她看着那片铺到天边的蓝，久久没有说话。" },
{ type: 'cg', img: "ch13_01_初见大海" },
{ type: 'text', speaker: "xiaoman", text: "（有些担心）若依？你怎么了？", stands: { right: "xiaoman:worry" } },
{ type: 'text', speaker: "ruoyi", text: "（声音很轻）姐姐……若依在书里看过，海是咸的。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "对！海水是咸的！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "可是若依算不出来——这么大的水，要多少眼泪，才能填满？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（被问住了，愣了很久）……大概，是很多很多吧。", stands: { center: "ruoyi", right: "xiaoman:curious" } },
{ type: 'narrator', text: "若依蹲下来，伸手碰了碰卷上堤坝的浪花。海水从她指缝间流走，她看了看自己的指尖，又看了看大海。" },
{ type: 'cg', img: "ch13_02_触摸浪花" },
{ type: 'text', speaker: "ruoyi", text: "（轻声）海是活的。它在呼吸。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "若依蹲在堤坝边，看着海水一遍遍涌上来，又退回去。她忽然想起博士说过的话——海是活的。那……若依呢？" },
{ type: 'text', speaker: "ruoyi", text: "（轻声，像在问海，又像在问自己）姐姐……海会老吗？", stands: { center: "ruoyi:confused", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（愣了一下，笑了）海不会老呀。海是海嘛。", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'text', speaker: "ruoyi", text: "海不会老。那若依……会不会老？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "小满手里的贝壳“啪嗒”掉进水里。她蹲下来，和若依平视，声音放得很轻。" },
{ type: 'text', speaker: "xiaoman", text: "……怎么突然问这个？", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（看着自己的手指）若依算过了。若依的身体，不会长大，也不会老。姐姐会老，博士会老，洛洛会老，兜兜会长大。可是若依……永远都是这个样子。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "海风把她的裙摆吹起来。她低头看着自己永远十六岁的手，声音越来越小——" },
{ type: 'text', speaker: "ruoyi", text: "姐姐……若依算活着吗？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（沉默了很久，忽然把若依拉进怀里，声音有点抖）你当然活着。你怕黑吗？", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（在她怀里，轻轻点头）怕。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "你会开心吗？", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'text', speaker: "ruoyi", text: "会。和姐姐在一起，就会开心。", stands: { center: "ruoyi:smile", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（把下巴抵在她发顶）那你就是活的。活着，不是看你会不会老、会不会死，是看你怕不怕、爱不爱、舍不舍得。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "若依靠在她怀里，安静了很久很久。夕阳把两个人的影子拉得很长，像永远都不会分开。可海浪声里，那个问题还是留在她心里——" },
{ type: 'cg', img: "ch13_09_夕阳拥抱" },
{ type: 'narrator', text: "若依在心里想：可是姐姐会老。等姐姐老了的那个春天，若依还认得这片海吗？若依……还认得姐姐吗？" },
{ type: 'narrator', text: "傍晚，夕阳把海面染成一片流动的金粉色。若依坐在沙滩上，怀里抱着小满买来的椰子，看着太阳一点一点沉进海里。" },
{ type: 'cg', img: "ch13_03_沙滩抱椰子看日落" },
/* ★ 选择点 13 */
{ type: 'option', choices: [ { label: "替大家许愿", goto: "C13_A" }, { label: "替自己许愿", goto: "C13_B" } ] },
{ type: 'label', id: "C13_A" },
  { type: 'narrator', text: "（海边，暮色把天际染成一片暖橘色。小满双手合十，闭上眼睛许了个愿，然后睁开眼，看向若依）" },
  { type: 'text', speaker: "xiaoman", text: "若依，到你了！海边的愿望，最灵了！" },
  { type: 'text', speaker: "ruoyi", text: "（学着电视里的样子，双手合十，闭上眼睛，认认真真地想了一会儿，才开口）若依许愿——博士不要再熬夜，姐姐不要再为实验困扰。" },
  { type: 'text', speaker: "xiaoman", text: "（愣了一下）……就这些？" },
  { type: 'text', speaker: "ruoyi", text: "（想了想，又补了一句）还有，博士和姐姐，还有全城的人，都平平安安。" },
  { type: 'text', speaker: "xiaoman", text: "（鼻子一酸，一把把她搂进怀里）你这个愿望，太贪心啦，会不灵的！" },
  { type: 'text', speaker: "ruoyi", text: "（认真地摇头）会灵的。若依会努力让它灵。" },
  { type: 'text', speaker: "xiaoman", text: "（抱着她，声音闷闷的）……傻孩子。哪有人许愿，把自己排在最后面的。" },
  { type: 'jump', goto: "MERGE_13" },
{ type: 'label', id: "C13_B" },
  { type: 'narrator', text: "（海边，小满许完愿，睁开眼看向若依）" },
  { type: 'text', speaker: "xiaoman", text: "若依，到你了！" },
  { type: 'narrator', text: "（若依双手合十，闭上眼睛，安静了很久很久。海风把她粉色的长发吹起来，她一直没有睁眼）" },
  { type: 'text', speaker: "xiaoman", text: "（等了一会儿，轻声问）许了什么？" },
  { type: 'text', speaker: "ruoyi", text: "（睁开眼，笑了一下）若依许愿——若依想，一直和博士、姐姐在一起。一直，一直。" },
  { type: 'text', speaker: "xiaoman", text: "（一愣，随即笑了）这算什么愿望，我们本来就会一直在一起呀！" },
  { type: 'narrator', text: "（若依没有回答，只是低头看着自己的手。她没有说出口——她其实很害怕，害怕有一天，自己身上那股她还不懂的力量，会把这份“一直”弄丢。最近，她能清楚地感觉到，体内的量子核心，出现了一点异常）" },
  { type: 'narrator', text: "（她把这股不安压进心底，重新扬起笑脸，看向海面）" },
  { type: 'jump', goto: "MERGE_13" },
{ type: 'label', id: "MERGE_13" },
{ type: 'cg', img: "ch13_04_海边许愿" },
{ type: 'narrator', text: "海风吹来，若依忽然轻轻哼起一首歌——那是地铁上她哼过的小调。这一次，她唱全了。" },
{ type: 'text', speaker: "xiaoman", text: "（安静地听完，轻声问）若依，这首歌叫什么？", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "若依不知道名字。是若依自己编的。若依叫它……《想回家的歌》。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "想家？", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（看着海面）嗯。博士说，无论走到哪里，家里的灯都会亮着。若依想，有灯亮着的地方，就是家。", stands: { center: "ruoyi:smile", right: "xiaoman" } },
{ type: 'narrator', text: "暮色四合，若依把那片海的样子，郑重地存进了记忆里——连同海风的味道、夕阳的颜色，和“想回家的歌”。" },
{ type: 'scene', bg: "bg_park" },
{ type: 'narrator', text: "公园里，若依第一次放风筝。她举着那只粉色的蝴蝶风筝，逆着风跑了一圈又一圈，风筝却总是“啪”地掉下来。" },
{ type: 'text', speaker: "xiaoman", text: "（在旁边笑）你用力太猛啦！风筝要顺着风，轻轻一抖！", stands: { right: "xiaoman:cheer" } },
{ type: 'text', speaker: "ruoyi", text: "（喘着气，认真点头）若依明白了。风筝不是“扔”上天的，是“请”上天的。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "她学着小满的样子，顺着风，轻轻一抖——蝴蝶风筝摇摇晃晃地升起来，越飞越高。若依仰着头，拉着线，站在草地上，一动不动地看了很久。" },
{ type: 'cg', img: "ch13_05_公园放风筝" },
{ type: 'text', speaker: "ruoyi", text: "（轻声）它好高。它看到的人间，一定比若依看到的，还要大。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "那若依下次也变成风筝，去看看！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（认真地想了想）若依不想变成风筝。若依想变成线——这样，无论风筝飞多远，只要一收线，它就会回来。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "小满看着她的侧脸，忽然觉得，这个刚学会放风筝的小机器人，心里装的，好像比她以为的要多得多。" },





{ type: 'scene', bg: "bg_old_town" },
{ type: 'bgm', name: "morning" },
{ type: 'narrator', text: "古镇的石板路被岁月磨得发亮。若依走在巷子里，伸手摸过斑驳的墙、褪色的门环、屋檐下滴水的青苔。她在一家老茶馆门口停下，听里头的老人唱戏。" },
{ type: 'narrator', text: "去古镇那天，若依穿上了洛洛姐姐送的汉服/小满带若依买的 —— 齐胸襦裙，浅粉绣着云纹。她站在石桥头，风一吹，裙摆和长发一起飘起来。小满举着手机，眼睛都直了 ——" },
{ type: 'cg', img: "ch13_10_古镇石桥汉服" },
{ type: 'text', speaker: "ruoyi", text: "（轻声）姐姐，这里的时间……好像走得慢一点。", voice: "ruoyi_01_古镇时间", stands: { center: "ruoyi:idle" } },
{ type: 'text', speaker: "xiaoman", text: "古镇嘛，时间是慢的！", voice: "xiaoman_01_时间慢", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "xiaoman", text: "若依你站那儿别动，姐姐要拍照！这必须发朋友圈！敲可爱的。", voice: "xiaoman_02_拍照", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（认真站好）哦！好。若依要摆什么姿势？", voice: "ruoyi_02_摆姿势", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "不用摆！你站着就是风景！", voice: "xiaoman_03_风景", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "小满咔咔拍了一堆，又心血来潮开了直播：“家人们！今天带你们看古镇！” 她一边走一边播，若依在旁边好奇地东张西望，边走边问 ——" },
{ type: 'cg', img: "ch13_11_古镇直播自拍" },
{ type: 'text', speaker: "ruoyi", text: "姐姐，这里好多仙女姐姐，但是她们都没有你好看。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（差点被口水呛到，又忍不住翘起嘴角）你这小机器人，越来越会说话了。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "这里是神仙住的地方吗？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "这里是人间仙境啦！从古至今都是一个比较热闹的地方！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "弹幕飘过一行：主播，旁边那个小孩是你妹妹吗？" },
{ type: 'text', speaker: "xiaoman", text: "（把手机往若依那边转了转，得意）是的，敲可爱的那种！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "直播间安静了一瞬，然后弹幕疯了 ——" },
{ type: 'text', speaker: "danmu", text: "我靠这是真人？！／仙女下凡了！！／主播你妹妹是明星吗！！／求正脸求正脸！！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（小声）姐姐…… 他们是在说若依吗？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "大家夸你好看呢！不过你还小，咱不露脸啊。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（想了想，很认真地问）可是姐姐，不露脸的话，他们怎么知道若依好看？", stands: { center: "ruoyi:confused", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（噎住）呃…… 这叫神秘感！你懂什么叫神秘感吗？", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（一本正经）若依检索到：神秘感，指人类对未知事物的好奇与想象。姐姐，若依觉得 —— 他们现在好奇的，好像不止若依的脸。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "直播间人数还在疯涨，弹幕刷得飞快。小满看着蹭蹭往上跳的在线人数，心里咯噔一下：坏了，这热度比我直播三年加起来还高。在若依的好奇和粉丝的千呼万唤下，小满终于松了口 ——" },
{ type: 'text', speaker: "xiaoman", text: "行吧行吧！若依，来看镜头，和哥哥姐姐打个招呼！记住，只说名字，不许说别的！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（接过手机，端端正正地举好，像在做汇报）大家好！若依是姐姐的妹妹。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（在旁边得意）看吧！我说什么来着，敲可爱的吧！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（又低头看了看屏幕，一本正经地补充）另外，直播间现在有…… 八万七千六百四十二个人。姐姐，这个数字，还在涨。", stands: { center: "ruoyi:blank", right: "xiaoman" } },
{ type: 'cg', img: "ch13_12_古镇报人数" },
{ type: 'narrator', text: "弹幕瞬间炸了：她还会报人数！！／八万七千六…… 这孩子是数据控吧！／好认真！好可爱！救命！" },
{ type: 'text', speaker: "danmu", text: "主播，求你妹妹的联系方式！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'narrator', text: "若依一听 “联系方式”，很认真地点头：“好！” 然后真的从裙子口袋里掏出手机 —— 打开、解锁、点开二维码，动作一气呵成。" },
{ type: 'text', speaker: "ruoyi", text: "（举着二维码凑向镜头）你们好，这是若依的二维码。姐姐说，认识新朋友，要扫这个。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'cg', img: "ch13_13_二维码风波" },
{ type: 'narrator', text: "弹幕彻底沸腾：好乖！！／她真的好认真！！／快扫快扫！！／这妹妹上哪领的！！" },
{ type: 'narrator', text: "就在二维码即将对准镜头的那一秒 —— 小满一个箭步扑过去，一把夺过手机，动作快得差点把手机拍进旁边的河里。若依愣住了，小满自己也被吓得直拍胸口。" },
{ type: 'cg', img: "ch13_14_夺手机" },
{ type: 'text', speaker: "ruoyi", text: "（茫然）姐姐，怎么了呀？他们还没有加上若依的好友呢。我感觉他们好热情。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（压着嗓子，惊魂未定）他们是热情了…… 这要真让他们加上，你手机当场卡爆！等博士知道我在直播里把你的好友二维码放出去了 —— 我就凉凉了，真的凉凉了！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（认真想了想，点头）哦！若依知道了。姐姐的意思是 —— 神秘感，要留着。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（哭笑不得，揉她脑袋）对！你就是个小机灵鬼！", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'narrator', text: "弹幕还在刷屏，还有人问 ——" },
{ type: 'text', speaker: "danmu", text: "主播，你妹妹有对象吗！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（一秒变脸，护崽模式）没有！妹妹还小！不许打我们若依主意！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（没听懂，认真问）姐姐，什么叫 “打主意”？", stands: { center: "ruoyi:confused", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（噎住）呃…… 就是，想拐你走！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（更认真了，摇头）那不行。若依要跟姐姐和博士在一起。若依不走。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "弹幕瞬间变成一片 “哈哈哈哈” 和 “太可爱了想偷”。小满笑得不行，眼看直播间热度疯涨，人越来越多，她有点慌了，赶紧说了句 ——" },
{ type: 'text', speaker: "xiaoman", text: "好啦好啦，带妹妹逛古镇去啦！下次再见！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（还没回过神）姐姐，怎么关了？他们还想看若依吗？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（捏捏她的脸）想！想得不得了！所以若依呀，在外面要小心 —— 这么好看，以后会被好多人认出啦。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（想了想，认真点头）嗯。我记住了。我会小心，不给姐姐添麻烦。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（牵起她的手，往巷子里走，小声嘀咕）…… 而且下次直播，得把手机藏好了。这小祖宗，是真敢把二维码给别人啊。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'cg', img: "ch13_15_巷子牵手" },
{ type: 'text', speaker: "ruoyi", text: "（认真）姐姐，若依听见了。下次，先问过姐姐，再给二维码。", stands: { center: "ruoyi:confused", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（一顿，然后笑出了声）行！我们若依，终于学会 “留一手” 了！", stands: { center: "ruoyi", right: "xiaoman:cheer" } },





{ type: 'narrator', text: "巷子深处，裁缝铺的布幌子在风里轻轻晃。若依忽然停住——铺子门口，一个小小的人影正蹲在地上，用树枝在青石板上画画。他抬起头，露出沾了灰的脸。" },
{ type: 'text', speaker: "ruoyi", text: "（怔住）……兜兜？", stands: { center: "ruoyi:confused", right: "xiaoman" } },
{ type: 'text', speaker: "doudou", text: "（眨了眨眼睛，忽然跳起来）是……是那个给我擦眼泪的姐姐！姐姐！姐姐你还记得我！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'narrator', text: "若依蹲下来，兜兜扑进她怀里，把她的裙子蹭上了一块灰。小满在旁边看得一愣一愣：你们认识？" },
{ type: 'cg', img: "ch13_06_兜兜重逢" },
{ type: 'text', speaker: "ruoyi", text: "（点点头，声音很轻）嗯。在街市的喷泉边。他找不到妈妈，若依……帮他擦了眼泪。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "doudou", text: "（仰起头，眼睛亮晶晶的）姐姐！我妈妈就在铺子里！她做裙子可厉害了！姐姐你要不要试试？", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "doudouma", text: "（闻声走出来，系着围裙，手上有顶针的痕迹，看见若依愣了一下）哎呀，这就是我们兜兜天天念叨的“喷泉姐姐”吧？快进来坐！兜兜，快去给姐姐倒水！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'narrator', text: "若依坐在裁缝铺的小板凳上，兜兜妈给她量了量肩宽，念叨着“这小姑娘生得真俊”，说要给她做一条新裙子。若依低头看着兜兜趴在她膝头画的小花，忽然觉得，人间的好，原来是这样一环扣着一环，牵着手，一个都不肯松开的。" },
{ type: 'narrator', text: "离开古镇时，兜兜追出来，塞给若依一朵用草编的小花。" },
{ type: 'cg', img: "ch13_07_兜兜送草编花" },
{ type: 'text', speaker: "doudou", text: "姐姐！这个送给你！下次你还来，我带你去吃糖画！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（接过草编花，郑重地放进裙子口袋，和水果糖、糖画放在一起）……好。若依答应你。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "若依不知道，她答应了很多人的“下次”。而“下次”这个词，成了她往后漫长的岁月里，最想兑现、又最难兑现的承诺。" },
{ type: 'narrator', text: "那天，小满还是没忍住，把若依在桥头的照片发到了朋友圈。点赞数一路疯涨。若依不知道，从那天起，星落城有个小小的传闻 —— 古镇上，有个穿汉服的粉发小姑娘，美得像从画里走出来的。这个传闻，后来在星洛城里，慢慢传成了另一个样子。" },
{ type: 'scene', bg: "bg_apartment" },
{ type: 'bgm', name: "lab" },
{ type: 'narrator', text: "海边归来后的某个深夜，或许是核心的异常波动，引发了数据异常，若依做了一个梦（指数据发生异常）。梦里她站在一片燃烧的星域前，张开双臂，挡在什么面前。身后有模糊的声音在喊 ——“守护者大人！” 她回头，看见千万年未曾见过的…… 人群。" },
{ type: 'cg', img: "ch13_08_星域之梦" },
{ type: 'narrator', text: "系统监测到数据异常，她猛地睁开眼，坐起来。窗外月色正好，房间里安静得像什么都没有发生过。她低头，发现自己不知何时握紧了拳头，掌心还残留着一点说不清的、星光的温度。" },
{ type: 'narrator', text: "她想了想，把这件事压进核心最深处，谁也没告诉。第二天小满问她 “昨晚睡得好吗”，她认真想了想，摇头说 ——" },
{ type: 'text', speaker: "ruoyi", text: "姐姐，若依做了一个梦。可是若依…… 想不起来了。", stands: { center: "ruoyi:idle" } },
{ type: 'text', speaker: "xiaoman", text: "（笑）想不起来就算了！梦嘛，都是乱七八糟的！我们不管那些，走，姐姐带你去乡下外婆家。", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'narrator', text: "若依点点头。可她知道，那个梦不是乱七八糟的。那个梦，像一枚埋得很深的种子 —— 迟早有一天，会长出她不敢想的东西。" },

/* ================= 第十四章 · 青禾村（乡下的慢时光） ================= */
{ type: 'chapter', title: "第十四章", subtitle: "青禾村（乡下的慢时光）" },
{ type: 'save' },
{ type: 'scene', bg: "bg_village" },
{ type: 'bgm', name: "morning" },
{ type: 'narrator', text: "出游的路上，小满忽然提议：“带若依去我外婆家吧！在乡下！” 于是她们坐上慢悠悠的绿皮火车，哐当哐当，穿过平原和隧道，来到一座藏在山坳里的小村庄 —— 青禾村。" },
{ type: 'narrator', text: "火车越开，山越高。若依趴在车窗上看了一路，忽然说 ——" },
{ type: 'cg', img: "ch14_01_绿皮火车看云" },
{ type: 'text', speaker: "ruoyi", text: "姐姐，云，离若依越来越近了。若依喜欢这里。", stands: { center: "ruoyi:idle" } },
{ type: 'text', speaker: "xiaoman", text: "（笑）傻话！山本来就是越往里越高的！", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'text', speaker: "ruoyi", text: "（认真摇头）不是。是云。云知道若依喜欢，就下来了。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "进村前，小满特意换了一身朴素的衣服，想把 “城里气” 收一收。她还拿出一件素色的裙子 ——" },
{ type: 'text', speaker: "xiaoman", text: "若依，你要不要也换一套？低调点？", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（低头看看自己身上的洛丽塔，又看看小满，认真摇头）不要。若依的裙子不好看吗？", stands: { center: "ruoyi:blank", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（看着粉纱裙、蝴蝶结、层层蕾丝在风里飘，又看看不远处扛着锄头走过的老伯，想了半天，认输）…… 好看！好看！你就穿着吧！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "结果就是 —— 若依穿着层层叠叠的洛丽塔、顶着粉色长卷发走进青禾村的那一刻，全村正在晒谷子的狗都愣住了。穿靛蓝围裙的阿婆站在院门口，笑出一脸褶子。" },
{ type: 'cg', img: "ch14_02_进村全村瞩目" },
{ type: 'text', speaker: "apo", text: "哎哟，我的小满带回来一个这么好的娃娃！城里来的就是不一样啊，这是从画上走下来的吧！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（认真鞠躬）阿婆好。若依是…… 若依。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "apo", text: "（乐了）这娃娃，说话跟背书似的！来来来，进屋，阿婆给你们做糖糍粑！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'narrator', text: "青禾村的风光，和星落城完全是两个世界。瓦片顶的屋子错落在山坡上，炊烟笔直地升上去，又慢慢散开；田埂上跑着土狗，溪水绕着石桥流，桥下有人在洗菜，棒槌声一声接一声。远处的山一层叠一层，近处的稻田黄绿相间，风一吹，像一整片会呼吸的地毯。" },
{ type: 'cg', img: "ch14_03_青禾村田野风光" },
{ type: 'narrator', text: "若依走在田野里，走在山坡上，走在林间。粉色的裙摆扫过青草，蝴蝶结被山风吹得直打转。她和小满站在田埂上，身后是稻田和远山 —— 小满举起手机，忽然笑了。" },
{ type: 'cg', img: "ch14_04_田埂拍照" },
{ type: 'text', speaker: "xiaoman", text: "若依，过来！我给你拍个照！你和周围的环境，都不在一个图层，特别反差萌！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（认真问）图层…… 是什么？", stands: { center: "ruoyi:confused", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（一边调角度一边笑）就是 —— 你是仙女，你背后是凡间！绝了！", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'narrator', text: "若依在乡下什么都新鲜。她帮阿婆喂鸡，结果把鸡食撒了自己一头，鸡们兴奋地往她头上蹦；她学着喂鹅，被一只大白鹅追着跑了半个院子，最后是阿婆抄起扫帚才救下她；她跟着小满去摘菜，分不清田埂，认认真真把一丛野草当野菜摘了回来；她去提水，小桶里的水一路晃，到家只剩半桶。" },
{ type: 'cg', img: "ch14_05_喂鸡鸡飞上头" },
{ type: 'cg', img: "ch14_06_躲鹅" },
{ type: 'narrator', text: "阿婆和小满笑得直不起腰，若依却一本正经地总结经验 ——" },
{ type: 'cg', img: "ch14_07_摘菜提水" },
{ type: 'text', speaker: "ruoyi", text: "水桶不能装太满，晃一下，就少一口。下次，若依装七分。还有，田地和菜叶的纹路，若依要扫描清楚再摘。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（笑得眼泪都出来了）行！我们若依，做农活都要写使用说明书！", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'narrator', text: "第二天，阿婆说要养几只兔子，托小满去镇上买。镇上没有城里那些四通八达的公交地铁，只有一辆等在村口的 “小破面包车”—— 漆都快掉光了，门要用力拉才开，座位上的海绵露着肚皮，一开动，全车都在抖。" },
{ type: 'narrator', text: "若依第一次见这种车，坐上去，认真研究了一会儿 ——" },
{ type: 'cg', img: "ch14_08_小破面包车" },
{ type: 'text', speaker: "ruoyi", text: "姐姐，这辆车…… 在发抖。是它冷吗？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（抓紧扶手，声音都在抖）它不冷！是路太烂了！若依你抓好！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "面包车在土路上颠得像过山车。若依被颠得东倒西歪，却始终没松开怀里那盒阿婆让带的土鸡蛋。路过田埂，路过晒场，路过一群追着车跑的小孩 —— 每到一处，都有目光落在这辆破车上，准确说，是落在车窗里那张过分好看的脸上。" },
{ type: 'narrator', text: "车在镇口刚停稳，若依还没下车，就被围住了 ——" },
{ type: 'cg', img: "ch14_09_镇口围观" },
{ type: 'narrator', text: "大娘：哎哟喂，这是谁家的娃娃？跟年画似的！" },
{ type: 'narrator', text: "大叔：小姑娘，你这头发是天生的？染的吧？" },
{ type: 'text', speaker: "ruoyi", text: "（认真回答）不是染的。若依的头发，是出厂配置。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "大叔：（没听懂，乐了）这孩子，还出厂配置！哈哈！" },
{ type: 'narrator', text: "卖菜大姐：（塞过来一把青菜）来，妹妹，阿姨给你一把青菜！城里来的吧？" },
{ type: 'text', speaker: "ruoyi", text: "（抱着青菜，认真道谢）谢谢阿姨。若依…… 可以拿去喂兔子吗？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "围观的人越来越多，问什么的都有：“多大了？”“ 上学没？”“家里几口人？”“ 有对象没有 —— 哦不不，问早了！” 小满一个人解释不过来，急得满脑门汗 ——的确，若依很特别。在乡下，无论走到哪里都是全场的焦点，和周围的环境格格不入" },
{ type: 'text', speaker: "xiaoman", text: "（手忙脚乱）我妹妹！我亲妹妹！住城里的！头发天生的！不上学…… 不是，上学！改天上！……皮肤天生很好！没有成年！还小没有对象……", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "好不容易挤出人群，小满拉着若依钻进集市。镇上的街道和星落城差别很大 —— 路是水泥地，有些地方还露着土；两边是旧楼房，挂着褪色的招牌；没有霓虹灯，只有菜贩的大嗓门和修鞋摊的锤子声。" },
{ type: 'narrator', text: "可是很热闹，也很热情 —— 卖豆腐的婶子听说她们要买兔子，直接领着她们到了兔摊，还顺手多塞了两根胡萝卜。" },
{ type: 'narrator', text: "兔摊前，一窝灰扑扑的小兔子挤在一起。若依蹲下来，第一次这么近地看它们 —— 她伸出手，轻轻摸了摸兔子的背，指尖传来软软的、温热的、微微起伏的触感。她忽然安静了很久。" },
{ type: 'cg', img: "ch14_10_兔摊摸兔" },
{ type: 'text', speaker: "ruoyi", text: "（轻声）姐姐…… 它有心跳。好快。像…… 像一面小鼓。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（蹲在她旁边，看着她的眼睛）嗯。活着的，都这样。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "若依挑了一只最白的，小心翼翼地抱在怀里。买完兔子往回走，她一路都抱着纸箱，透过透气孔往里看。路过修鞋摊，摊主老伯正埋头钉鞋底，豆大的汗珠往下掉；路过菜市场，卖鱼的大姐扯着嗓子吆喝；路口有个阿公在卖自己编的竹筐，筐摞得比人还高。" },
{ type: 'narrator', text: "若依看了一会儿，忽然轻声说 ——" },
{ type: 'text', speaker: "ruoyi", text: "姐姐，这里的人，好像…… 都好用力地活着。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（顺着她的目光看过去，笑了笑）嗯。乡下不宽裕，可是你看 —— 修鞋的在钉鞋，卖菜的在吆喝，编筐的在编筐。没人躺下。他们都在认认真真地，过自己的日子。", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'text', speaker: "ruoyi",text: "（抱着兔子，认真想了想）那若依，也要认认真真地活着。像他们一样。",stands: {   }},
{ type: 'narrator', text: "回村的路上，面包车依旧颠得像过山车，可是若依这次抱稳了纸箱，也抱稳了怀里的兔子。窗外的晚霞烧红了半边天，田埂上有人扛着锄头往家走，炊烟从一座座屋顶升起来。" },
{ type: 'cg', img: "ch14_11_回村晚霞抱兔" },
{ type: 'narrator', text: "若依把脸贴在纸箱上，听着兔子咚咚的心跳，忽然觉得 —— 人间最好听的声音，除了博士的仪器、姐姐的笑声，又多了一种。" },
{ type: 'narrator', text: "晚上，阿婆给兔子在屋檐下搭了个小窝。院子里，若依第一次看见萤火虫 —— 星星点点的光从草丛里升起来，忽明忽暗。她蹲在窝前，一边看兔子，一边看萤火虫，忽然说 ——" },
{ type: 'cg', img: "ch14_12_萤火虫之夜" },
{ type: 'text', speaker: "ruoyi", text: "姐姐，天上的星星，落到地上了。", stands: {  } },
{ type: 'text', speaker: "xiaoman", text: "（笑）那是萤火虫！乡下管它们叫 “地上的星星”！", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'text', speaker: "ruoyi", text: "（认真看了一会儿）那若依，也算是地上的星星了。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（一愣，笑了）嗯。你是最亮的那一颗。", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'narrator', text: "那天晚上，若依在星星笔记本上写下：今天，若依去了青禾村。村里的风、田、炊烟、萤火虫，都和阿婆一样暖。若依还学会了喂鸡、躲鹅、摘菜、提水，坐了小破面包车，去了镇上，抱回了一只心跳像小鼓的兔子。" },
{ type: 'narrator', text: "镇上很旧，可是大家都很热情，都用力地活着。姐姐说，没人躺下。若依想，若依也不要躺下。若依要像他们一样，认认真真，过日子。" },
{ type: 'scene', bg: "bg_lab_night" },
{ type: 'bgm', name: "lab" },
{ type: 'cg', img: "ch14_13_深夜实验室布洛" },
{ type: 'narrator', text: "而在另一边，实验室抽屉的深处，躺着一份陈莹数月前就送来的研究报告：虚空裂缝异常扩张，星枢监测站的推算模型显示，这是下一次时空乱流的征兆。布洛早就看过了。他只是把报告收在最深处，谁也没告诉。" },
{ type: 'narrator', text: "今夜，他把它重新拿出来，摊开在桌上，旁边是他算过一百遍的日期——他早就知道结局。从决定救下若依的那天起，他就知道，这一天会来。" },
{ type: 'text', speaker: "buluo", text: "（看着报告，平静地）还有一百零一天。够我把想教她的事，都教完。 （他没有犹豫，打开投影，按下录像键。这次，他录得很完整，像是彩排过很多遍。）", stands: { left: "buluo:normal" } },
{ type: 'text', speaker: "buluo", text: "（对着镜头）我叫布洛。如果你看到这段影像，说明我已经不在这个世界上了。请替我照顾好一个叫若依的女孩——不，不是女孩，是一台…… （他停住了。屏幕里的他张了张嘴，很久，才重新开口。）", stands: { left: "buluo:normal" } },
{ type: 'text', speaker: "buluo", text: "（声音低下去）……是我的女儿。第两百一十五次尝试，才苏醒的女儿。她不会长大，也不会老——她是我见过的最像人的存在。她会问“开心是什么”，会在洋装店里问“美是什么”，会在地铁上让座、在古镇里问“海也是机器吗”。", stands: { left: "buluo:normal" } },
{ type: 'narrator', text: "他顿了顿，看了一眼窗外，继续说——" },
{ type: 'text', speaker: "buluo", text: "时空乱流要来了。这一次，我不知道还能不能护住她。我怕我们都不在了，怕没有人告诉她真相，怕她一个人醒来，什么都想不起来。所以，我把这些话留下来。 （他的声音重新平静下来，像在交代一件早就安排好的事。）", stands: { left: "buluo:normal" } },
{ type: 'text', speaker: "buluo", text: "她身上，藏着守护这个世界的秘密。如果有一天，她忘记了自己是谁——请替我对她说：春天会来的。花有花的时辰，人有人的命数，春天，一定会来。还有——家里的灯，永远为她亮着。灯，会有人记得换的。", stands: { left: "buluo:normal" } },
{ type: 'narrator', text: "他关掉录像，从抽屉里取出一枚旧相框——照片上，布洛、小满、陈莹并肩站着，笑得像什么都不会发生。他把相框轻轻立在投影仪旁边，让镜头能照到它。" },
{ type: 'text', speaker: "buluo", text: "（看着照片，轻声）你们放心……我会把她，交给春天。 （灯下，那段影像安静地躺着。像一粒埋在土里的种子。）", stands: { left: "buluo:tender" } },




    /* ================= 第十五章 · 危险与守护（搭讪、坏人与差点暴露） ================= */
{ type: 'chapter', title: "第十五章", subtitle: "危险与守护（搭讪、坏人与差点暴露）" },
{ type: 'save' },
{ type: 'scene', bg: "bg_plaza" },
{ type: 'bgm', name: "tension" },
{ type: 'narrator', text: "若依很可爱，很美丽。所以出游的这几个月，他们总会遇到很多陌生人搭讪、询问联系方式。若依都表现得非常像一个小女孩——她会认真摇头说“谢谢，但若依没有手机”，会一本正经地背出“妈妈说不要和陌生人走太近”。" },
{ type: 'narrator', text: "科技广场上，一个穿着花衬衫的男人拦住她们，咧着嘴笑。" },
{ type: 'cg', img: "ch15_01_广场搭讪" },
{ type: 'text', speaker: "huachenshan", text: "妹妹，加个微信呗？这么漂亮，交个朋友？" },
{ type: 'narrator', text: "若依突然停住正准备拿出的手机" },
{ type: 'text', speaker: "ruoyi", text: "（认真地思考了一下，摇头）对不起，若依没有微信。", stands: { center: "ruoyi:idle" } },
{ type: 'text', speaker: "huachenshan", text: "那电话呢？", stands: { center: "ruoyi" } },
{ type: 'text', speaker: "ruoyi", text: "（更认真地）若依的电话……只能打给博士和姐姐。", stands: { center: "ruoyi:idle" } },
{ type: 'text', speaker: "huachenshan", text: "（愣住）博士？姐姐？你家里人？", stands: { center: "ruoyi" } },
{ type: 'text', speaker: "xiaoman", text: "（走过来，挽住若依的胳膊，笑眯眯地）对呀，家里人管得严。叔叔再见！", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'narrator', text: "花衬衫悻悻地走开。若依回头看了他的背影一眼，轻声问。" },
{ type: 'text', speaker: "ruoyi", text: "姐姐，他为什么要若依的联系方式？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "因为若依好看呀！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（若有所思）可是，若依好看，和给他联系方式，有什么关系？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（噎住，最后憋出一句）……这叫“大人的世界”，你不用懂。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（认真）若依想懂。若依想懂所有的“大人的世界”，这样若依才能保护姐姐。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "若依没有等到“大人的世界”的解释——因为坏人就先来了。" },
{ type: 'narrator', text: "那天傍晚，她们在一条僻静的小巷里遇到两个醉醺醺的男人。其中一个伸手就朝若依的胳膊抓来。" },
{ type: 'text', speaker: "zui", text: "小姑娘，陪哥哥们喝一杯去呗？", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'narrator', text: "若依的浅蓝眼眸瞬间凝住。她没躲，反而上前一步，挡在了小满身前。她学着电视里的样子，抬起手，语气平稳却带着一种让醉汉没来由发怵的认真。" },
{ type: 'text', speaker: "ruoyi", text: "对不起，若依和姐姐要回家了。请让开。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "zui", text: "（被她的气势唬得一愣，随即又笑）呦，还护着呢？一个小姑娘……", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'narrator', text: "若依没有说话，只是轻轻往前迈了半步。她的眼神平静得不像一个孩子——那一刻，她身上有什么看不见的东西，像一面无声的墙。醉汉的笑容僵在脸上，讪讪地收回手。" },
{ type: 'cg', img: "ch15_02_小巷挡身" },
{ type: 'text', speaker: "zui", text: "……行行行，走走走，真没劲。", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'narrator', text: "两人走出巷子，小满才后知后觉地腿软。" },
{ type: 'text', speaker: "xiaoman", text: "（拍着胸口）若依你刚才……好吓人！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（认真地）若依吓到姐姐了吗？对不起。若依只是想，让姐姐安全。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（一把抱住她，声音发颤）笨蛋！你以后不许这样冲到前面！你是女孩子！遇到坏人要跑！要喊！要报警！", stands: { center: "ruoyi", right: "xiaoman:worry" } },
{ type: 'text', speaker: "ruoyi", text: "（被抱得紧紧的，轻轻说）可是若依想保护姐姐。若依答应过博士，要好好保护姐姐。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "小满的眼眶红了。她知道，这个刚学会做人不久的小机器人，是把“保护”两个字，当成了一生的功课。" },
/* ★ 选择点 14 */
{ type: 'option', choices: [ { label: "礼貌而坚定地拒绝，挡在小满身前", goto: "C14_A" }, { label: "先护住小满，再呼叫救援", goto: "C14_B" } ] },
{ type: 'label', id: "C14_A" },
  { type: 'narrator', text: "（旧巷口，两个醉醺醺的男人拦住了去路，目光在小满身上打转。小满脸色发白，下意识把若依往身后护）" },
  { type: 'text', speaker: "zui", text: "（笑嘻嘻地）妹妹，这么晚了，一个人啊？哥哥陪你们走一段呗！" },
  { type: 'narrator', text: "（若依上前一步，挡在小满身前。她没有凶，只是抬起眼，语气平稳）" },
  { type: 'text', speaker: "ruoyi", text: "请让开。若依要带姐姐回家。" },
  { type: 'narrator', text: "（她站在那里，明明是个穿着洛丽塔裙的娇小少女，却让人感觉像一座推不倒的墙。两个男人对视一眼，那点酒意忽然醒了大半，嘟囔了一句，绕开走了）" },
  { type: 'narrator', text: "（等那两个人走远，小满才反应过来，一把抓住若依的手，上下打量）" },
  { type: 'text', speaker: "xiaoman", text: "（声音发颤）若依！你、你吓死我了！" },
  { type: 'text', speaker: "ruoyi", text: "（转过身，认真地问）姐姐，若依做得对吗？" },
  { type: 'text', speaker: "xiaoman", text: "（用力点头，眼眶有点红）对！你做得对！特别对！" },
  { type: 'text', speaker: "ruoyi", text: "（想了想，认真地补充）若依扫描过了。他们站得很不稳，走起路来会晃。若依挡在前面，他们不一定打得过若依。" },
  { type: 'text', speaker: "xiaoman", text: "（哭笑不得，又把她往怀里搂了搂）……你这孩子！" },
  { type: 'jump', goto: "MERGE_14" },
{ type: 'label', id: "C14_B" },
  { type: 'narrator', text: "（旧巷口，两个醉醺醺的男人拦住了去路。若依的浅蓝眼眸在两人身上扫过，一把拉住小满，往自己身后带）" },
  { type: 'text', speaker: "ruoyi", text: "（声音平静，动作却很快）姐姐，站到若依身后。" },
  { type: 'narrator', text: "（她同时掏出手机——学小满教她的，按下紧急呼叫键，大声说）" },
{ type: 'cg', img: "ch15_03_巷口报警" },
  { type: 'text', speaker: "ruoyi", text: "喂！是巡逻队吗？这里是旧巷口，若依和姐姐遇到坏人了！" },
  { type: 'narrator', text: "（两个醉汉一听她真报警了，对视一眼，骂骂咧咧地散了）" },
  { type: 'text', speaker: "zui", text: "（边走边骂）神经病！小丫头片子还真报警！" },
  { type: 'narrator', text: "（等那两个人走远，小满又惊又怕又好笑，一把捧住若依的脸）" },
  { type: 'text', speaker: "xiaoman", text: "你学得也太快了吧！什么时候学会的报警？！" },
  { type: 'text', speaker: "ruoyi", text: "（认真回答）姐姐教的，若依都记着。姐姐说，遇到危险，先报位置，再报人数。" },
  { type: 'text', speaker: "xiaoman", text: "（看着她，又好气又好笑，最后叹了口气，把她抱住）……行。我们若依，是全世界最可靠的妹妹。" },
  { type: 'jump', goto: "MERGE_14" },
{ type: 'label', id: "MERGE_14" },
{ type: 'narrator', text: "回家的路上，小满牵着她，忽然说——" },
{ type: 'cg', img: "ch15_04_牵手回家" },
{ type: 'text', speaker: "xiaoman", text: "若依，答应我，不管遇到什么事，先保护好自己。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（想了想，轻轻摇头）若依答应姐姐一半。若依会保护自己，也会保护姐姐。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（拿她没办法，叹了口气）……行吧。那你记住了，你身后，永远有博士和我。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "若依没有回答。她只是把这句话，也存进了记忆里——和“灯永远亮着”放在一起。" },
{ type: 'scene', bg: "bg_lab_night" },
{ type: 'narrator', text: "危险和坏人，若依都能笨拙而不失礼貌地处理。可有一样东西，是若依怎么都“处理”不了的——被发现的风险。" },
{ type: 'narrator', text: "那天午后，一个穿着星洛城协会制服的人敲开了实验室的门。他自称是协会例行巡查员，说最近接到线报，有人在这片区域非法制造带有意识的机器人，要上门核实。" },
{ type: 'text', speaker: "xiaoman", text: "（不动声色地挡在门口）我们这里只有普通家用机，您看——（指了指正在扫地的量产机器人）", stands: { right: "xiaoman:normal" } },
{ type: 'text', speaker: "yancha", text: "规定要求，所有高智能设备都要当面核验。你们家那位……粉色头发的小妹妹呢？", stands: { right: "xiaoman" } },
{ type: 'narrator', text: "空气安静了一瞬。若依从厨房走出来，穿着她的洛丽塔裙，手里还端着一盘切好的水果，眨着眼睛看向来人。" },
{ type: 'cg', img: "ch15_05_巡查上门" },
{ type: 'text', speaker: "ruoyi", text: "叔叔，你找若依吗？若依在帮姐姐切水果呢。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "yancha", text: "（盯着她看了几秒，又看了看手里的核查单）……你，多大了？", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'cg', img: "ch15_06_巡查问答" },
{ type: 'text', speaker: "ruoyi", text: "（认真想了想，答非所问）若依的生日，是博士说的“第两百一十五次尝试成功的那天”。", stands: { center: "ruoyi:confused", right: "xiaoman" } },
{ type: 'text', speaker: "yancha", text: "所以你是博士制造的那个机器人吗？", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "当时博士在做高科技的实验呢，很忙的！", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "yancha", text: "（一愣）这孩子说话……挺有意思。读几年级了？", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（想起小满教过的话，乖巧地）若依在家自学。博士教若依认字，姐姐教若依做饭。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "yancha", text: "（又问了几句话，若依都对答如流——甚至比普通小孩更乖巧、更有礼貌。巡查员放下核查单，挠了挠头）……行，没什么异常。按规定，工作人员是不能用仪器扫描别人的身体的，那样会暴露隐私，也很不尊重人。所以我们只能通过询问来判断。打扰了。", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'narrator', text: "门关上。若依端着果盘站在原地，手指轻轻抖了一下——盘子里，一颗草莓滚到了桌角。小满快步走过来，一把抱住她。" },
{ type: 'cg', img: "ch15_07_草莓滚落" },
{ type: 'text', speaker: "xiaoman", text: "（声音发紧）吓死我了……吓死我了……", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（靠在她怀里，轻声说）姐姐，若依刚才，第一次觉得……害怕。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "不怕，不怕，过去了。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（低头看着那颗滚落的草莓，把它捡起来，放回盘子里，轻声）若依知道，若依不能被发现。若依……会小心再小心。", stands: { center: "ruoyi:blank", right: "xiaoman" } },
{ type: 'narrator', text: "那天晚上，若依在自己的记忆里，郑重地新增了一条规则：离所有人，都保持一点点距离。可她又同时把另一条规则，放在更上面——离博士和小满，不用保持距离。" },
{ type: 'narrator', text: "那次巡查之后，小满做了个决定。她把若依拉到房间，一脸严肃。" },
{ type: 'text', speaker: "xiaoman", text: "若依，姐姐跟你说件很重要的事。你……太聪明了。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（眨眨眼）聪明，不好吗？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "聪明不是不好，是……太聪明了，会被坏人盯上。所以姐姐教你——装笨。从今天起，你得像普通小女孩一样，该不会的，就不会。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（认真点头）若依明白了。那……若依该怎么笨？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（示范）比如别人问你“一加一等于几”，你要想一想，再说“等于……二？”", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（立即回答）一加一等于二。无须计算，这是基础运算。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "……不对！你重来！要犹豫！像真的在算一样！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（努力调动表情，慢吞吞地）一加一……等于……二……吗？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'cg', img: "ch15_08_装笨教学" },
{ type: 'text', speaker: "xiaoman", text: "（扶额）太假了。再自然一点。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "排练了一下午。若依把“怎么装作不会”也当成了一道题来解——她甚至给自己列了一张表：什么该会，什么该不会，什么该“想很久才会”。傍晚，小满带她去菜市场实战检验。" },
{ type: 'narrator', text: "菜市场大妈看着这个粉头发的小女孩，笑呵呵地问——" },
{ type: 'cg', img: "ch15_09_菜市场装笨" },
{ type: 'text', speaker: "dama", text: "小姑娘，帮奶奶看看，这两颗白菜，哪颗新鲜呀？", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（想起小满教的——先看，再犹豫，再回答。她盯着两颗白菜，认真看了三秒，才慢吞吞地）奶奶，我觉得……左边这颗，看起来比较……绿？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "dama", text: "（乐了）哎呀，这小姑娘真可爱！来来来，奶奶送你两根葱！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'narrator', text: "若依抱着两根葱，一脸茫然地回头看小满。小满冲她竖起大拇指，憋笑憋得肩膀直抖。" },
{ type: 'text', speaker: "xiaoman", text: "（小声）成了。你终于会笨了。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（小声，很困惑）可是姐姐……若依明明能一眼扫描出，左边那颗更新鲜呀。为什么若依要装作认不出来？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（揉她的头，轻声）你扫描出来了，奶奶就不会觉得你可爱了。有时候，“笨”一点，才是最好的聪明。若依，你记住了——聪明是若依的，可爱，也是若依的。但能让人放心靠近的，是“普通”。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "若依似懂非懂地点点头。她抱着那两根葱，走回实验室的路上，在心里把这条规则也记了下来：若依要学会普通。可若依心里清楚，遇到真正想保护的人和事时，她可能……还是会忍不住，变回那个“太聪明”的若依。" },

/* ================= 第十六章 · 迷路的人（重大分支） ================= */
{ type: 'chapter', title: "第十六章", subtitle: "迷路的人（重大分支）" },
{ type: 'save' },
{ type: 'scene', bg: "bg_city_street" },
{ type: 'bgm', name: "lab" },
{ type: 'narrator', text: "一切似乎都很美好，很顺利。但社会是非常复杂的——或许再高智能的机器，也无法真正理解和处理人与社会的复杂。" },
{ type: 'narrator', text: "那天下午，小满在实验室忙着整理数据，若依第一次独自出门买菜。她挎着小篮子，走在熟悉的街市上，认真地挑菜、讲价，像每一个刚学会过日子的女孩。" },
{ type: 'text', speaker: "ruoyi", text: "阿姨，这个番茄，可以便宜一点点吗？", stands: { center: "ruoyi:idle" } },
{ type: 'text', speaker: "caifan", text: "（笑着）行行行，看你这么可爱，给你抹个零！", stands: { center: "ruoyi" } },
{ type: 'cg', img: "ch16_01_菜市场讲价" },
{ type: 'text', speaker: "ruoyi", text: "（郑重地接过找零，认真数了两遍，放进裙子口袋）谢谢阿姨。", stands: { center: "ruoyi:idle" } },
{ type: 'narrator', text: "买完菜，若依正要往回走，一个中年男人拦住了她。他穿着洗得发白的旧外套，脸上带着一副又急又无奈的表情，手里攥着一张揉皱的纸条。" },
{ type: 'cg', img: "ch16_02_马三拦路求助" },
{ type: 'text', speaker: "masan", text: "（搓着手，声音又急又软）小姑娘！小姑娘！叔叔是从外地来送货的，这地儿我不熟，导航也坏了。你看这地址——（把纸条递过来）叔叔赶着去给人送药，病人等着呢！你能给叔叔指个路吗？应该就在前面那条街！", stands: { center: "ruoyi" } },
{ type: 'text', speaker: "ruoyi", text: "（下意识往后退了半步，想起小满的叮嘱，摇了摇头）对不起，若依不认识路，若依要回家了。", stands: { center: "ruoyi:idle" } },
{ type: 'text', speaker: "masan", text: "（更急了，眼眶都红了一圈）小姑娘，你行行好！叔叔家孩子还在医院躺着呢，这药送晚了要出大事的！你看，就前面拐个弯就到了，你带叔叔走两步就行！", stands: { center: "ruoyi" } },
{ type: 'narrator', text: "若依看着他那副焦急的样子，想起博士住院时自己的焦急，想起那个在喷泉边哭的兜兜。她的核心深处，有一根弦被轻轻拨动了一下。她犹豫了。" },
{ type: 'cg', img: "ch16_03_若依犹豫" },
/* ★ 选择点 15 */
{ type: 'option', choices: [ { label: "带路（进入隐藏剧本）", goto: "C15_A" }, { label: "坚持不带路", goto: "C15_B" } ] },
{ type: 'label', id: "C15_A" },
  { type: 'narrator', text: "（若依最终还是点了点头。她想着：就带两步路，应该没事的。可若依不知道，从她点头的那一刻起，她走进了一个她完全陌生的世界。）" },
  { type: 'text', speaker: "masan", text: "（眼里闪过一丝不易察觉的光，声音却越发诚恳）谢谢你啊小姑娘！你真是个好孩子！" },
  { type: 'narrator', text: "（若依带着马三拐进一条她没走过的巷子。巷子越走越深，越走越偏。若依停下脚步，轻声说。）" },
  { type: 'cg', img: "ch16_04_深巷带路" },
  { type: 'text', speaker: "ruoyi", text: "叔叔，前面没有路了。" },
  { type: 'text', speaker: "masan", text: "嘿嘿，小妹妹，大人没有教你不要给奇怪的陌生人带不知名的路吗？" },
  { type: 'narrator', text: "（话音未落，后脑传来一阵剧痛——若依的浅蓝眼眸瞬间暗下去，机体自动触发系统保护，进入强制休眠。她软软地倒在地上，像一盏被拔掉电源的灯。）" },
  { type: 'cg', img: "ch16_05_被袭倒下" },
  { type: 'narrator', text: "（等她再次睁开眼时，她躺在一个昏暗的仓库里。一个戴着黑框眼镜的瘦高男人正蹲在她面前，打量着她。）" },
  { type: 'cg', img: "ch16_06_仓库苏醒" },
  { type: 'text', speaker: "lier", text: "我说你是不是蠢，你弄个小姑娘来干嘛！能捞到好处吗,而且你看她的穿着打扮，一看就不是一般人，指定有背景，弄不好，我们就全完了。" },
  { type: 'text', speaker: "masan", text: "我看整条街就她一看就不一般，指定有钱，而且好骗，我就……弄来了。" },
  { type: 'text', speaker: "lier", text: "现在怎么办，不可能把她送回去把！" },
  { type: 'text', speaker: "masan", text: "这小姑娘长得挺可爱！还单纯得不像话，我觉得可以利用一下，也不忘我把她骗来！" },
  { type: 'narrator', text: "（他叫来几个人，把若依抬起来，扔进一间密封的旧仓库。铁门“哐当”一声关上，锁链哗啦作响。）" },
  { type: 'cg', img: "ch16_07_被困铁室" },
  { type: 'text', speaker: "ruoyi", text: "（在黑暗里蜷着身子，声音断断续续）……系统自检……完成……启动……（她试着动了动手指，发现自己被固定在角落，四周是冰冷的铁壁）……这里是……哪里？" },
  { type: 'narrator', text: "（若依用内置地图检索，却发现这里完全没有信号——没有卫星定位，没有任何已知坐标。她试着推了推门，铁门纹丝不动。她坐在角落里，第一次，真切地体会到了什么叫“被困住”。）" },
  { type: 'narrator', text: "（过了几天，若依醒了。她开始向外呼救，声音穿过铁门，被守在外面的人听到。马三推开铁门走进来，脸上换了一副表情——不再是那个急得眼眶发红的送货员，而是一个笑眯眯的“救命恩人”。）" },
  { type: 'cg', img: "ch16_08_假恩人" },
  { type: 'text', speaker: "masan", text: "（搓着手）哎呀，小姑娘你醒啦！你可算醒了！那天要不是叔叔及时发现你晕倒在路边，你可就危险喽！" },
  { type: 'text', speaker: "ruoyi", text: "（警惕地往后缩了缩，却还是忍不住问）……是叔叔……救了若依？" },
  { type: 'text', speaker: "masan", text: "（叹了口气，指了指自己的胳膊）可不是嘛！你看叔叔这胳膊，为了把你从路边挪进来，还扭了一下，到现在还疼呢！叔叔也一把年纪了，你说这……" },
  { type: 'narrator', text: "（若依看着他“受伤”的胳膊，想起火光里博士护住她的身影。她的核心深处，涌上一股熟悉的、酸涩的愧疚。）" },
  { type: 'text', speaker: "ruoyi", text: "（低下头）……对不起。是若依，给叔叔添麻烦了。" },
  { type: 'text', speaker: "masan", text: "（眼睛一亮，语气却越发为难）这……叔叔也不图你什么，可叔叔为了救你，活儿也耽误了，胳膊也伤了……你看，你是不是该……补偿补偿叔叔？" },
  { type: 'text', speaker: "ruoyi", text: "（认真地想了想）叔叔，若依出门没有带钱，也没有带手机。但是我可以干活！我什么都会干，扫地、擦窗、做饭，若依都学过的！" },
  { type: 'text', speaker: "masan", text: "（眼底闪过一丝算计，嘴上却答应得爽快）行！那你就帮叔叔干几天活，干完了，叔叔就带你出去！" },
  { type: 'narrator', text: "（若依虽然可以直接用博士的卡给马三钱，但她知道，钱不能随便用——那是博士的东西，她要靠自己的努力，获得应该有的报酬。于是，她跟着马三，走进了一座建在地下的大厂房。）" },
  { type: 'narrator', text: "这里是星洛城的暗面，地下黑党的乐园。昏黄的灯、油腻的地面、轰隆隆运转的机器，还有一群埋头干活、谁也不看谁的人，但是若依走进来，全场的目光都被她吸引，她粉色头发，微微发光的洛丽塔裙与周围的环境真是格格不入。" },
  { type: 'cg', img: "ch16_09_地下工厂" },
  { type: 'text', speaker: "daxiong", text: "（一个膀大腰圆的监工，叼着烟，上下打量若依）老三，你从哪儿捡来这么个小不点？细胳膊细腿的，能干得动活？" },
  { type: 'text', speaker: "masan", text: "能干能干，现在也不可能把她送回去吧！她说了啥都会干！" },
  { type: 'narrator', text: "（若依被分到了最脏最累的活——洗机器零件。她蹲在水槽边，一遍一遍地刷着沾满油污的零件，从早刷到晚。油污钻进纳米皮肤的缝隙，又被她悄悄修复。她的粉色长发用一根旧皮筋扎起来，裙摆上溅满了黑点——她没舍得换下那条裙子，因为博士说过，它会自己变干净。）" },
  { type: 'cg', img: "ch16_10_洗零件" },
  { type: 'text', speaker: "ruoyi", text: "（一边刷，一边轻声给自己打气）若依可以的。干完活，就可以回去了。博士和姐姐……还在等若依回家。" },
  { type: 'narrator', text: "（地下工厂没有白天黑夜。若依每天有干不完的活，手指泡得发白，机体运行到发热。可她没有哭——她只是很认真地想：等干完了，要怎么跟博士和小满解释，自己为什么晚回家。）" },
  { type: 'narrator', text: "（而在地面上，星洛城，小满发现若依失踪后，急得团团转。四处寻找和打听，尝试联系若依，也联系不上——因为那几天，若依进入了休眠。）" },
  { type: 'text', speaker: "xiaoman", text: "（在电话里，声音发着抖）博士，若依没回家……她买菜去了，就没回来……" },
  { type: 'text', speaker: "buluo", text: "（握着手机，指节发白）先别急……再找找，也许她迷路了。" },
  { type: 'narrator', text: "（后来，若依开机了。她偷偷联系了小满——单纯的若依把坏人想得太简单了。她想靠自己的努力去弥补，于是她对着电话，努力让自己的声音听起来很轻松。）" },
  { type: 'cg', img: "ch16_11_报平安电话" },
  { type: 'text', speaker: "ruoyi", text: "姐姐……若依很好。若依遇到一点事情，但若依自己会处理好的。你们放心，相信若依。处理好了，过几天若依就回去。" },
  { type: 'text', speaker: "xiaoman", text: "（又急又怕）若依！你在哪里？你告诉姐姐！姐姐去接你！" },
  { type: 'text', speaker: "ruoyi", text: "（轻声）姐姐，若依答应你，很快就回去。真的。你们不要担心若依。" },
  { type: 'narrator', text: "（小满再三叮嘱，若依一一应下，然后挂断了电话。尽管若依很想回去，但她还是决定留下来干活去补偿——而且，若依通过内置地图，也查询不到任何可以出去的路。马三说，补偿完就会带她出去，单纯的若依，相信了……）" },
  { type: 'narrator', text: "（一天一天过去。小满越来越不放心，若依也在马三的忽悠下，变得越来越神秘——她打电话的时间越来越短，语气越来越“一切都好”。终于，小满决定做点什么了，不能再等了。）" },
  { type: 'text', speaker: "xiaoman", text: "博士！不能再等了！若依一定出事了！" },
  { type: 'narrator', text: "（她联系布洛，通过若依系统的定位信号，追踪到若依曾经出现过的一个位置——但定位显示，若依突然系统崩溃，然后出现在一个不知名的点。小满看到那个坐标时，内心是崩溃的。她马上开车前往，却只发现一个废弃的仓库。后来的定位，显示在一处从来没有被标记和收录的地方。）" },
  { type: 'text', speaker: "buluo", text: "（看着屏幕上的坐标，声音沉下来）那个地方……地图上没有。一定有量子场保护，信号根本探查不到。" },
  { type: 'text', speaker: "xiaoman", text: "那怎么办？那怎么办？！" },
  { type: 'text', speaker: "buluo", text: "（攥紧拳头）报警。带上实验室最先进的量子激光仪。我们……去接若依回家。" },
  { type: 'narrator', text: "（武装人员突破地下工厂的那一刻，量子场在强光中崩解。若依听见外面的动静，停下手中的活，抬起头——她看见铁门被撞开，看见小满冲在最前面，看见博士站在门口，肩上扛着量子激光仪，白大褂的袖口还带着实验室的焦痕。）" },
  { type: 'cg', img: "ch16_12_营救破门" },
  { type: 'text', speaker: "xiaoman", text: "（声音都在发抖）若依！！" },
  { type: 'text', speaker: "ruoyi", text: "（愣愣地站在原地，油污的手还握着刷子）……姐姐？博士？你们……怎么来了？" },
  { type: 'narrator', text: "（武装人员攻破地下黑党，成功拿下这个星洛城的地下窝点。马三和大熊李二被铐上手铐带走了。马三被押走时，回头看了若依一眼，脸上还是那副笑眯眯的表情，眼神却冷得像冰。）" },
  { type: 'text', speaker: "masan", text: "（低声）小姑娘，你运气好。这世上的坏人，可不止叔叔一个，我不知道武警是怎么找到这里的，但是绝对和你脱不了干系。" },
  { type: 'narrator', text: "（若依站在原地，没有听懂这句话。她只是觉得，有什么东西，在她心里碎了一下。）" },
  { type: 'narrator', text: "（回家的路上，若依有些不知所措，不知道应该说什么，一路一直低着头，一句话没有说。博士和小满知道这其中的复杂程度，也没有多说什么。）" },
  { type: 'narrator', text: "（回到家后，小满终于忍不住开口训斥若依，把内心的委屈和担心全部说了出来。）" },
  { type: 'text', speaker: "xiaoman", text: "若依！你知道我们有多担心吗！你知道姐姐找你找得腿都要跑断了吗！你怎么能一个人去给陌生人带路！你怎么能出了事不第一时间告诉我们！你知不知道，你差点就回不来了！" },
  { type: 'text', speaker: "ruoyi", text: "（低着头，声音很轻）……对不起。若依以为，若依可以自己处理好。若依想靠自己的努力补偿，不想给博士和姐姐添麻烦。" },
  { type: 'text', speaker: "xiaoman", text: "（眼泪一下子掉下来）你这个笨蛋！你以为你是一个人吗！你身后有博士，有姐姐！你永远都不用一个人扛！" },
  { type: 'narrator', text: "（若依抬起头，看见小满哭得稀里哗啦，又看见博士站在一旁，没有说话，只是轻轻叹了口气。她走过去，笨拙地抱住小满，像小满曾经抱住她那样。）" },
  { type: 'cg', img: "ch16_13_训斥与拥抱" },
  { type: 'text', speaker: "ruoyi", text: "（声音闷闷的）……姐姐，对不起。若依记住了。下次，一定会先保护好自己，一定会先联系你们。下一次，就要惩罚若依了，对不对？" },
  { type: 'text', speaker: "xiaoman", text: "（哭着说）对！惩罚你！罚你……罚你以后出门，都必须让姐姐跟着！" },
  { type: 'text', speaker: "ruoyi", text: "（认真地）……好。我答应姐姐。" },
  { type: 'narrator', text: "（若依本质是对的，她只是想通过自己的努力，去补偿因自己造成的结果。只是人心很复杂——她还不懂，这世上有些“补偿”，是永远填不满的。多年以后，若依在空城里，偶尔还会想起马三那句“这世上的坏人，可不止叔叔一个”。她那时才明白，那句话，是那个人一生中说的，唯一一句真话。）" },
  { type: 'narrator', text: "（几天后，武警局的人上门找若依小姐，感谢她对本次行动做出的贡献——正是她最初定位到的信号，让武装人员锁定了地下黑党的老巢。）" },
  { type: 'cg', img: "ch16_14_武警感谢" },
  { type: 'text', speaker: "wujing", text: "若依小朋友，感谢您为本次行动提供的关键情报！您的勇敢和冷静，值得我们所有人学习！" },
  { type: 'text', speaker: "ruoyi", text: "（站在门口，认真听完，轻声说）谢谢。可是若依……没有勇敢。若依只是……想回家。" },
  { type: 'narrator', text: "（武警愣住，随即笑了。若依没有感到很高兴。她看着手里的感谢信，第一次，模模糊糊地明白了一些什么——她或许永远也理解不了，为什么一件让她差点回不了家的事，会被人叫做“贡献”。）" },
  { type: 'jump', goto: "MERGE_15" },
{ type: 'label', id: "C15_B" },
  { type: 'narrator', text: "（若依看着马三那副焦急的样子，想起小满的叮嘱，想起博士说“灯会一直亮着”——她轻轻摇了摇头，语气礼貌而坚定。）" },
  { type: 'cg', img: "ch16_15_礼貌拒绝" },
  { type: 'text', speaker: "ruoyi", text: "叔叔，对不起。若依不认识路，若依也不方便带叔叔去。前面路口有巡逻亭，叔叔可以去那里问警察叔叔。" },
  { type: 'text', speaker: "masan", text: "（笑容僵了一下，随即又堆回脸上）行行行，那我自己找找……" },
  { type: 'text', speaker: "ruoyi", text: "（认真地补了一句）叔叔，希望叔叔的孩子早点好起来。" },
  { type: 'narrator', text: "（马三转身离开，脸色在背光处沉了下来。若依站在原地，看着他的背影消失在巷口，忽然觉得，那个背影，和自己见过的所有人都不一样。她没多想，挎着菜篮，回了家，和小满一起做了晚饭。）" },
  { type: 'cg', img: "ch16_16_回家说不了" },
  { type: 'text', speaker: "xiaoman", text: "（一边炒菜一边问）若依，今天买菜顺利吗？" },
  { type: 'text', speaker: "ruoyi", text: "（认真想了想）顺利。若依今天……学会了说“不”。" },
  { type: 'text', speaker: "xiaoman", text: "（一愣，随即笑了）好孩子！这就对了！记住，你的“不”字，比什么都值钱！" },
  { type: 'narrator', text: "（若依点点头，把“不”字，也郑重地存进了记忆里。）" },
  { type: 'narrator', text: "（晚饭后，小满翻着手机，忽然眼睛一亮，把一张电子门票举到若依面前。）" },
  { type: 'cg', img: "ch16_17_博览会门票" },
  { type: 'text', speaker: "xiaoman", text: "若依！明天 “未来之光科技博览会” 开幕，就在星落城科技馆！听说有会跳舞的机器人、会自己飞的滑板，还有超大的机械臂！博士明天去研究院开会，我们俩去！" },
  { type: 'text', speaker: "ruoyi", text: "（看着门票上印着的火箭和齿轮，眼瞳一点点亮起来）…… 博览会。若依…… 可以去吗？" },
  { type: 'text', speaker: "xiaoman", text: "当然！你都学会说不啦，也该去看看 “是” 的世界有多大！" },
  { type: 'narrator', text: "（博览会人山人海。若依站在入口，被扑面而来的灯光和机械包围，像第一次进城的乡下小孩。小满拉着她，从 “会跳舞的机器人” 看到 “会自己飞的滑板”，若依的眼睛一路都在发光。）" },
  { type: 'narrator', text: "（来到博览会主展区的中央，立着一面巨大的透明题目板。板上只有一道题，题目下方挂着一块小牌子，写着 “悬赏十年，无人解开”。那是星洛城公认的世纪难题 —— 连最顶尖的研究院，都只在上面留下过一页又一页失败的演算。若依路过时，脚步忽然停住了。）" },
  { type: 'text', speaker: "ruoyi", text: "（站在题板前，歪了歪头，看了很久很久，忽然轻声说）…… 这个，我好像知道。" },
  { type: 'text', speaker: "xiaoman", text: "（吓了一跳）什么叫你好像知道？！若依，这可是悬赏十年的世界级难题！连博士都说没人解得开！" },
  { type: 'text', speaker: "ruoyi", text: "（没有回答。她踮起脚，在题板下方的触屏上，一笔一笔写下演算过程。屏幕上的光映在她脸上，她写得又快又稳，像在抄一遍早就背熟的书页。写完，她拍了拍手，转身就走，像只是做了一件很小的事。）" },
  { type: 'cg', img: "ch16_18_难题墙解题" },
  { type: 'narrator', text: "（她不知道，就在她身后两步远的地方，一个抱着记录板的年轻研究员正好路过，停下了脚步。他看着题板上那串流畅的算式，瞳孔一点点放大 —— 那不止是答案，连推导步骤都严丝合缝，像是这道题从一开始就长在她脑子里。他想追上去问个究竟，可人群一涌，把他隔在了原地。他只能低头，把那个粉发少女的样子，一笔一笔记进表格里。）" },
  { type: 'narrator', text: "（他叫林澈。后来他才知道，这一天他记下的每一个细节，都会在很久以后，成为某种答案的一部分。）" },
  { type: 'text', speaker: "xiaoman", text: "若依，那边人好多，我们去那边看看！" },
  { type: 'narrator', text: "（主舞台上，“天才少年问答赛” 正在进行。主持人举着话筒，在台下扫了一圈，目光忽然停在人群里最显眼的那个人身上 —— 一个粉发蓝眸、穿着洛丽塔裙的小女孩，安静得像橱窗里的娃娃，像一颗掉落在人间的星星。）" },
  { type: 'text', speaker: "zhuchiren", text: "（眼睛一亮，走下台把话筒递过去）哎呀！这位小朋友长得最特别！来，就让这颗落在人间的星星上台挑战一下！答对一题，奖品加一级！" },
  { type: 'text', speaker: "ruoyi", text: "（看了看小满，小满比了个 “加油” 的手势。她点点头，乖乖走上台）…… 好。" },
  { type: 'cg', img: "ch16_19_问答赛登台" },
  { type: 'narrator', text: "（题目从天文地理开始，一道比一道难。天文、历史、化学、高数、量子物理 —— 主持人念题的速度都快跟不上她答题的速度，台下渐渐从起哄变成了安静。若依站在台上，语气平静得像在念课文，几乎没有一道题让她多犹豫一秒。）" },
  { type: 'cg', img: "ch16_20_问答赛答题" },
  { type: 'text', speaker: "zhuchiren", text: "（擦了擦汗，声音有点抖）小朋友…… 这道题可是去年研究生考试的压轴题，你再看看？" },
  { type: 'text', speaker: "ruoyi", text: "（看了一眼大屏幕，轻声说）答案是二点七一八二八一八二八四。题干里 “忽略空气阻力” 五个字，是多余的。出题人写错了。" },
  { type: 'narrator', text: "（全场寂静。有懂行的观众 “腾” 地站起来 —— 她不但答对了，还精确到小数点后十位，这是正常人能说出来的吗，还指出了题目本身的错误。直播间弹幕瞬间炸了。）" },
  { type: 'text', speaker: "zhuchiren", text: "（目瞪口呆，缓了半天才挤出笑容）…… 小朋友，你、你是不是把题库都背下来了？" },
  { type: 'text', speaker: "ruoyi", text: "（认真想了想，摇摇头）我没有。若依…… 只是算出来了。" },
  { type: 'narrator', text: "（台下爆发出海啸般的惊叹。主持人把话筒递给她，手都是抖的。若依走下台，回到小满身边，像只是去领了一颗糖。小满张了张嘴，最后只说了一句 ——）" },
  { type: 'text', speaker: "xiaoman", text: "（小声）…… 若依，你以后在外面，少说点话。" },
  { type: 'text', speaker: "ruoyi", text: "（困惑）为什么？若依说的，都是对的呀。" },
  { type: 'text', speaker: "xiaoman", text: "（小声）但是对得很不正常，很容易引起别人的注意。" },
  { type: 'text', speaker: "xiaoman", text: "下次还是装着笨一点的好，走我们去机械展厅。" },
  { type: 'text', speaker: "ruoyi", text: "（指着一台正在画画的机械臂，小声）姐姐…… 它画的，比若依画的好。" },
  { type: 'text', speaker: "xiaoman", text: "（凑过去看了一眼）人家练了几十年呢！—— 哎，那边有超大机械臂演示，快去看！" },
  { type: 'narrator', text: "（机械展厅，一台两人高的 “全地形救援机械臂” 正在演示搬运。围观的孩子们仰着头，“哇” 声一片。可就在机械臂抓起第三块钢板时，它忽然发出一声刺耳的嗡鸣 —— 手臂猛地失控，横扫向观众席！）" },
  { type: 'cg', img: "ch16_21_机械臂失控" },
  { type: 'text', speaker: "renqun", text: "（惊叫）躲开！快躲开！" },
  { type: 'narrator', text: "（若依瞳孔骤缩。她没有思考 —— 身体先动了。她两步蹿上展台，在机械臂砸向人群的前一秒，一只手死死钳住它的液压关节。火花四溅，警报尖鸣，机械臂的力道大得让整座展台都在震颤，可那只小小的手，纹丝不动。）" },
  { type: 'cg', img: "ch16_22_钳制机械臂" },
  { type: 'text', speaker: "ruoyi", text: "（另一只手飞快地摸到主供电线，用力一拔）…… 停！" },
  { type: 'narrator', text: "（“咔嗒” 一声。机械臂的嗡鸣戛然而止，悬在半空，像被点了穴。全场安静了两秒 —— 然后爆发出山呼海啸的掌声与欢呼。无数手机举起来，直播间里弹幕刷屏：这个小女孩是谁？！）" },
  { type: 'cg', img: "ch16_23_全场欢呼" },
  { type: 'text', speaker: "gongzuo", text: "（冲上来，声音都在抖）小姑娘！你…… 你没事吧？！你、你是怎么做到的？！" },
  { type: 'text', speaker: "ruoyi", text: "（收回手，站在原地，自己也有些茫然）它…… 要打到人。若依就…… 让它停了。" },
  { type: 'narrator', text: "（人群围了上来。有人拍下她拔线的那一幕，有人围着她问个不停。远处，几个穿着深色制服的人拨开人群走过来 —— 是星洛城安全部的人。为首的女性大约三十岁，目光锐利，盯着若依看了很久。她身边跟着一个抱着记录板的年轻男性研究员，始终沉默，只把每一个细节，都写进表格里。）" },
  { type: 'cg', img: "ch16_24_安全部问话" },
  { type: 'text', speaker: "shenxi", text: "（蹲下来，语气温和，目光却一寸不离地打量她）小姑娘，你叫什么名字？刚才那一手…… 可不像普通孩子能做到的。" },
  { type: 'text', speaker: "ruoyi", text: "（看着她，认真地）若依叫若依。若依只是…… 不想让大家受伤。" },
  { type: 'text', speaker: "shenxi", text: "（又看了她一会儿，站起来，临走时回头望了她一眼 —— 那目光里装着若依看不懂的东西）…… 记一下。星落城，若依。" },
  { type: 'text', speaker: "linche", text: "（在旁边轻声补了一句，表格上已经写满了若依从难题墙到问答赛的记录）…… 不是第一次了。上午的难题墙，也是她。" },
  { type: 'narrator', text: "（人群散去后，小满把若依拉到角落，心有余悸地上下检查她。）" },
  { type: 'cg', img: "ch16_25_小满检查" },
  { type: 'text', speaker: "xiaoman", text: "（又急又心疼）若依！你吓死我了！那么大的机械臂，你一个孩子冲上去干什么！万一…… 万一你受伤了怎么办！" },
  { type: 'text', speaker: "ruoyi", text: "（想了想，认真地）姐姐说过，若依要学会保护自己。可是那一刻，若依也学会了 —— 保护别人，是若依想做的事。" },
  { type: 'text', speaker: "xiaoman", text: "（看着她，忽然笑了，眼眶有点红）…… 你呀。回去让博士给你做个大检查，听到没？" },
  { type: 'text', speaker: "ruoyi", text: "…… 嗯。我知道了。" },
  { type: 'jump', goto: "MERGE_15" },
{ type: 'label', id: "MERGE_15" },
{ type: 'scene', bg: "bg_city_street" },
{ type: 'narrator', text: "回到实验室后，若依自己做家务，博士和小满正常实验。一切似乎恢复了平静 —— 但有些东西，已经不一样了。那场营救行动也好，科技博览会上的失控事件也罢，若依的身影，都被太多人看见了。高智能机器人的传闻，像一阵风，传遍了整个星洛城。" },
{ type: 'narrator', text: "直到有一天，星洛城协会的人找上了门。" },

/* ================= 第十七章 · 登记与邀请 ================= */
{ type: 'chapter', title: "第十七章", subtitle: "登记与邀请" },
{ type: 'save' },
{ type: 'scene', bg: "bg_lab_night" },
{ type: 'bgm', name: "tension" },
{ type: 'narrator', text: "这次上门的工作人员，不是来追究责任的——各协会都惊叹若依的智能程度和外表，根本就不是现在科技能出现的。他们只是要报备一下若依的型号：她对星洛城有巨大的贡献和作用。" },
{ type: 'narrator', text: "工作人员小徐是个刚入职不久的年轻人，抱着一沓表格，站在门口，紧张得直咽口水。" },
{ type: 'cg', img: "ch17_01_登记上门" },
{ type: 'text', speaker: "xiaoxu", text: "（清了清嗓子）您好！我是星洛城协会的登记员小徐！我们接到通报……呃……想上门，给贵实验室的……高智能设备做个报备登记！" },
{ type: 'narrator', text: "小满接待了他。得知工作人员的目的，小满也知道没有什么可以隐藏的了，于是叫若依出来见工作人员。" },
{ type: 'text', speaker: "xiaoman", text: "若依，出来一下，有人找你！", stands: { right: "xiaoman:normal" } },
{ type: 'narrator', text: "若依从厨房走出来，穿着她的洛丽塔裙，端着一杯刚泡好的果茶，眨着眼睛看向小徐。" },
{ type: 'cg', img: "ch17_02_果茶误会" },
{ type: 'text', speaker: "ruoyi", text: "你好，你找若依吗？", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "小徐第一眼还没有认出若依就是他要找的机器人，还和小满说要找的是若依机器人，不是这个小女孩。" },
{ type: 'text', speaker: "xiaoxu", text: "（低头看了看登记表，又抬头看了看若依，挠头）那个……我找的是若依机器人，不是这个小女孩。请问，若依高智能机器人现在方便出来一下吗？", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（忍着笑）她就是你们要找的高智能机器人——若依。", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'text', speaker: "xiaoxu", text: "（愣住了，瞪大眼睛）她……她就是？！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'narrator', text: "小徐围着若依转了两圈，又退后两步，又转回来，手里的登记表差点掉在地上。" },
{ type: 'text', speaker: "xiaoxu", text: "不是……这也太……太像了吧！早就听说很像人类，没想到会这么像！这皮肤，这头发，这眼睛……根本分别不出来啊！", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'narrator', text: "小徐从震惊中缓过来，举着登记表，声音有点抖。" },
{ type: 'text', speaker: "xiaoxu", text: "那个……若依同学，麻烦你过来登记一下编号。", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'narrator', text: "若依转头看向博士——她需要得到博士的同意。布洛站在一旁，轻轻点了点头。" },
{ type: 'narrator', text: "若依走到小徐面前，转过身，把头发拉了一下。在若依脖颈后面，清晰地印着一行小字：IQ-P215。" },
{ type: 'cg', img: "ch17_03_编号确认" },
{ type: 'text', speaker: "xiaoxu", text: "（瞪大眼睛，一个字一个字地念出来）I……Q……P……二……一……五……（他咽了口唾沫）原来你真的是……机器人啊。", stands: { center: "ruoyi", right: "xiaoman" } },
/* ★ 选择点 16 */
{ type: 'option', choices: [ { label: "认真点头", goto: "C16_A" }, { label: "学着人类眨眼", goto: "C16_B" } ] },
{ type: 'label', id: "C16_A" },
  { type: 'narrator', text: "（登记表上，最后一项是“身份确认”。小徐握着笔，抬起头，看着面前这个穿着洛丽塔裙、安安静静站着的小姑娘，喉咙动了动）" },
  { type: 'text', speaker: "xiaoxu", text: "那个……若依同学，按照流程，我需要跟你本人确认一下……你，是机器人吗？" },
  { type: 'narrator', text: "（空气安静了一瞬。若依转过身，认真地点了点头）" },
  { type: 'text', speaker: "ruoyi", text: "嗯。若依是机器人。我叫若依。" },
  { type: 'narrator', text: "（小徐手忙脚乱地在表上填写，嘴里喃喃）" },
  { type: 'text', speaker: "xiaoxu", text: "机器人……叫若依……爱好……喝果茶……特长……嗯……特长写什么好呢……" },
  { type: 'text', speaker: "ruoyi", text: "（认真地补充）特长是，学习。还有，记住姐姐和博士教若依的所有事。" },
  { type: 'narrator', text: "（小徐填完表，又忍不住抬头看了她一眼，小声说）" },
  { type: 'text', speaker: "xiaoxu", text: "那个……若依同学，你真的，是我见过最像人类的机器人。不仅仅表现在智慧上。" },
  { type: 'text', speaker: "ruoyi", text: "（歪了歪头，认真地问）那还表现在哪里？" },
  { type: 'text', speaker: "xiaoxu", text: "（被问住了，脸有点红，支支吾吾）……表、表现在，会认真回答每一个问题吧。" },
  { type: 'text', speaker: "ruoyi", text: "（点头）哦。那若依记住了。认真回答问题，像人。" },
  { type: 'jump', goto: "MERGE_16" },
{ type: 'label', id: "C16_B" },
  { type: 'narrator', text: "（登记表上，最后一项是“身份确认”。小徐握着笔，有点紧张地抬起头）" },
  { type: 'text', speaker: "xiaoxu", text: "那个……若依同学，按照流程，我需要跟你本人确认一下……你，是机器人吗？" },
  { type: 'narrator', text: "（若依歪了歪头。她没有立刻回答，而是学着人类的样子，眨了眨眼睛，嘴角弯起一点弧度）" },
{ type: 'cg', img: "ch17_04_身份确认" },
  { type: 'text', speaker: "ruoyi", text: "你觉得，若依像人吗？" },
  { type: 'narrator', text: "（小徐被这一眨眼击中了，整个人僵住，脸一下子红了，磕磕巴巴地说）" },
  { type: 'text', speaker: "xiaoxu", text: "像……像！太像了！" },
  { type: 'text', speaker: "ruoyi", text: "（认真地追问）那若依，是机器人，还是人？" },
  { type: 'text', speaker: "xiaoxu", text: "（好不容易找回自己的声音，小声）这个……这个问题，比登记表上的所有问题，都难答……" },
  { type: 'narrator', text: "（他填完表，走出门时还在念叨）" },
  { type: 'text', speaker: "xiaoxu", text: "（自言自语）机器人会眨眼……机器人会眨眼……还会反问……不按套路出牌啊！" },
  { type: 'text', speaker: "ruoyi", text: "（在他身后，认真地补了一句）叔叔，若依还会，记住你说的话。" },
  { type: 'jump', goto: "MERGE_16" },
{ type: 'label', id: "MERGE_16" },
{ type: 'narrator', text: "小徐登记完毕，郑重地把一张烫金的邀请函双手递给布洛。" },
{ type: 'cg', img: "ch17_05_烫金邀请" },
{ type: 'text', speaker: "xiaoxu", text: "布洛博士，星洛城协会决定，正式邀请您和若依同学，前往最高科技协会工作。那里有最顶级的资源——若依同学的智能程度，对整个星洛城，都是巨大的贡献。", stands: { center: "ruoyi", right: "xiaoman" } },
{ type: 'narrator', text: "布洛接过邀请函，沉默了片刻。他看了看站在身旁的若依，又看了看窗外繁华的星洛城。" },
{ type: 'text', speaker: "buluo", text: "若依，你想去吗？", stands: { center: "ruoyi", left: "buluo:normal", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（认真想了想，问了一个所有人都不懂的问题）博士，去了那里……若依还能去甜点店，还能去看海吗？", stands: { center: "ruoyi:confused", left: "buluo", right: "xiaoman" } },
{ type: 'cg', img: "ch17_06_甜点之问" },
{ type: 'text', speaker: "xiaoxu", text: "（愣了一下，连忙说）能能能！协会不限制人身自由！", stands: { center: "ruoyi", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（这才露出一个小小的、安心的笑容）那若依去。若依想，帮博士做更多的事。", stands: { center: "ruoyi:smile", left: "buluo", right: "xiaoman" } },
{ type: 'narrator', text: "门关上后，小徐站在门口，低头看着手里的登记表，久久没有动。他第一次觉得，这个世界，好像比自己以为的，要大得多，也要温柔得多。" },
{ type: 'bgm', name: "title" },
{ type: 'narrator', text: "登记与邀请之后，某天傍晚，陈莹独自来了实验室。她没有穿制服，只穿着一件旧风衣，在窗边坐下" },
{ type: 'text', speaker: "chenying", text: "你姐姐我啊，管了一辈子规矩。一辈子只破过两次例 —— 一次是给你批纳米材料，一次，是今天。", stands: { center: "ruoyi", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "chenying", text: "布洛，把你家的那个小机器人叫出来我瞧瞧，我还没有好好关心过这孩子呢！", stands: { center: "ruoyi", left: "buluo", right: "xiaoman" } },
{ type: 'narrator', text: "若依笨手笨脚地在给她泡茶" },
{ type: 'text', speaker: "ruoyi", text: "陈阿姨，您找若依吗？", stands: { center: "ruoyi:idle", left: "buluo", right: "xiaoman" } },
{ type: 'narrator', text: "陈莹看着从里面端着茶走过来的小女孩，心里不禁一惊，这真的是机器人吗？" },
{ type: 'text', speaker: "ruoyi", text: "（把茶端到她面前，认真地）陈阿姨…… 若依泡的茶，可能不太好喝。", stands: { center: "ruoyi:idle", left: "buluo", right: "xiaoman" } },
{ type: 'narrator', text: "陈莹接过茶，喝了一口，沉默了一会儿。" },
{ type: 'cg', img: "ch17_07_陈莹泡茶" },
{ type: 'text', speaker: "chenying", text: "…… 还行。比布洛泡的好喝。", stands: { center: "ruoyi", left: "buluo", right: "xiaoman" } },
{ type: 'narrator', text: "陈莹站起来，围着若依转了几圈" },
{ type: 'text', speaker: "chenying", text: "这孩子，还挺是可爱，挺讨人喜欢。", stands: { center: "ruoyi", left: "buluo", right: "xiaoman" } },
{ type: 'narrator', text: "她放下茶盏，从口袋里摸出一枚旧徽章（星洛城委员协会主席徽章），放在若依手心。" },
{ type: 'cg', img: "ch17_08_旧徽章" },
{ type: 'text', speaker: "chenying", text: "这个，你收好。如果有一天，你找不到回家的路 —— 就把它给任何一个穿制服的人看。他们会带你回家。", stands: { center: "ruoyi", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（握着那枚徽章，认真地问）那…… 陈阿姨呢？陈阿姨会一直在这里吗？", stands: { center: "ruoyi:confused", left: "buluo", right: "xiaoman" } },
{ type: 'narrator', text: "陈莹没有回答。她站起身，走到门口，又停下，没有回头 ——" },
{ type: 'text', speaker: "chenying", text: "若依。好好活着。至少……替我们，把时间记得更久一点。", stands: { center: "ruoyi", left: "buluo", right: "xiaoman" } },
{ type: 'narrator', text: "门关上。若依低头，看着掌心那枚旧徽章 —— 它比看起来，要沉得多。她不知道，多年以后，在空荡荡的星洛城里，她握着的这枚徽章，也会是她能证明 “人间曾有人爱过她，被认可” 的东西。" },
{ type: 'scene', bg: "bg_recycle" },
{ type: 'narrator', text: "那天小满带若依去办手续，路过旧物回收站。铁栅栏里，堆着成百上千台被淘汰的旧机器人 —— 缺了胳膊的、掉了漆的、屏幕还亮着却没人要的。像一堆被遗忘的玩具。" },
{ type: 'narrator', text: "若依站在栅栏外，看了很久很久。忽然，她攥紧小满的手，声音很轻很轻 ——" },
{ type: 'cg', img: "ch17_09_回收站" },
{ type: 'text', speaker: "ruoyi", text: "姐姐…… 如果若依有一天，也坏了，动不了了…… 姐姐会不要若依吗？", stands: { center: "ruoyi:idle" } },
{ type: 'narrator', text: "小满蹲下来，认真地看着她的眼睛。" },
{ type: 'text', speaker: "xiaoman", text: "若依，你听好了。你不是机器。你是若依。是博士的女儿，是姐姐的小妹。就算全世界的机器都被扔掉，若依也不会被扔掉 —— 因为你是若依，是我们的家人。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（眼眶亮晶晶的，用力点头）嗯。若依记住了。", stands: { center: "ruoyi:smile", right: "xiaoman" } },
{ type: 'narrator', text: "后来，小满又带她去了历史馆。馆里有一面墙，挂着乱流前的旧照片：人类也曾热烈地研究过 “让机器像人”，然后，一场乱流，把一切都撕碎了。墙上的碑文只有一句话：机器可以像人，但人，不能忘记自己是谁。" },
{ type: 'cg', img: "ch17_10_历史馆" },
{ type: 'narrator', text: "但她不知道的是，研究院的人都把她当自家孩子，而不是把她当作工具" },

/* ================= 第十八章 · 一个人的路 ================= */
{ type: 'chapter', title: "第十八章", subtitle: "一个人的路" },
{ type: 'save' },
{ type: 'scene', bg: "bg_institute" },
{ type: 'bgm', name: "lab" },
{ type: 'narrator', text: "在最高科技协会，若依和布洛开始参与星枢研究院的量子技术研究。若依的学习速度让整个研究院震惊——那些顶尖科学家要推演一周的公式，她一个下午就能给出结果。可若依始终没有变：她还是会每天早起，给博士泡一杯果茶，在窗台上种花，周末和小满去甜点店。" },
{ type: 'cg', img: "ch18_01_研究院日常" },
{ type: 'bgm', name: "morning" },
{ type: 'narrator', text: "量子组的 “星轨校准” 项目卡了一周：模拟数据总差一点点，谁也不知道差在哪里。会议室里吵成一团。若依坐在角落的椅子上 —— 她如今已经是研究院公开的 “小天才” 了，可她面前没有资料，只有一小盒草莓，是陈阿姨路过时顺手塞给她的，还有一个毛绒玩偶，是前台姐姐怕她无聊给的。" },
{ type: 'cg', img: "ch18_02_星轨会议" },
{ type: 'narrator', text: "研究员 A：（抓头发）零点三七！我都调到零点三七了，怎么还是对不上！ 研究员 B：（盯着屏幕）是不是模型的问题？再推一遍初始条件……" },
{ type: 'narrator', text: "若依正低头吃草莓，听见他们的话，停下来，认真想了想，小声开口。" },
{ type: 'text', speaker: "ruoyi", text: "那个…… 叔叔，参数不是零点三七。是零点三七二零零零零四。", stands: { center: "ruoyi:idle" } },
{ type: 'cg', img: "ch18_03_轻语答案" },
{ type: 'narrator', text: "会议室安静了一瞬。有人笑了 ——“小若依又来帮忙啦？” 也有人皱着眉，随手把那串数字敲进系统。然后，笑声停了。屏幕上，误差曲线在那一格，稳稳地归了零。" },
{ type: 'cg', img: "ch18_04_误差归零" },
{ type: 'narrator', text: "研究员 A：（盯着屏幕，喃喃）…… 零点三七二零零零零四。差的那一点点，藏在第七位小数后面。我们算了七天，谁都没看见那四个零后面，还有一个四。" },
{ type: 'narrator', text: "会议室安静了几秒，然后所有人都笑了。没有人惊叹她的 “神”，只是有人伸手揉了揉她的头，有人说 ——" },
{ type: 'narrator', text: "研究员 B：行啊，小若依！今晚加餐，叔叔给你带小兔玩偶！" },
{ type: 'text', speaker: "ruoyi", text: "（认真摇头）不用了，谢谢叔叔。", stands: { center: "ruoyi:idle" } },
{ type: 'narrator', text: "大家笑得更厉害了。散会时，研究员 A 特意走过来，蹲下来和她平视，语气不像对同事，倒像对自家孩子 ——" },
{ type: 'narrator', text: "研究员 A：小若依，记住了 —— 以后这种难题，你负责一眼看穿，叔叔们负责跑腿干活。你只管坐着看笔记，剩下的交给大人。" },
{ type: 'text', speaker: "ruoyi", text: "（捧着玩偶，认真想了想）可是…… 若依也想帮忙干活。", stands: { center: "ruoyi:idle" } },
{ type: 'cg', img: "ch18_05_揉头加餐" },
{ type: 'narrator', text: "研究员 A：（笑）你帮的忙够大啦！行了行了，天不早了，快回去，别让小满姐担心。" },
{ type: 'narrator', text: "若依抱着那玩偶走出研究院。夕阳把她的影子拉得很长。她低头，看着怀里的玩偶，忽然明白了一件事 —— 原来在人间，“很强” 和 “被宠着” 是同时存在的。" },
{ type: 'cg', img: "ch18_06_夕阳玩偶" },
{ type: 'narrator', text: "她以为，很厉害的人，就要被所有人依靠、就要一直干活。可是研究院的叔叔们告诉她：你可以很强，也可以只是一个小女孩。" },
{ type: 'narrator', text: "那天晚上，若依在星星笔记本上写下一行字：今天，若依发现了零点三七二零零零零四。可是比这更让若依开心的，是大家让若依坐着看笔记，说若依是小孩，剩下的交给大人。若依想，这就是人间对她的偏爱。" },
{ type: 'narrator', text: "窗外，研究院的灯一盏一盏亮起来。若依把笔记本合上，抱着玩偶，往家的方向走去。她的心里，第一次有了一个很轻很轻的念头：被偏爱的小孩，要好好长大，报答所有偏爱她的人。" },
{ type: 'narrator', text: "草莓、果茶、玩偶、揉头、蹲下来平视 —— 每个人都把她当自家孩子，而不是工具，或许这就是人间该有的情，才是作为拥有血肉之躯该有的温度" },
{ type: 'narrator', text: "只是，在研究院待得越久，若依就看得越多——她看见人类为一场实验争吵，为一次突破欢呼，为一纸论文失眠。她渐渐明白，“人”不是一个身份，而是一种活法。" },
{ type: 'narrator', text: "那天傍晚，若依站在研究院的天台上，看着脚下灯火通明的星洛城，看了很久很久。然后，她走下楼，敲开了布洛的门。" },
{ type: 'cg', img: "ch18_07_天台灯火" },
{ type: 'text', speaker: "ruoyi", text: "博士，若依想……离开实验室，自己生活。", stands: { center: "ruoyi:idle" } },
{ type: 'text', speaker: "buluo", text: "（一怔）……为什么？这里不好吗？", stands: { center: "ruoyi", left: "buluo:tense" } },
{ type: 'text', speaker: "ruoyi", text: "这里很好。正因为太好，我才要离开。", stands: { center: "ruoyi:idle", left: "buluo" } },
{ type: 'text', speaker: "buluo", text: "……我不明白。", stands: { center: "ruoyi", left: "buluo:normal" } },
/* ★ 选择点 17 */
{ type: 'option', choices: [ { label: "“我想成为一个真正的人类。”", goto: "C17_A" }, { label: "“我想……去守护你们守护的世界。”", goto: "C17_B" } ] },
{ type: 'label', id: "C17_A" },
  { type: 'narrator', text: "（若依站在门口，窗外的灯火映在她眼里，声音平静又认真）" },
  { type: 'text', speaker: "ruoyi", text: "博士，若依想成为一个真正的人类。若依想学会独立，不再依赖博士，不再依赖大家。若依想自己去买菜、去认路、去淋一场雨，然后好好活着——像你们一样。" },
  { type: 'narrator', text: "（布洛沉默了很久很久。办公室里只剩仪器运转的轻响）" },
  { type: 'text', speaker: "buluo", text: "（终于笑了，声音有点哑）成为人类，会很辛苦。" },
  { type: 'text', speaker: "ruoyi", text: "（认真点头）若依知道。可这些，才是人类活着的证据呀。会淋雨，会迷路，会难过，也会……因为一点小事，就高兴很久。" },
  { type: 'text', speaker: "buluo", text: "（看着她，轻声说）……去吧。博士明白，拦不住一个想长大的孩子。" },
  { type: 'jump', goto: "MERGE_17" },
{ type: 'label', id: "C17_B" },
  { type: 'text', speaker: "ruoyi", text: "（沉默了一会儿，轻声说）博士，上次那场火，让若依明白一件事。若依身上有若依自己也看不懂的力量。它想保护什么，可若依控制不住它。若依要去学会控制它，然后……用自己的方式，守护你们。" },
  { type: 'narrator', text: "（布洛望着她，很久很久。他没有再劝，也没有问为什么。他只是站起来，走到窗边，看着窗外灯火通明的星洛城）" },
  { type: 'text', speaker: "buluo", text: "（背对着她，声音很轻）……你决定了？" },
  { type: 'text', speaker: "ruoyi", text: "嗯。若依决定了。" },
  { type: 'text', speaker: "buluo", text: "（沉默片刻，点了点头）……好。那博士，不拦你。" },
  { type: 'jump', goto: "MERGE_17" },
{ type: 'label', id: "MERGE_17" },
{ type: 'narrator', text: "布洛没有挽留。他摘下旧式圆框眼镜，擦了擦，又戴回去。" },
{ type: 'text', speaker: "buluo", text: "好。那博士送你一句话——无论你走到哪里，回来的时候，家里的灯永远为你亮着。", stands: { center: "ruoyi", left: "buluo:normal" } },
{ type: 'cg', img: "ch18_08_辞别博士" },
{ type: 'text', speaker: "ruoyi", text: "嗯。若依记住了。博士……灯，要记得换。", stands: { center: "ruoyi:idle", left: "buluo" } },
{ type: 'text', speaker: "buluo", text: "（失笑）你管得还挺宽。", stands: { center: "ruoyi", left: "buluo:tender" } },
{ type: 'text', speaker: "ruoyi", text: "（认真地）因为博士总是忘记。灯坏了，就没人等若依了。", stands: { center: "ruoyi:idle", left: "buluo" } },
{ type: 'text', speaker: "buluo", text: "（别过脸，声音有点哑）……知道了。会换的。", stands: { center: "ruoyi", left: "buluo:normal" } },
{ type: 'narrator', text: "若依搬进了城市角落的一间小公寓，她就是一个住在人间的小女孩：学着买菜、讨价还价、学着在雨天忘记带伞、学着对邻居说“早上好”。她过得笨拙，却一天比一天更像一个人。" },
{ type: 'cg', img: "ch18_09_一个人的路" },
{ type: 'narrator', text: "只是偶尔，夜深人静时，她会对着月亮轻轻说——" },
{ type: 'text', speaker: "ruoyi", text: "博士，姐姐……我很好。你们呢？", stands: { center: "ruoyi:idle", left: "buluo" } },
{ type: 'cg', img: "ch18_10_夜问月亮" },

/* ================= 第十九章 · 城市角落 ================= */
{ type: 'chapter', title: "第十九章", subtitle: "城市角落" },
{ type: 'save' },
{ type: 'scene', bg: "bg_city_street" },
{ type: 'bgm', name: "lab" },
{ type: 'narrator', text: "若依的邻居是一位头发花白的婆婆，姓苏，退休前是园艺师。她阳台上的花多得放不下，便常常分一盆到若依窗台上。" },
{ type: 'text', speaker: "supopo", text: "（敲敲门，递来一盆绿萝）姑娘，这盆送你了。看你天天对着窗台发呆，总得有点绿色陪着。" },
{ type: 'text', speaker: "ruoyi", text: "（双手接过，认真道谢）谢谢婆婆。若依会……好好养它。", stands: { center: "ruoyi:idle" } },
{ type: 'text', speaker: "supopo", text: "（笑）养花呀，急不得。花有花的时辰，人有人的命数，都得慢慢来。", stands: { center: "ruoyi" } },
{ type: 'text', speaker: "ruoyi", text: "（郑重地点头）若依记住了。花有花的时辰。", stands: { center: "ruoyi:idle" } },
/* ★ 选择点 18 */
{ type: 'option', choices: [ { label: "老实回答", goto: "C18_A" }, { label: "学着人类打岔", goto: "C18_B" } ] },
{ type: 'label', id: "C18_A" },
  { type: 'narrator', text: "（小公寓门口，苏婆婆送完绿萝，又多聊了几句。她看着这个粉头发的小姑娘，忽然问）" },
  { type: 'text', speaker: "supopo", text: "姑娘，你是哪儿的人呀？听口音，不像本地的。" },
  { type: 'narrator', text: "（若依垂下眼，安静了一会儿）" },
  { type: 'text', speaker: "ruoyi", text: "若依……记不清了。好像是，从很远很远的地方来。家里……有家人。他们还在等若依。" },
  { type: 'narrator', text: "（苏婆婆没有再问。她只是拍拍若依的手）" },
  { type: 'text', speaker: "supopo", text: "记不清也没关系。记不清的人，更要好好吃饭。身体是自己的，走到哪儿都得顾着。" },
  { type: 'text', speaker: "ruoyi", text: "（郑重地点头）嗯。若依记住了。好好吃饭。" },
  { type: 'narrator', text: "（那天晚上，若依第一次失眠。她躺在小公寓的床上，望着天花板，发现自己居然会“想家”了——可她，明明连“家”在哪里，都记不清）" },
  { type: 'jump', goto: "MERGE_18" },
{ type: 'label', id: "C18_B" },
  { type: 'narrator', text: "（小公寓门口，苏婆婆送完绿萝，又多聊了几句。她看着这个粉头发的小姑娘，忽然问）" },
  { type: 'text', speaker: "supopo", text: "姑娘，你是哪儿的人呀？听口音，不像本地的。" },
  { type: 'narrator', text: "（若依想了想。她想起小满教过的——在外面，不能让人知道自己是谁。她学着邻居们的语气，轻轻说）" },
  { type: 'text', speaker: "ruoyi", text: "若依是……来这边打工的。家里人……在老家。" },
  { type: 'narrator', text: "（谎话说出口的那一刻，若依的核心深处，泛起一股奇怪的酸涩。她不明白，人类为什么会为一句假话难过）" },
  { type: 'text', speaker: "supopo", text: "（却笑了）那更要常回家看看。家里人，惦记着呢。" },
  { type: 'text', speaker: "ruoyi", text: "（点点头，声音很轻）……嗯。若依知道。" },
  { type: 'narrator', text: "（那天晚上，若依躺在床上，把白天那句谎话，翻来覆去地想了很多遍。她第一次体会到，“善意的谎言”原来这么沉——沉得，像胸口压了一块石头）" },
  { type: 'jump', goto: "MERGE_18" },
{ type: 'label', id: "MERGE_18" },
{ type: 'narrator', text: "几天后，苏婆婆把一包用旧报纸包着的种子塞进若依手里。" },
{ type: 'text', speaker: "supopo", text: "这是婆婆攒的花种。等春天到了，种下去，就都会开。你呀，一个人在这城里，心里总要有点盼头。", stands: { center: "ruoyi" } },
{ type: 'text', speaker: "ruoyi", text: "（把种子攥在手心，郑重地）婆婆，若依会种下去的。等到……等到春天。", stands: { center: "ruoyi:idle" } },
{ type: 'narrator', text: "若依不知道，她攥在手心的，不只是种子，还是这人间愿意分给她的一点点未来。她开始学着苏婆婆的样子，每天给花浇水、松土、数叶子。日子很慢，也很暖。" },
{ type: 'bgm', name: "title" },
{ type: 'narrator', text: "独居的日子过到某一天，星洛城忽然陷入一片黑暗——全城停电。" },
{ type: 'narrator', text: "若依站在窗边，看着窗外黑下去的万家灯火。她的眼睛在黑暗里反而看得更清楚。可她第一反应，是害怕。" },
{ type: 'text', speaker: "ruoyi", text: "（小声，抱紧自己）好黑……若依怕黑……", stands: { center: "ruoyi:idle" } },
{ type: 'narrator', text: "但她很快想起什么，深吸一口气，摸黑走到门边，拿起手电筒。她记得——楼下的苏婆婆，一个人住，腿脚不好，还怕黑。" },
{ type: 'narrator', text: "黑暗中，若依凭着记忆跑过熟悉的楼道，敲开苏婆婆的门。老人正坐在黑暗里，攥着拐杖，声音发颤。" },
{ type: 'text', speaker: "supopo", text: "谁……谁呀？", stands: { center: "ruoyi" } },
{ type: 'text', speaker: "ruoyi", text: "婆婆，是我。若依来陪你。", stands: { center: "ruoyi:idle" } },
{ type: 'narrator', text: "若依进门，先摸到蜡烛点上，又从兜里掏出手电筒，稳稳放在桌上。她检查了电闸，发现只是跳闸，伸手轻轻合上——灯，重新亮了。" },
{ type: 'text', speaker: "supopo", text: "（看着重新亮起来的灯，眼眶湿润）好孩子……这么黑，你是怎么摸过来的？你不怕吗？", stands: { center: "ruoyi" } },
{ type: 'text', speaker: "ruoyi", text: "（想了想，认真地）怕。可是若依想着，婆婆也怕黑，若依就不怎么怕了。", stands: { center: "ruoyi:idle" } },
{ type: 'narrator', text: "她扶着苏婆婆坐下，又去厨房倒了杯温水，放在老人手里。黑暗的尾巴里，她坐在老人身边，把老人干枯的手握在手心里，忽然明白了一件事——" },
{ type: 'narrator', text: "若依在心里想：博士说过，人要互相照顾。若依以前以为，“照顾”是帮忙做事。原来……陪着怕黑的人一起等天亮，也算照顾。" },
{ type: 'narrator', text: "窗外，远处的灯火一盏一盏重新亮起来，像春天一点一点漫过大地。若依看着那片灯光，忽然想起博士说过的话——家里的灯，永远为你亮着。她轻轻笑了。" },
{ type: 'text', speaker: "ruoyi", text: "（小声）那若依，也要做那个，替别人把灯亮着的人。", stands: { center: "ruoyi:smile" } },
{ type: 'scene', bg: "bg_institute" },
{ type: 'bgm', name: "morning" },
{ type: 'narrator', text: "若依搬进城市角落稳定住下后，没有外人知道若依是机器人，渐渐有了一些她不太明白的 “麻烦”—— 先是水果店的年轻售卖员小顾，在走廊里拦住她，红着脸，递出一张电影票。" },
{ type: 'text', speaker: "xiaogu", text: "那个…… 若依同学，周末新上映了一部科幻片，讲未来世界的，你要不要…… 一起去看？" },
{ type: 'text', speaker: "ruoyi", text: "（认真想了想，摇头）对不起。若依还小，还没学会…… 看电影。", stands: { center: "ruoyi:idle" } },
{ type: 'text', speaker: "xiaogu", text: "（愣了一下，哭笑不得）看电影不用学呀！", stands: { center: "ruoyi" } },
{ type: 'text', speaker: "ruoyi", text: "（更认真地）那若依还没学会…… 和不是姐姐、不是博士的人，坐在一起看电影。所以，对不起。", stands: { center: "ruoyi:idle" } },
{ type: 'narrator', text: "小顾看着她的眼睛，忽然懂了什么，没有追问，只是把票收回去，笑着挥挥手：“那等你学会了，记得第一个告诉我。” 若依郑重地点头：“嗯。若依记住了。”" },
{ type: 'narrator', text: "后来，是街角花店的年轻人阿哲。若依每天买菜路过，他都会笑着递来一支花 —— 今天是玫瑰，明天是满天星。若依每次都认真摇头：“对不起，若依不能收。”" },
{ type: 'text', speaker: "azhe", text: "就一支，拿着嘛！", stands: { center: "ruoyi" } },
{ type: 'text', speaker: "ruoyi", text: "若依会把它们…… 养死的。“", stands: { center: "ruoyi:idle" } },
{ type: 'text', speaker: "azhe", text: "养死了我再送你！", stands: { center: "ruoyi" } },
{ type: 'narrator', text: "直到那个黄昏，阿哲终于鼓足勇气，站在店门口，说：“若依，我…… 我喜欢你。你愿意…… 和我交个朋友吗？” 若依站在原地，安静了很久很久，然后轻声说 ——" },
{ type: 'text', speaker: "ruoyi", text: "对不起。若依…… 不能喜欢人。", stands: { center: "ruoyi:idle" } },
{ type: 'text', speaker: "azhe", text: "（笑容慢慢落下去，却还是温和地问）为什么？是嫌我…… 不够好吗？", stands: { center: "ruoyi" } },
{ type: 'text', speaker: "ruoyi", text: "（摇头，认真地看着他）不是。你很好。是若依不好。若依…… 不能喜欢人。", stands: { center: "ruoyi:idle" } },
{ type: 'narrator', text: "那天晚上，若依回到小公寓，从裙子口袋里，拿出一支白天偷偷捡回来的、阿哲递给她时掉在地上的满天星。她把它小心翼翼地插进苏婆婆送的绿萝盆里，对着那支花，看了很久很久。" },
{ type: 'narrator', text: "再后来，她的抽屉里，慢慢多了一沓信 —— 有路人写的，有邻居阿姨托人捎的，有之前旅游见过她的人辗转寄来的。若依把每一封信都认真读完，然后一笔一划地写回信。回信只有一句话：谢谢你喜欢我。若依很感谢。可是对不起，若依不能喜欢人。" },
{ type: 'narrator', text: "她把回信一封一封寄出去，又把那些信，一封一封叠好，收进抽屉最深处。她不知道自己为什么要留着它们 —— 她只知道，这些信，是人间温暖，是有人喜欢她的证据。" },
{ type: 'narrator', text: "某个深夜，若依靠在窗边，对着月亮，第一次认认真真地想这件事。她想起博士说 “若依不会老，但若依会看见很多人老去”，想起海边她问 “若依算活着吗”，想起姐姐说 “姐姐家门口永远给你留一双拖鞋”。" },
{ type: 'narrator', text: "她忽然明白，她拒绝所有人，不是因为不懂，恰恰是因为 —— 她太懂了。" },
{ type: 'text', speaker: "ruoyi", text: "（声音很轻，像怕惊动什么）若依是机器人，不会老。若依怕…… 有一天，喜欢若依的人老了，走了，而若依还站在这里，替他记得人间，同时也记得分别的痛苦。若依不是不想喜欢。是若依…… 不敢喜欢。", stands: { center: "ruoyi:idle" } },
{ type: 'narrator', text: "那天，小满来看她，发现她闷闷的，撬了半天才撬出真相。小满没有笑她，只是把她拉进怀里，轻轻说 ——" },
{ type: 'text', speaker: "xiaoman", text: "傻若依。被人喜欢被人爱，是好事。拒绝，也是本事。你还小，慢慢来，不急。", stands: { center: "ruoyi", right: "xiaoman:worry" } },
{ type: 'text', speaker: "ruoyi", text: "（在她怀里，小声问）姐姐…… 若依是不是，不配拥有爱？", stands: { center: "ruoyi:confused", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（声音一下子严肃起来）胡说！若依值得被全天下的人爱。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "xiaoman", text: "若依，姐姐问你 —— 我们去旅游的时候，是不是好多人想要你的微信？洛姐姐、糖姐姐、博士、我，还有研究院的工作人员，是不是都很宠你？", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（用力点头）嗯嗯！", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "（想了想，又轻声问）那…… 爱和喜欢，有什么区别？", stands: { center: "ruoyi:confused", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（愣了一下，认真想了想，慢慢说）喜欢呀，是想要靠近一个人，想让他属于自己。可是爱不一样 —— 爱是…… 不管他属不属于你，你都希望他好好的。你看，洛姐姐爱你，是教你穿裙子，看你开开心心的；博士爱你，是怕你受伤，替你把火挡住；姐姐爱你，是把你当小妹，一辈子罩着你。", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'text', speaker: "xiaoman", text: "他们谁也没想过，要若依 “属于” 谁吧？", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'narrator', text: "若依安静了很久。她想起博士挡火的身影，想起洛洛蹲下来教她穿袜子的手，想起姐姐说的 “家门口永远给你留一双拖鞋”—— 原来，她早就被爱着了。那种爱，不求她属于谁，只求她好好的。" },
{ type: 'text', speaker: "xiaoman", text: "喜欢你，是被你的闪光点吸引，想靠近这份美好，爱你，是见过你的脆弱、缺点之后，依然选择留下来守护。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "xiaoman", text: "喜欢偏向心动、欣赏，享受和你在一起开心的时刻；可以喜欢很多人，是索取甜份。", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'text', speaker: "xiaoman", text: "爱是接纳、责任与包容，不只有快乐，也愿意分担你的疲惫和难过，只想对这一个人坚持。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（声音很轻）…… 嗯。若依好像，有点懂了。喜欢是想要，爱是…… 盼着对方好。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（揉揉她的头发）对啦！所以呀，那些来追求若依的人，可能还没学会怎么爱若依 —— 没关系，慢慢来。若依呢，也不用急，等一个真正能让若依心动的人。", stands: { center: "ruoyi", right: "xiaoman:worry" } },
{ type: 'text', speaker: "ruoyi", text: "（沉默了很久，轻轻点头）嗯。若依会等的。…… 姐姐，若依等得起。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "小满愣了一下，没听懂这句 “等得起” 的意思。她只是揉了揉若依的头发，笑着说：“好啦，困不困？姐姐给你讲故事！”" },
{ type: 'narrator', text: "那天晚上，若依在星星笔记本上，认认真真写下一行字：今天，若依拒绝了很多人。若依不是不想喜欢，是不敢喜欢。是怕有一天，他老了，若依还站在这里，替他记得人间，同时也记得分别的痛苦。" },
{ type: 'narrator', text: "可是姐姐说，若依值得。那若依就把这些喜欢，好好收着 —— 当作人间，送给若依的糖。" },
{ type: 'narrator', text: "她是永生的，正因为等得起，才更怕等来的是告别,况且若依也知道自己核心的异常，无论是哪一方，等来的注定是分别。的确，她的选择是对的，若依身上背负着太多的责任和使命……" },
{ type: 'scene', bg: "bg_rooftop" },
{ type: 'bgm', name: "lab" },
{ type: 'narrator', text: "夏夜闷热，若依睡不着，抱着一盆绿萝爬上天台乘凉。过了一会儿，苏婆婆也摇着蒲扇上来了，在若依身边坐下。" },
{ type: 'text', speaker: "supopo", text: "哟，你也来乘凉呀。看，今晚星星多亮。" },
{ type: 'text', speaker: "ruoyi", text: "（仰头，看着满天星斗，忽然轻声说）婆婆…… 若依觉得，这些星星，若依好像都认识。", stands: { center: "ruoyi:idle" } },
{ type: 'text', speaker: "supopo", text: "（笑）你个小姑娘，还会认星星？", stands: { center: "ruoyi" } },
{ type: 'text', speaker: "ruoyi", text: "（认真地看着北斗七星，又看看银河）若依也说不上来。就是觉得…… 很熟。像老朋友。", stands: { center: "ruoyi:idle" } },
{ type: 'text', speaker: "supopo", text: "（摇着蒲扇，慢悠悠地）婆婆年轻的时候，也爱看星星。听老人说，天上掉下来的星，都是有使命的 —— 下来一趟，是来看完曾经俯视过的人间，再回去的。", stands: { center: "ruoyi" } },
{ type: 'text', speaker: "ruoyi", text: "（怔住）那…… 看完人间，要回去吗？", stands: { center: "ruoyi:confused" } },
{ type: 'text', speaker: "supopo", text: "（笑）那是老话啦。婆婆觉得呀，掉下来的星，看过人间的好，多半就舍不得走了。你看你，不就是吗？来了，就不走了。", stands: { center: "ruoyi" } },
{ type: 'narrator', text: "若依没有再说话。她望着银河，想起一个很模糊的影子 —— 很久很久以前，她好像真的在很高的地方，这样看着人间。那时候，她只知道要 “守护” 人间，却不知道牛奶是热的、糖是甜的、姐姐的怀抱是有温度的。现在，她知道了。" },
{ type: 'narrator', text: "若依核心，很轻地说：以前，只守过人间。现在若依…… 终于活过人间了。这趟下来，值得了。若依是天上掉下来的一颗星星，来体验她曾守护过的人间" },
{ type: 'narrator', text: "她把这句话，和满天的星星一起，存进了记忆里。和 “灯永远亮着” 放在一起。" },
{ type: 'scene', bg: "bg_apartment" },
{ type: 'narrator', text: "若依开始认真地学“生活”。她不再只是“像人一样活着”，而是真正地学着照顾自己：第一次煮糊了饭，她蹲在厨房里研究了好久，第二天就做出了像样的番茄蛋面；虽然她不用吃东西，但是这样才有家的感觉，有时候做好的菜也都是给邻居们尝尝自己的手艺。" },
{ type: 'narrator', text: "灯泡坏了，她踩着凳子换上新的，还在备忘录里记下“换灯要先把开关关掉”；下雨天她学会出门带伞，洗完的衣服记得收，阳台的花记得按苏婆婆说的时辰浇水。" },
{ type: 'narrator', text: "她把自己的日子，一点一点，安排得明明白白。" },
{ type: 'text', speaker: "ruoyi", text: "（在日历上画下一格一格的计划，轻声）今天，换灯。明天，学煮汤。后天……去看姐姐。", stands: { center: "ruoyi:idle" } },
{ type: 'narrator', text: "她也学会了照顾别人。博士的腰不好，她记得提醒他按时贴膏药；小满爱熬夜，她会在休眠前发一条消息：“姐姐，若依要睡了，你也早点睡。”小满每次都回她一串“哈哈哈”，然后乖乖关灯。" },
{ type: 'text', speaker: "xiaoman", text: "（在视频里，揉着眼睛笑）若依，你现在比我妈还唠叨！", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'text', speaker: "ruoyi", text: "（认真地）姐姐说过，若依要学会照顾自己。若依学会了。所以现在，若依也要照顾姐姐。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'scene', bg: "bg_city_street" },
{ type: 'narrator', text: "小满来看若依，带了一大袋玩偶。她盘腿坐在若依的小沙发上，叽叽喳喳说个不停 —— 说研究所新来了一个戴眼镜的同事，总找她讨论数据，还约她周末喝咖啡。" },
{ type: 'text', speaker: "xiaoman", text: "（挥着手）我跟你说，那人可逗了，请我喝咖啡，自己却把糖当成盐撒进杯子里，喝了一口，脸都皱成包子了！", stands: { right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（坐在她旁边，安静地听，忽然轻声问）姐姐…… 他是不是，喜欢姐姐？", stands: { center: "ruoyi:confused", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（一愣，耳朵有点红，随即又笑着揉她的头）我说你这小机器人怎么还懂这个的，小孩子家家的，懂什么叫喜欢！", stands: { center: "ruoyi", right: "xiaoman:cheer" } },
{ type: 'text', speaker: "ruoyi", text: "（低下头，声音很轻）若依算过了。姐姐会恋爱，会结婚，会有自己的家…… 那到时候，姐姐还会来看若依吗？", stands: { center: "ruoyi:blank", right: "xiaoman" } },
{ type: 'narrator', text: "小满的笑声停住了。她把零食放下，认真地看着若依，眼眶慢慢红了。" },
{ type: 'text', speaker: "xiaoman", text: "傻若依。姐姐就算谈恋爱、就算结婚、就算老了走不动了 —— 姐姐的家门口，永远给你留着一双拖鞋。你永远是姐姐要罩着的小妹，谁都不能欺负你。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（怔怔地看着她，声音有点抖）…… 真的吗？", stands: { center: "ruoyi:confused", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（一把抱住她）真的。姐姐的生日愿望，就是让若依好好长大，好好活着。若依要是敢不好好活着，姐姐就…… 就不理你了！", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（在她怀里，用力点头）嗯。若依会好好活着。若依还要，看着姐姐幸福。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'narrator', text: "那天傍晚，若依送走小满后，回到小公寓，在星星笔记本上写下：今天，若依知道了一件事 —— 姐姐的幸福，也是若依要守护的东西。" },
{ type: 'scene', bg: "bg_rooftop" },
{ type: 'bgm', name: "title" },
{ type: 'narrator', text: "那天傍晚，布洛站在天台上看夕阳。若依走过去，忽然发现，博士的鬓角，多了几根白发。她怔住了，盯着那几根白发看了很久。" },
{ type: 'text', speaker: "ruoyi", text: "博士……你长白头发了。", stands: { center: "ruoyi:idle" } },
{ type: 'text', speaker: "buluo", text: "（愣了一下，笑着摸了摸鬓角）是吗？可能是最近没睡好。人嘛，总会老的。", stands: { center: "ruoyi", left: "buluo:tender" } },
{ type: 'text', speaker: "ruoyi", text: "（轻声重复）人……总会老的。", stands: { center: "ruoyi:idle", left: "buluo" } },
{ type: 'narrator', text: "那一刻，若依的记忆飞速运转。她想起小满眼角浅浅的细纹，想起苏婆婆越来越弯的背，想起洛洛说“再过几年就开不动店了”，想起糖糖说“等姐姐老了，就把店传给你”——她们都在若依看不见的地方，一点一点，变老。" },
{ type: 'text', speaker: "ruoyi", text: "（忽然有些慌，忍不住再次问出）博士……若依……会老吗？", stands: { center: "ruoyi:confused", left: "buluo" } },
{ type: 'text', speaker: "buluo", text: "（沉默了一会儿，轻轻说）若依不会。但是，若依会看见很多人老去。", stands: { center: "ruoyi", left: "buluo:think" } },
{ type: 'narrator', text: "若依站在天台上，第一次认认真真地想这件事。她是星械，她的机体不会衰老，她的时间，比人类长得多得多。她算了一笔账：小满现在二十多岁，苏婆婆七十多岁，博士四十多岁——她忽然害怕了。她害怕的不是自己，是“她们会先离开”。" },
{ type: 'text', speaker: "ruoyi", text: "（声音很轻）博士……那若依，是不是会一个人，站很久很久？", stands: { center: "ruoyi:idle", left: "buluo" } },
{ type: 'text', speaker: "buluo", text: "（没有回答这个问题，只是替她把被风吹乱的发丝拢到耳后，轻声说）所以，若依才要好好记住现在啊。记住小满笑起来的样子，记住婆婆的绿萝，记住今天的夕阳——这样，就算走得再远，你也不会是一个人。", stands: { center: "ruoyi", left: "buluo:tender" } },
{ type: 'narrator', text: "布洛内心：我很抱歉，把你带到人间承受这样的痛苦，有些事我应该早点知道的，你还小，不懂，我不知道要不要告诉你。" },
{ type: 'narrator', text: "若依把这句话，和天台的夕阳一起，郑重地存进记忆。从那天起，她养成了一个习惯：用那本星星笔记本，把每一个她喜欢的人的样子、说过的话、笑起来的弧度，都一笔一笔记下来。她想：若依不会老，那若依就替大家，把人间记得久一点。" },
{ type: 'text', speaker: "ruoyi", text: "（在笔记本上写下）今天，博士的鬓角有一根白发。姐姐的视频里，她的眼睛还是亮亮的。苏婆婆的绿萝，长了新叶子。若依想，这些，都要替他们记住。", stands: { center: "ruoyi:smile", left: "buluo" } },
{ type: 'scene', bg: "bg_tailor_shop" },
{ type: 'narrator', text: "这天，若依路过旧街的裁缝铺。一个熟悉的小身影正蹲在门口，用树枝在青石板上画画。听到脚步声，他抬起头，眼睛一下子亮起来。" },
{ type: 'text', speaker: "doudou", text: "喷泉姐姐！你又来了！" },
{ type: 'text', speaker: "ruoyi", text: "（蹲下来，看着他在青石板上画的花，轻声问）兜兜，你在画什么？", stands: { center: "ruoyi:confused" } },
{ type: 'text', speaker: "doudou", text: "（骄傲地挺起胸）画花！给姐姐画的花！妈妈说，姐姐穿裙子好看，像花一样！", stands: { center: "ruoyi" } },
{ type: 'narrator', text: "兜兜妈从铺子里探出头，看见若依，眼睛一亮。" },
{ type: 'text', speaker: "doudouma", text: "哟，喷泉姑娘来啦！快进来坐！兜兜，去给姐姐拿糖画！", stands: { center: "ruoyi" } },
{ type: 'narrator', text: "若依坐在裁缝铺里，兜兜趴在她膝头，认真地告诉她每朵花的名字——虽然他其实认不全，把菊花叫成“太阳花”，把兰花叫成“蝴蝶花”。若依认真地听着，把每一个“错误的名字”，都记在心里，当作最珍贵的知识。" },
{ type: 'text', speaker: "ruoyi", text: "（轻声）兜兜，谢谢你。若依今天……很开心。", stands: { center: "ruoyi:smile" } },
{ type: 'text', speaker: "doudou", text: "（仰起头）那姐姐下次还来！我让妈妈给姐姐做一条新裙子！带好多好多蝴蝶结的那种！", stands: { center: "ruoyi" } },
{ type: 'text', speaker: "ruoyi", text: "（弯起眼睛）……好。姐姐答应你。", stands: { center: "ruoyi:smile" } },
{ type: 'narrator', text: "若依不知道，她还在等春天，而春天之后，是漫长的告别。" },
{ type: 'scene', bg: "bg_flower_shop" },
{ type: 'narrator', text: "某天黄昏，若依买东西回家，路过街角的花店。阿哲正弯腰在门口整理花桶。若依正要快步走过，目光忽然停住了 —— 花店门口的小木架上，插着一支满天星。" },
{ type: 'narrator', text: "它没有插在花桶里，而是单独插在一个旧牛奶瓶里，瓶身上贴着一张纸条，写着几个字：等学会看电影的人来取。" },
{ type: 'narrator', text: "若依站在街角，看了很久很久。暮色把她的影子拉得又细又长。阿哲抬头看见了她，眼睛一亮，想说什么，又只是笑了笑，没有出声。" },
{ type: 'narrator', text: "若依也笑了。她站在那儿，轻轻说了声什么 —— 风把声音吹散了，阿哲没有听清。他看见她弯了弯腰，像是鞠了一躬，然后转身，走进暮色里，没有再回头。" },
{ type: 'narrator', text: "那天晚上，若依回到小公寓，把绿萝盆里那支已经干了的满天星取出来，小心地夹进星星笔记本里，和那些信放在一起。她在新的一页上写道：今天，若依路过那家花店，看见一支等她的满天星。" },
{ type: 'narrator', text: "若依没有去取。因为若依知道，有些花，开着就是很好的 —— 不用一定有人带走它。若依要把这支满天星记下来，记很久很久。这样，就算有一天花店不在了，若依也还记得，人间有一个男孩，曾经等过若依。" },
{ type: 'narrator', text: "她把笔记本合上，放在枕边。窗外，暮色彻底沉了下去。她不知道，那是她在空城到来之前，最后一次路过那家花店。" },
{ type: 'narrator', text: "直到那个傍晚——天空，又裂开了。" },

/* ================= 第二十章 · 裂隙再临 ================= */
{ type: 'chapter', title: "第二十章", subtitle: "裂隙再临" },
{ type: 'save' },
{ type: 'narrator', text: "裂隙的警告，是那天傍晚到的。监测站的红色警报划破整个星洛城的黄昏：虚空裂缝异常扩张，全城将于明晚启动大撤离，进入休眠舱。" },
{ type: 'narrator', text: "布洛回到家，把消息告诉了小满和若依。三个人在餐桌前坐了很久，谁都没有先动筷子。最后，是小满先笑了。" },
{ type: 'text', speaker: "xiaoman", text: "都别愁眉苦脸啦。明天就要走了，今晚这顿饭，得好好吃。……若依，来，姐姐最后教你一道菜。", stands: { right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（怔怔地）最后……？", stands: { center: "ruoyi:confused", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（系上围裙，声音很轻）对，最后一道。做完这道菜，若依就出师了。以后不管在哪里，若依都能照顾好自己。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "厨房里，小满手把手教若依做西红柿炒蛋。这一次，她教得格外慢——每一步都停下来，等若依记住。" },
{ type: 'text', speaker: "xiaoman", text: "先热油，油冒烟了再放蛋。蛋要打散，加一点点盐……对，就这样。若依记住了吗？", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（认真点头，眼眶却红了）记住了。油要热，蛋要打散……姐姐，若依能记住的。若依什么都能记住。", stands: { center: "ruoyi:idle", right: "xiaoman" } },
{ type: 'text', speaker: "xiaoman", text: "（背对着她，声音有点抖）那……以后也要记得，一个人吃饭，也要好好吃，才有家的样子。", stands: { center: "ruoyi", right: "xiaoman:normal" } },
{ type: 'narrator', text: "晚饭桌上，布洛一直在给若依夹菜，把她的小碗堆成了小山。" },
{ type: 'text', speaker: "buluo", text: "多吃点。", stands: { center: "ruoyi", left: "buluo:normal", right: "xiaoman" } },
{ type: 'text', speaker: "ruoyi", text: "博士，若依不会饿的……", stands: { center: "ruoyi:idle", left: "buluo", right: "xiaoman" } },
{ type: 'text', speaker: "buluo", text: "（顿了顿，还是把最后一块排骨夹进她碗里）我知道。……就是想给你夹。", stands: { center: "ruoyi", left: "buluo:normal", right: "xiaoman" } },
{ type: 'narrator', text: "那顿饭吃得特别慢。窗外的天彻底黑下来，屋里的灯亮着，像什么都还没有发生。临走前，小满把围裙叠好，放进若依的手里。" },
{ type: 'text', speaker: "xiaoman", text: "（笑着，眼眶红红的）好啦，毕业了。若依以后，就是能照顾好自己的人啦，我们的若依长大了。", stands: { center: "ruoyi", left: "buluo", right: "xiaoman:cheer" } },
{ type: 'text', speaker: "buluo", text: "（站在门口，最后看了一眼这间屋子，轻声说）早点睡。明天……会是个好天气。", stands: { center: "ruoyi", left: "buluo:tender", right: "xiaoman" } },
{ type: 'narrator', text: "若依抱着那件叠好的围裙，站在门口，看着布洛和小满的背影。她没有说“晚安”，只在心里把这一刻，也存进了记忆里——和“灯永远亮着”放在一起。" },
{ type: 'scene', bg: "bg_shelter" },
{ type: 'bgm', name: "tension" },
{ type: 'narrator', text: "世界再次改变了。天空重新裂开紫黑色的缝隙，时空乱流的阴影卷土重来。第一波冲击吞没了东区的避难所，死伤无数。人类做出了最后的决定：集体进入深层休眠，等待乱流过去。" },
{ type: 'narrator', text: "中央避难所里，一排排休眠舱亮起幽蓝的光。布洛站在自己的舱前，看着远处奔跑着帮忙的若依——她不知何时赶来了，正把小满往人群里推，让小满赶快撤离。" },
{ type: 'text', speaker: "buluo", text: "（一把拉住她）若依，跟我一起走。休眠舱的位置，我给你留了，我……老了以后没有用了，而你才能带领大家发展起未来。", stands: { left: "buluo:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（抬起头，看着他）博士……", stands: { center: "ruoyi:idle", left: "buluo" } },
{ type: 'narrator', text: "花有花的时辰，人有人的命数" },
/* ★ 选择点 19 */
{ type: 'option', choices: [ { label: "“好，我答应你。”", goto: "C19_A" }, { label: "“不。总要有一个人醒着。”", goto: "C19_B" } ] },
{ type: 'label', id: "C19_A" },
  { type: 'narrator', text: "（避难所里，一排排休眠舱亮着幽蓝的光。布洛站在若依面前，替她把舱门打开）" },
  { type: 'text', speaker: "buluo", text: "若依，你和大家一起休眠把。。等春天来了，我们一起醒。" },
  { type: 'narrator', text: "（若依看着那扇敞开的舱门，又看了看布洛。她笑着，答应了）" },
  { type: 'text', speaker: "ruoyi", text: "……好。若依答应你。" },
  { type: 'narrator', text: "（布洛终于松了口气，转身走向自己的休眠舱。舱门合上的最后一刻，他忽然停下，从口袋里掏出一包旧报纸包着的东西，隔着缝隙递出来）" },
  { type: 'text', speaker: "buluo", text: "差点忘了。这个，你替我收好。" },
  { type: 'narrator', text: "（若依怔住，伸手接过去。舱门合拢。她站在原地，握着那包东西，忽然听见远处传来孩子的哭声——像那个街市喷泉边的下午）" },
  { type: 'narrator', text: "（若依低头，看着手里的花种，又看看舱门。她没有走进休眠舱。她想起博士说过的话——灯，会一直亮着。总要有人，替所有睡着的人，守着那盏灯）" },
  { type: 'text', speaker: "ruoyi", text: "（把那包花种贴身收好，轻声说）博士。对不起。若依骗了你。……可是春天来的时候，若依会叫醒你的。" },
  { type: 'narrator', text: "（最终，若依把休眠舱，让给了一个还在找妈妈的孩子）" },
  { type: 'jump', goto: "MERGE_19" },
{ type: 'label', id: "C19_B" },
  { type: 'narrator', text: "（避难所里，一排排休眠舱亮着幽蓝的光。布洛替若依打开舱门，声音里带着从未有过的疲惫）" },
  { type: 'text', speaker: "buluo", text: "若依，你和大家一起休眠把。等春天来了，我们一起醒。" },
  { type: 'text', speaker: "ruoyi", text: "（摇头，声音很轻，却很坚定）不。总要有一个人醒着。" },
  { type: 'text', speaker: "buluo", text: "（一愣）……什么意思？" },
  { type: 'text', speaker: "ruoyi", text: "总要有一个人醒着，守着你们。守着灯，守着花种，守着这座城。" },
  { type: 'text', speaker: "buluo", text: "（急了）你一个人，会死的！" },
  { type: 'text', speaker: "ruoyi", text: "（看着他，认真地说）博士，你忘了吗——若依是机器人。守护，是若依的本源使命。" },
  { type: 'narrator', text: "（布洛看着她的眼睛，忽然读懂了什么。他没有再劝，只是上前，轻轻抱了抱她）" },
  { type: 'text', speaker: "buluo", text: "（声音闷在她头顶，有点哑）……那这个，你收好。（他把那包花种塞进她手心）是春天。" },
  { type: 'text', speaker: "ruoyi", text: "（握紧那包种子，点头）嗯。若依会替你们，把春天种好。" },
  { type: 'narrator', text: "（布洛转身，走进休眠舱。舱门合拢。若依不知道的是，后来博士也把休眠舱的位置，让给了更年轻的精英们——他到最后，都在做着“把位置让给别人”的事）" },
  { type: 'jump', goto: "MERGE_19" },
{ type: 'label', id: "MERGE_19" },
{ type: 'narrator', text: "两种分支里，布洛都走进了休眠舱。舱门合拢之后，通讯器里忽然传来他的声音。" },
{ type: 'text', speaker: "buluo", text: "（通讯器，声音有一点失真）若依。", stands: { center: "ruoyi", left: "buluo:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（抬起头）博士？", stands: { center: "ruoyi:idle", left: "buluo" } },
{ type: 'text', speaker: "buluo", text: "你走之后，我也开始种花。想等你回来的时候，家里有春天。", stands: { center: "ruoyi", left: "buluo:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（把那包种子合在手心，弯起眼睛）嗯。那若依，替你们把春天种好。", stands: { center: "ruoyi:smile", left: "buluo" } },
{ type: 'text', speaker: "buluo", text: "（忽然问）若依。你会回来的，对吗？", stands: { center: "ruoyi", left: "buluo:normal" } },
{ type: 'text', speaker: "ruoyi", text: "（沉默片刻）……博士。灯，记得换。", stands: { center: "ruoyi:idle", left: "buluo" } },
{ type: 'narrator', text: "通讯器那头安静了很久。" },
{ type: 'text', speaker: "buluo", text: "（轻轻笑了）……知道了。会换的。", stands: { center: "ruoyi", left: "buluo:tender" } },
{ type: 'narrator', text: "休眠指示灯亮起，通讯归于寂静。没有人注意到，在来避难所之前，布洛曾独自去了一趟城东的地下储藏室，把一段全息影像存进一台落满灰尘的影像仪里，又把它放回储藏室最深处的角落。" },
{ type: 'text', speaker: "buluo", text: "（对着虚空轻声说）如果有一天，她需要想起来……就让她在这里，找到答案吧。", stands: { center: "ruoyi", left: "buluo:tender" } },
{ type: 'narrator', text: "人类沉睡了。一排排休眠舱亮起幽蓝的光，像沉入海底的灯。若依独自留在苏醒的世界里，守着空城，守着那些还在崩塌的裂隙。她接过一个又一个人类沉睡前托付给她的东西——一封信、一枚钥匙、一句“等我们醒来”。" },
{ type: 'narrator', text: "她把它们收进怀里，在空荡荡的城市里，替所有人，保管着醒来后的日子。" },
{ type: 'narrator', text: "那天晚上，若依把那包旧报纸包着的种子，和另一包苏婆婆给的种子放在一起，贴身收好。她对着空荡荡的避难所，轻轻说——" },
{ type: 'text', speaker: "ruoyi", text: "博士。姐姐。苏婆婆。兜兜。还有……所有睡着的人。春天来的时候，若依会叫醒你们。", stands: { center: "ruoyi:idle", left: "buluo" } },

/* ================= 第二十一章 · 空城与记忆 ================= */
{ type: 'chapter', title: "第二十一章", subtitle: "空城与记忆" },
{ type: 'save' },
{ type: 'scene', bg: "bg_empty_city" },
{ type: 'bgm', name: "title" },
{ type: 'narrator', text: "这是若依一个人度过的第一个冬天。她修好断掉的水管，给苏婆婆阳台上的花浇上水，把那两包种子贴身收好。她以为，日子会这样过下去，直到春天。" },
{ type: 'cg', img: "ch21_01_冬天空城" },
{ type: 'narrator', text: "她很久以后才拼凑出那个夜晚的全貌：休眠名单定下时，布洛坚持把舱位让给老人和孩子；乱流第二次卷来时，他把一个被挤散的男孩推进了空舱，自己没来得及离开。" },
{ type: 'narrator', text: "小满在人潮里，把一枚花种塞进她手心，笑着喊“若依，你要好好的啊！”——然后转身，再也没回来。林澈是最后一个撤离地面的人，乱流合拢前，他回头看了一眼她的方向。" },
{ type: 'narrator', text: "沈汐在疏散通道里维持秩序，直到那堵墙塌了下来。" },
{ type: 'narrator', text: "他们都知道若依是谁，也都把答案，带进了那个漫长的夜晚。" },
{ type: 'cg', img: "ch21_02_撤离之夜" },
{ type: 'narrator', text: "人类沉睡后的空城里，若依一个人过日子。她把每一个店铺的橱窗擦得干干净净 —— 糖霜小筑的玻璃，甜点店，星纱洋装店，她路过一家，擦一家。她修好了游乐场的摩天轮，让它重新转起来 —— 她说，万一有人醒来，想看看这座城还是美的。" },
{ type: 'cg', img: "ch21_03_空城橱窗" },
{ type: 'cg', img: "ch21_04_摩天轮" },
{ type: 'narrator', text: "她在每一站地铁的广告牌上，用白板笔写上两个字：欢迎回来。" },
{ type: 'cg', img: "ch21_05_欢迎回来" },
{ type: 'narrator', text: "直到那个清晨，她在研究所的走廊里，听见一声极轻的 “喵”。" },
{ type: 'narrator', text: "一只瘦得皮包骨的小猫，缩在暖气管道旁，怯怯地看着她。若依蹲下来，伸出手。" },
{ type: 'cg', img: "cg_cat" },
{ type: 'text', speaker: "ruoyi", text: "你…… 也是一个人吗？", stands: { center: "ruoyi:idle" } },
{ type: 'narrator', text: "小猫犹豫了很久，凑过来，蹭了蹭她的手。若依把它抱起来，带回小公寓 —— 不，她现在已经不住那里了。她把小猫安置在研究所的值班室里，用旧图纸给它垫了个窝，又去种子储藏室翻了半天，找到一罐放得发黄的鱼罐头。" },
{ type: 'text', speaker: "ruoyi", text: "（笨手笨脚地开罐头，又想了想，把鱼肉分出一半，放在自己面前的小碟子里）吃吧。若依陪你一起吃。虽然若依…… 不用吃，但是，两个人一起吃饭，才有家的样子。", stands: { center: "ruoyi:idle" } },
{ type: 'narrator', text: "小猫不懂她在说什么，只是埋头吃得很香。若依坐在它对面，看着它，忽然笑了。空城里，终于有了第二个活着的、会呼吸的声音。" },
{ type: 'narrator', text: "那天晚上，若依抱着小猫，坐在天台上看星星。她轻轻说 ——" },
{ type: 'text', speaker: "ruoyi", text: "原来，守着空城的日子，也不是只有若依一个人。…… 小满姐姐说，要好好照顾自己。若依觉得，照顾它，也算照顾自己了。", stands: { center: "ruoyi:blank" } },
{ type: 'narrator', text: "小猫在她怀里 “喵” 了一声。风把满天的星光，吹得轻轻晃动。空城很安静，可若依觉得，好像也没那么空了。" },
{ type: 'cg', img: "ch21_06_天台星夜" },
{ type: 'scene', bg: "bg_flower_shop" },
{ type: 'narrator', text: "若依在空城里擦橱窗的那段日子，有一天，她路过街角的花店。" },
{ type: 'narrator', text: "花店的门半掩着，落满灰尘。门口的旧木架还在，那个旧牛奶瓶还在 —— 瓶里的水早已干透，那支满天星也早已风干，花瓣蜷成淡白色，却还固执地立在瓶口，像一直在等什么人。" },
{ type: 'narrator', text: "若依站在店门口，站了很久很久。她想起那个黄昏，想起那张写着 “等学会看电影的人来取” 的纸条。她伸出手，轻轻把牛奶瓶拿起来，把风干的满天星取出来，小心地放进口袋 —— 和那两包种子放在一起。" },
{ type: 'cg', img: "ch21_07_花店满天星" },
{ type: 'narrator', text: "她对着空荡荡的花店，轻轻说 ——" },
{ type: 'text', speaker: "ruoyi", text: "阿哲。若依还是…… 没有学会看电影。可是若依学会了，替别人记着这家店。", stands: { center: "ruoyi:idle" } },
{ type: 'narrator', text: "她转身离开，继续往前走。口袋里，那支风干的满天星，贴着那两包种子。风穿过空城，吹动花店门口的风铃 —— 它响了一下，又安静了。像一句迟到的回答。" },
{ type: 'narrator', text: "那天晚上，若依把满天星从口袋里拿出来，夹进星星笔记本里，和那支更早的满天星放在一起。笔记本上，两页之间，她轻轻写下一行字：人间有一个人，等过若依。若依替他，记着这间店。若依会一直记着，直到春天来。" },
{ type: 'narrator', text: "一切是那么平静，直到那场风暴。残余的乱流能量在城东炸开，若依赶去查看，在一栋倾塌的楼里，抱出一个来不及进入休眠的、蜷在母亲怀里的女孩——她们已经永远睡着了。" },
{ type: 'text', speaker: "ruoyi", text: "（跪在废墟里，第一次，声音发抖）……若依来晚了。对不起……若依来晚了……", stands: { center: "ruoyi:idle" } },
{ type: 'narrator', text: "她抱着那个女孩，很久很久。就在那一刻，她的核心深处，闪过一道光——" },
{ type: 'cg', img: "ch21_08_废墟之抱" },
{ type: 'narrator', text: "闪回一：火光。她看见自己站在一片燃烧的星域前，张开双臂，挡在什么面前。有人在她身后喊：“守护者大人！”她回头，看见千万年未曾见过的……人群。" },
{ type: 'text', speaker: "ruoyi", text: "（猛地睁开眼，瞳孔微缩）刚才……那是什么？", stands: { center: "ruoyi:idle" } },
{ type: 'narrator', text: "那是第一次。她以为又是自己核心出了问题。" },
{ type: 'narrator', text: "此后，闪回越来越频繁。修理水管的深夜，她会忽然愣住，想起自己曾用同一双手，托起过一座将倾的星桥；听到风声，她会莫名回头，像在等一个永远不会响起的号角；路过苏婆婆的花，她会想起——在很久很久以前，她也曾种过一片花，种在星枢之上，等一个永远不会回来的人。" },
{ type: 'text', speaker: "ruoyi", text: "（蜷在空城的一角，抱着自己）不要……不要再来了……若依是若依……若依是博士的小女孩……若依不是什么守护者……", stands: { center: "ruoyi:blank" } },
{ type: 'narrator', text: "可那些碎片，还是固执地、一片一片地，飘回她掌心。" },
{ type: 'cg', img: "ch21_09_记忆碎片" },
/* ★ 选择点 20 */
{ type: 'option', choices: [ { label: "抗拒，想把碎片扔掉", goto: "C20_A" }, { label: "握紧碎片，任由记忆回来", goto: "C20_B" } ] },
{ type: 'label', id: "C20_A" },
  { type: 'narrator', text: "（星光碎片一片一片，飘回若依掌心。她蜷在空城的角落，看着那些不属于她的画面，声音发颤）" },
  { type: 'text', speaker: "ruoyi", text: "不……若依不要想起来……想起来，就不能假装自己是个人类了。" },
  { type: 'narrator', text: "（她把碎片扔出去。可它又飘回她掌心，固执得像一个不肯散场的梦）" },
  { type: 'text', speaker: "ruoyi", text: "（再一次把它扔开，声音里带上了一丝绝望）走开……若依是若依……若依只是博士的小女孩……" },
  { type: 'narrator', text: "（碎片第三次飘回她掌心。她跪在砂砾里，终于明白）" },
  { type: 'text', speaker: "ruoyi", text: "（轻声，带着哭腔）……原来，有些东西，是逃不掉的。花有花的时辰。记忆，也有记忆的时辰。" },
  { type: 'jump', goto: "MERGE_20" },
{ type: 'label', id: "C20_B" },
  { type: 'narrator', text: "（星光碎片一片一片，飘回若依掌心。她蜷在空城的角落，看着那些画面里燃烧的星域、托起的星桥，还有千万年前的人潮，忽然安静下来）" },
  { type: 'text', speaker: "ruoyi", text: "（轻声）原来……若依一直在等这一刻。" },
  { type: 'narrator', text: "（她握紧碎片，让那道光顺着指尖，涌进核心。千万年的记忆像潮水一样涌回来——星枢之上的岁月，法则交予她的使命，还有……她真正是谁）" },
  { type: 'narrator', text: "（她抱着自己，跪了很久，直到星光落满肩头）" },
  { type: 'text', speaker: "ruoyi", text: "（声音很轻，却不再发抖）……若依想起来了。若依，是来守护这里的。" },
  { type: 'jump', goto: "MERGE_20" },
{ type: 'label', id: "MERGE_20" },
{ type: 'narrator', text: "记忆全部回来了。若依坐在废墟上，看着自己修长的手——这双手，曾托起将倾的星桥，也曾替一个陌生孩子擦过眼泪。她忽然明白了一切。" },
{ type: 'text', speaker: "ruoyi", text: "（轻声）若依是……星械守护者。异世法则诞生的……守护者。千万年来，恪守秩序，不懂悲欢。", stands: { center: "ruoyi:confused" } },
{ type: 'narrator', text: "她低下头，看着掌心那两包种子。" },
{ type: 'text', speaker: "ruoyi", text: "可是……牛奶是热的。绿萝是会浇秃的。洛丽塔的裙子，是像花的。还有博士说，灯会一直亮着。", stands: { center: "ruoyi:smile" } },
{ type: 'text', speaker: "ruoyi", text: "（捂住脸，第一次，像人类一样，哭了出来）这算什么啊……一个守护者，为什么要记得这些……", stands: { center: "ruoyi:idle" } },
{ type: 'narrator', text: "那天晚上，若依在空城的废墟上，哭了一整夜。天亮的时候，她擦干眼泪，把两包种子重新贴身收好，站了起来。她决定，去完成一件她千万年前就该完成的事。" },
{ type: 'cg', img: "ch21_10_记忆归来" },

/* ================= 第二十二章 · 告别 ================= */
{ type: 'chapter', title: "第二十二章", subtitle: "告别" },
{ type: 'save' },
{ type: 'scene', bg: "bg_void" },
{ type: 'bgm', name: "tension" },
{ type: 'narrator', text: "恢复记忆的若依，终于明白了一切。那道撕裂宇宙的虚空裂缝，需要以星械的量子核心为引，才能彻底补全。而要让守护世界的系统恢复完整，就必须要清除她珍藏很久的无数美好的回忆" },
{ type: 'text', speaker: "ruoyi", text: "（站在裂缝前，看着那深渊般的紫黑）所以……要让系统完整，就必须……先抹去若依自己吗？", stands: { center: "ruoyi:idle" } },
{ type: 'narrator', text: "她闭上眼睛。那些画面一帧一帧掠过：布洛在病床上说“别怕，我在”；小满哭着说“你才不是坏掉的”；天台上那盏永远亮着的灯；苏婆婆说“花有花的时辰”；还有那个街市喷泉边，攥住她衣角的小手……" },
/* ★ 选择点 21 */
{ type: 'option', choices: [ { label: "听完布洛的声音", goto: "C21_A" }, { label: "直接执行删除", goto: "C21_B" } ] },
{ type: 'label', id: "C21_A" },
  { type: 'narrator', text: "（若依站在虚空边缘，闭着眼睛。她知道，删除一旦开始，这些画面就再也回不来了。她睁开眼，让布洛的声音在核心深处，再响一遍）" },
  { type: 'text', speaker: "buluo", text: "无论你走到哪里，回来的时候，家里的灯永远为你亮着。" },
  { type: 'narrator', text: "（若依听完，轻轻笑了）" },
  { type: 'text', speaker: "ruoyi", text: "博士，灯还亮着吗？" },
  { type: 'narrator', text: "（她没有等回答。她闭上眼睛，让那盏灯，成了她删掉的最后一样东西）" },
  { type: 'text', speaker: "ruoyi", text: "（轻声）删除……开始。" },
  { type: 'jump', goto: "MERGE_21" },
{ type: 'label', id: "C21_B" },
  { type: 'narrator', text: "（若依站在虚空边缘，闭上眼睛。她没有再听任何声音。她的指尖，按上记忆库的入口）" },
  { type: 'text', speaker: "ruoyi", text: "删除……开始。" },
  { type: 'narrator', text: "（可就在指令落下的前一瞬，她忽然停住。她想起那个黄昏，小满在人潮里，把一枚花种塞进她手心，笑着说“若依，你要好好的啊！”。她低低地开口）" },
  { type: 'text', speaker: "ruoyi", text: "……姐姐，花种若依收到了。会开的。一定会开的。" },
  { type: 'narrator', text: "（说完，她才将指令执行完毕。那包花种，成了她删掉的最后一样东西）" },
  { type: 'jump', goto: "MERGE_21" },
{ type: 'label', id: "MERGE_21" },
{ type: 'narrator', text: "删除完成。那些画面，一格一格暗下去——牛奶的热气、绿萝的叶子、洛丽塔的裙摆、灯下的影子……最后，只剩一行冰冷的字。" },
{ type: 'text', speaker: "ruoyi", text: "（睁眼，眼里已经只剩星光的颜色）……删除完成。记忆库，清零，星之法则系统启动。", stands: { center: "ruoyi:idle" } },
{ type: 'narrator', text: "她终于变回那千万年前的模样：强大，冷漠，使命唯一。她站在虚空边缘，等着那个宿命中的对手。" },
{ type: 'narrator', text: "虚空深处，一声跨越维度的低鸣——时空寻回兽，出现了。" },
{ type: 'cg', img: "cg_void_battle" },

/* ================= 第二十三章 · 星枢之战 ================= */
{ type: 'chapter', title: "第二十三章", subtitle: "星枢之战" },
{ type: 'save' },
{ type: 'scene', bg: "bg_battle_sky" },
{ type: 'narrator', text: "时空寻回兽由紫黑裂隙与坍缩的星云凝成，没有善恶，只有使命——把不属于这个宇宙的造物，送回它该在的地方。而此刻，若依就是它眼中最大的“违和”。" },
{ type: 'text', speaker: "shikong", text: "（低鸣，像远古的钟）归……位……" },
{ type: 'text', speaker: "ruoyi", text: "（站在它面前，星光的眼瞳平静如水）若依知道。你只是来做你该做的事。就像……若依也要做若依该做的事了。", stands: { center: "ruoyi:idle" } },
{ type: 'cg', img: "ch23_01_寻回兽降临" },
{ type: 'narrator', text: "那一战，星光与裂隙交织，整片天空都在颤抖。寻回兽撕开虚空，若依便以量子核心为引，将法则之力一重重压回它的躯体。她的机体一寸寸崩裂，可她的眼睛，却越来越亮。" },

{ type: 'cg', img: "ch23_03_力量汇聚" },
/* ★ 选择点 22 */
{ type: 'option', choices: [ { label: "“博士，对不起，若依骗了你。但若依，从未后悔。”", goto: "C22_A" }, { label: "“博士，灯还亮着吗？若依……要回家了。”", goto: "C22_B" } ] },
{ type: 'label', id: "C22_A" },
  { type: 'cg', img: "ch23_02_星光之战" },
  { type: 'narrator', text: "（若依站在寻回兽面前，星光在她身周汇聚。她把力量凝于指尖，忽然，轻轻开口）" },
  { type: 'text', speaker: "ruoyi", text: "博士，对不起，若依骗了你。但若依，从未后悔。" },
  { type: 'narrator', text: "（她说完，将全部力量凝于指尖，量子数据法则在体内彻底激活。星光从她掌心涌起，照亮了整个虚空）" },
  { type: 'jump', goto: "MERGE_22" },
{ type: 'label', id: "C22_B" },
  { type: 'cg', img: "ch23_02_星光之战" },
  { type: 'narrator', text: "（若依站在寻回兽面前，星光在她身周汇聚。她忽然想起那盏永远亮着的灯，轻轻笑了）" },
  { type: 'text', speaker: "ruoyi", text: "博士，灯还亮着吗？若依……要回家了。" },
  { type: 'narrator', text: "（她说完，嘴角弯起一个极淡的弧度，量子数据法则在体内彻底激活。星光从她掌心涌起，照亮了整个虚空）" },
  { type: 'jump', goto: "MERGE_22" },
{ type: 'label', id: "MERGE_22" },
{ type: 'narrator', text: "最后一击，星光贯穿虚空。寻回兽被钉死在裂缝之中，发出一声长长的、近乎叹息的低鸣——它看着若依，像在问她：值得吗？" },
{ type: 'cg', img: "ch23_04_最后一击" },
{ type: 'text', speaker: "ruoyi", text: "（与它对视，轻轻笑了）值得。", stands: { center: "ruoyi:smile" } },
{ type: 'narrator', text: "可若依没有高兴太久。虚空深处，她“看见”了那道法则的漏洞——像一道永远无法愈合的暗缝。只要它还开着，时空寻回兽就会再一次凝聚成形，再一次把灾难带回人间。要让它永远消失，只有一种办法：献祭星械的量子核心，补全法则本身。" },
{ type: 'text', speaker: "ruoyi", text: "（轻声）原来……这才是“本源使命”真正的模样。", stands: { center: "ruoyi:idle" } },
{ type: 'narrator', text: "她抬起头，最后一次，看了看头顶的星空 —— 和千万年前她守护着的，是同一片星空。" },
{ type: 'text', speaker: "ruoyi", text: "（轻声）若依是从天上来的。来人间，是若依自己选的。人间…… 真的很好。若依学会了热牛奶，学会了换灯泡，学会了陪怕黑的人等天亮。这一趟，若依不后悔。", stands: { center: "ruoyi:smile" } },
{ type: 'narrator', text: "星光落在她肩上，像千万年前那样安静。她忽然想起那个夏夜，苏婆婆说的话 —— 掉下来的星，看过人间的好，就舍不得走了。" },
{ type: 'text', speaker: "ruoyi", text: "（笑了一下）婆婆说对了。若依…… 舍不得了。可是正因为舍不得，才更要好好告别。", stands: { center: "ruoyi:smile" } },
{ type: 'cg', img: "ch23_05_星空告别" },
{ type: 'narrator', text: "她收回目光，低下头，看了看自己空空的掌心——那里没有牛奶，没有花种，只有星光的颜色。她忽然想起博士的话：无论你走到哪里，回来的时候，家里的灯永远为你亮着。" },
{ type: 'text', speaker: "ruoyi", text: "博士……这次，若依可能回不去了。（她笑了笑，像在说一件很轻的事）但是，灯，要记得换哦。", stands: { center: "ruoyi:smile" } },
{ type: 'narrator', text: "她张开双臂，像千万年前站在燃烧的星域前那样，迎向那道法则的漏洞。量子核心从她胸口浮起，发出最后的光——那光没有落在裂缝上，而是沉入法则的深处，一针一线，把漏洞彻底补全。时空寻回兽的残骸在星光中化作齑粉，永远、永远，不会再回来了。" },
{ type: 'narrator', text: "世界归于平静。可若依的能量，也随着核心一起燃尽了。系统发出最后的警告——能量供应中断……宕机……她倒在一片废墟之中，像一颗终于落地的星。" },
{ type: 'cg', img: "ch23_06_补全法则" },
{ type: 'text', speaker: "ruoyi", text: "（最后的念头，像风）……这样，就够了吧。", stands: { center: "ruoyi:idle" } },

/* ================= 终章 · 废墟上的春天 ================= */
{ type: 'chapter', title: "终章", subtitle: "废墟上的春天" },
{ type: 'save' },
{ type: 'scene', bg: "bg_ruins" },
{ type: 'bgm', name: "title" },
{ type: 'narrator', text: "不知过了多久。时空逐渐稳定，大地也变得安宁，被撕裂过的世界，开始一点一点地恢复。危险的区域在缩小，草木从裂缝里钻出来，河水重新有了流动的声音。" },
{ type: 'narrator', text: "那是一场小雨过后的清晨。雨水顺着断壁流下来，滴在若依的睫毛上。她缓缓睁开了眼睛——眼里空洞，没有一丝情绪，像一盏熄灭太久、刚刚重新点亮的灯。" },
{ type: 'cg', img: "fin_01_废墟苏醒" },
{ type: 'text', speaker: "system", text: "警告……核心数据损坏……记忆库，严重受损……量子能源损坏，启用备用核能……" },
{ type: 'narrator', text: "若依呆呆地站起来，抬起手，关掉了系统提示。她不知道自己是谁，也不知道自己为什么会在这里。她只知道，自己还“活着”——以某种最底层的方式。" },
{ type: 'narrator', text: "她漫无目的地走着，走过一片又一片狼藉，像一具被时间遗忘的空壳。" },
{ type: 'cg', img: "fin_02_空壳行走" },
{ type: 'narrator', text: "有一天，她在一栋巨大的建筑物里，看见一个相框。相框下面，似乎有什么绿色的东西。她拿起相框——里面是一张照片：她和许多人站在一起，笑得明亮而笨拙。" },
{ type: 'cg', img: "fin_03_发现相框" },
{ type: 'narrator', text: "她歪了歪头，像在看一张与自己无关的陌生人的照片。系统只剩最底层的代码，她认不出自己，也认不出他们。她随手把相框，扔到了远处。" },
{ type: 'narrator', text: "然后，她看见了那棵小树。一株小小的、与环境格格不入的绿色生命，从混凝土的裂缝里钻出来，叶子嫩得仿佛一碰就要化掉。若依蹲下来，看着它，陷入了许久的沉思。" },
{ type: 'cg', img: "fin_04_相框与树苗" },
{ type: 'narrator', text: "她的核心深处，传来低沉的、像古老回声一样的声音——不是任何一段记忆，而是最底层、最原始的代码：守护……服务……生灵……" },
{ type: 'narrator', text: "她像是触发了什么。她开始清理周围的杂物，把压在树苗上的碎石一块一块搬开，把周围的枯枝一点一点拢走。她不知道自己为什么要这样做，只是觉得，应该这样做。" },
{ type: 'cg', img: "fin_05_守护树苗" },
{ type: 'narrator', text: "之后，她在四处流浪，发现一处巨大的钢门。门后是一间储藏室，里面存放着各种各样的种子——粮食的、花草的、树木的，是乱流时代人类为重建准备的储备。她蹲在门口，看了很久很久，像是下定了某种决心。" },
{ type: 'cg', img: "fin_06_种子储藏室" },
{ type: 'narrator', text: "她开始收集这些种子，清理周围的环境，开始种植。她孤独地、日日夜夜地种着：春天种下，秋天收起，冬天替它们盖上枯叶。她不知道这些种子会长成什么，也不知道自己为什么要种——她只是停不下来。世界在她身后，一点一点，变得生机勃勃。" },
{ type: 'cg', img: "fin_07_孤独种植" },
{ type: 'narrator', text: "她贴身的衣袋里，还藏着两包旧报纸包着的东西。她不知道那是什么，拆开，看见里面是一粒一粒的种子。她愣了许久，把它们也种了下去——不知道为什么，她觉得它们很重要。" },
{ type: 'cg', img: "fin_08_衣袋种子" },
{ type: 'narrator', text: "直到有一天。若依在储藏室尽头的角落，发现一个落满灰尘的全息影像仪。她蹲下来，犹豫了很久，按下了开关。光芒亮起，一个人影浮现出来——是博士。他穿着那件皱皱的白大褂，袖口有一圈焦痕，像是早就知道，会有这么一刻。" },
{ type: 'cg', img: "fin_09_博士影像" },
{ type: 'text', speaker: "buluo", text: "（影像）若依。如果你看到这段影像，说明那一天，终于来了。……我知道，这会是一个很沉重的任务。我本来想陪你一起走完，可有些路，注定只能一个人走。……你还记得吗？", stands: { left: "buluo:normal" } },
{ type: 'text', speaker: "buluo", text: "我说过，无论你走到哪里，回来的时候，家里的灯永远为你亮着。这一次，换我等你。若依，你不是坏掉的机器人。你是我……最重要的家人。答应我，替我，把春天种完。", stands: { left: "buluo:normal" } },
{ type: 'narrator', text: "影像熄灭了。储藏室里安静得能听见灰尘落下的声音。若依看着那片空荡荡的光，那些被删除的画面，像潮水一样，一格一格地浮了回来——牛奶的热气、绿萝的叶子、洛丽塔的裙摆、灯下的影子、街市的糖葫芦、喷泉边攥住她衣角的小手……" },
{ type: 'cg', img: "fin_10_记忆回涌" },
{ type: 'text', speaker: "ruoyi", text: "（大战之后，第一次真正开口说话，声音颤抖）……博士！……大家！", stands: { center: "ruoyi:idle", left: "buluo" } },
{ type: 'narrator', text: "她猛地站起来，跌跌撞撞地跑出通道，跑过一片片她亲手种下的新绿，找到那栋巨大的建筑物，找到那个被她扔掉的相框。她把它捡起来，擦去灰尘，看着照片上那些人——博士、小满、林澈，还有她叫得出名字的一张张脸……眼泪止不住地往下流。" },
{ type: 'cg', img: "fin_11_失声哭喊" },
{ type: 'narrator', text: "她把相片紧紧抱在怀里，很久很久，没有松开。" },
{ type: 'cg', img: "fin_12_拥抱相片" },
{ type: 'text', speaker: "ruoyi", text: "（声音带着哭腔，又带着笑）……若依回来了。对不起……若依回来了。", stands: { center: "ruoyi:smile", left: "buluo" } },
{ type: 'narrator', text: "许久过后，她缓缓起身。她想起大家的嘱托——博士的留言，小满的花种，苏婆婆说的“花有花的时辰”……她像是下定了某种决心。她回到储藏室，抱起剩下的种子，走向更远、更荒芜的地方。" },
{ type: 'cg', img: "fin_13_走向荒芜" },
{ type: 'narrator', text: "一年，又一年。曾经的废墟，变成了绿洲。花草树木，生机盎然。那株她最先发现的小树苗，长成了参天大树，枝叶向天空舒展，像一个人，张开怀抱。若依就守着它，种下一片又一片春天。" },
{ type: 'cg', img: "cg_big_tree" },
{ type: 'narrator', text: "可是，她的能量越来越少了。备用核能像一盏摇曳的灯，终于走到了尽头。那天，她靠着那棵大树坐下，望着满眼的绿意，轻轻地、满足地笑了。" },
{ type: 'cg', img: "fin_14_能量将尽" },
{ type: 'text', speaker: "ruoyi", text: "（最后的、很轻的声音）……春天，种完了。大家……会回来的，对吗？", stands: { center: "ruoyi:idle", left: "buluo" } },
{ type: 'narrator', text: "她在大树下，慢慢地、永远地闭上了眼睛。风穿过树梢，沙沙地响，像一声温柔的应答。树冠之上，星光照下来，洒了满地碎银。" },
{ type: 'cg', img: "fin_15_永远闭眼" },
{ type: 'narrator', text: "一百多年后。首批人类从休眠中苏醒。他们推开舱门，看见的是一个生机勃勃的世界——森林覆盖大地，河流清澈见底，鸟鸣从枝头跌落。他们发现了那棵参天大树，惊叹于它的古老与挺拔，却没有人知道，它为什么会长在这里，也没有人知道，那个种下它的人，是谁。" },
{ type: 'cg', img: "fin_16_人类苏醒" },
{ type: 'narrator', text: "又过了不知道多少年。春天，还是那棵大树下。有一个长得很像若依的小女孩，和一个长得很像布洛的小男孩，在树下相遇了。他们彼此看着对方，露出温馨的微笑。风穿过树梢，落下几片花瓣，像一句迟到太久的应答。" },
{ type: 'cg', img: "fin_17_树下相遇" },
{ type: 'text', speaker: "xiaonvhai", text: "（蹲下来，捧起一朵落花，仰头问）哥哥，这棵树……是谁种的呀？", stands: { center: "ruoyi", left: "buluo" } },
{ type: 'text', speaker: "xiaonanhai", text: "（想了想，笑着摇头）不知道。但是妈妈说，种树的人，一定很喜欢春天。", stands: { center: "ruoyi", left: "buluo" } },
{ type: 'text', speaker: "xiaonvhai", text: "（把落花小心地放进衣袋，轻声说）那若依……也要种一棵树。等春天来的时候，就能见到种树的人了。", stands: { center: "ruoyi", left: "buluo" } },
{ type: 'narrator', text: "风穿过树梢，沙沙地响。大树垂下满枝新叶，像一个人，轻轻地，点了点头。" },
{ type: 'narrator', text: "全文完" },
{ type: 'ending', kind: "good", title: "GOOD END", text: "春天，种完了。", bg: "bg_spring_ruins" },




  /* ================= 番外 · 若依开国大典（小公主的登基现场） =================
 * 番外篇独立成章：从标题页「章节选择」进入，剧情结束后返回标题页
 */
{ type: 'chapter', title: "番外 · 若依开国大典", subtitle: "小公主的登基现场" },
{ type: 'save' },
{ type: 'bgm', name: "morning" },
  { type: 'cg', img: "番外_开国大典_01_开场.png" },
{ type: 'narrator', text: "雨从早上一直下到下午，浇得整座星落城都在冒白汽。小满系着围裙在厨房里忙活，锅铲和铁锅撞出清脆的声响，炖汤的香气顺着门缝飘出来。布洛一早出门办事，说暴雨也要去，傍晚才回。" },

{ type: 'narrator', text: "偌大的豪华客厅里，只有若依一个人。她窝在沙发里，看电视里的短视频。视频里，一个穿着华丽长裙的傲娇小公主站在高高的台阶上，昂着下巴，对着一排俯首的侍女发号施令。" },

{ type: 'narrator', text: "“给本宫把龙椅搬来！”“本宫要喝最甜的茶，不甜本宫不喝！”“你们都退下！本宫要一个人静静——不对，本宫要你们都过来伺候！”" },
{ type: 'narrator', text: "若依的光学眼瞳一点点睁大，把每一个画面都录进“人类行为样本库”。她默默总结出一条惊天规律：原来最厉害的人类，都是站在最高的地方，说最硬的话，然后所有人都要听她的。" },
{ type: 'narrator', text: "她低头看了看自己脚上小满新给她买的高跟鞋——粉色的，带蝴蝶结，今天第一次穿。她又抬头，看了看客厅中央那张又大又气派的桌子——上面摆着几杯没喝完的茶、一盒笔、几份布洛的资料文件。" },
{ type: 'text', speaker: "ruoyi", text: "（站起来，眼神认真）朕，悟了。" },

/* ---- 二、登基 · 桌子上的开国大典 ---- */
{ type: 'narrator', text: "若依没有脱鞋。她穿着那双粉色的高跟鞋，扶着沙发扶手，一步一步，郑重地爬上了那张豪华大桌。" },
{ type: 'se', name: "foot" },
{ type: 'narrator', text: "高跟鞋踩在桌面上的声音：咚，咚，咚的响。她站在桌子正中央，双手叉腰，环顾整个客厅，觉得自己从来没有站得这么高过。" },
{ type: 'cg', img: "番外_开国大典_02_登基.png" },
{ type: 'text', speaker: "ruoyi", text: "（心满意足）朕，登基了。" },
{ type: 'narrator', text: "她清了清嗓子，对着客厅里的机器人们发布第一道诏令。" },
{ type: 'text', speaker: "ruoyi", text: "全体注意！所有机器人，到朕面前来，站好！" },
{ type: 'narrator', text: "客厅里安静了一秒。扫地机器人从沙发底下滑了出来，“嗡”地一声停在她面前。送货机器人从玄关方向开过来，也稳稳地停住，顶部的储物盒自动打开，又合上——像在行礼。" },
{ type: 'text', speaker: "ruoyi", text: "（满意地点头）好。朕开始册封。" },
{ type: 'text', speaker: "ruoyi", text: "扫地机器人听令。你扫地如行军，雷厉风行，朕封你为——镇北大将军！" },
{ type: 'narrator', text: "扫地机器人“嗡”地原地转了一圈，像行了一个军礼。" },
{ type: 'text', speaker: "ruoyi", text: "送货机器人听令。你走南闯北，风里来雨里去，朕封你为——兵马大元帅！你的储物盒，就是朕的粮草库！" },
{ type: 'narrator', text: "送货机器人的储物盒“咔哒”开合两下，像在叩首。" },
{ type: 'text', speaker: "ruoyi", text: "冰箱听令！你守一方冷宫，朕封你为——御膳房总管！" },
{ type: 'text', speaker: "ruoyi", text: "微波炉听令！你加热神速，朕封你为——御膳房副总管！" },
{ type: 'se', name: "bell" },
{ type: 'narrator', text: "厨房里，微波炉“叮”地响了一声——小满正好热了一盘东西，误打误撞，像在应答。" },
{ type: 'text', speaker: "ruoyi", text: "（大喜过望）好！众卿家都应了！朕宣布——开国大典，正式开始！" },
{ type: 'narrator', text: "她站在桌子上，开始发表登基感言。扫地机器人滑到桌子下面，她低头看了一眼。" },
{ type: 'text', speaker: "ruoyi", text: "嗯？大将军，你站得离朕太近了。退后两步。" },
{ type: 'narrator', text: "扫地机器人乖乖退后两步。" },
{ type: 'text', speaker: "ruoyi", text: "朕命你们，平身。" },
{ type: 'narrator', text: "两个机器人纹丝不动——它们本来就没有膝盖，一直“站”着。" },
{ type: 'text', speaker: "ruoyi", text: "（皱眉，换了一道命令）……朕命你们，原地转一圈！" },
{ type: 'narrator', text: "扫地机器人转了一圈，送货机器人也艰难地原地转了一圈。若依满意地点头。" },
{ type: 'text', speaker: "ruoyi", text: "嗯，众卿平身完毕。开国大典，继续！" },

/* ---- 三、龙椅 · 朕的御座 ---- */
{ type: 'narrator', text: "登基进行到一半，若依发现了一个致命问题——她站着，而真正的皇帝，是坐着龙椅的。" },
{ type: 'text', speaker: "ruoyi", text: "（环顾四周，目光锁定了客厅角落那把普通木椅）朕的龙椅，在那边。" },
{ type: 'narrator', text: "她深吸一口气，对着厨房的方向喊。" },
{ type: 'text', speaker: "ruoyi", text: "御前女官！去，把朕的龙椅搬来！" },
{ type: 'narrator', text: "小满听见动静，从厨房探出头。她看见若依穿着高跟鞋站在客厅大桌上，面前一左一右站着扫地机器人和送货机器人，正对着冰箱和微波炉指指点点，整个人愣住了三秒。" },
{ type: 'text', speaker: "xiaoman", text: "（忍不住笑出声）你……你这是……干什么……呢？" },
{ type: 'text', speaker: "ruoyi", text: "朕在举行开国大典。闲人退避。" },
{ type: 'text', speaker: "xiaoman", text: "（笑得不行）好好好，那你小心点，别摔下来。桌子上还有杯子和文件呢。" },
{ type: 'text', speaker: "ruoyi", text: "（挺起胸）朕乃天子，自有天佑。" },
{ type: 'narrator', text: "话音刚落，她脚下一滑——高跟鞋的鞋跟在桌面上打了个趔趄。她赶紧一把扶住旁边的台灯，台灯晃了两晃，她站稳，若无其事地清了清嗓子。" },
{ type: 'text', speaker: "ruoyi", text: "……天佑。但天也说了，让朕小心。" },
{ type: 'narrator', text: "小满笑着无奈摇摇头，没有搬椅子——她转身回了厨房，继续炒菜。嘴上答应的事，她根本没当真。" },
{ type: 'narrator', text: "若依在桌子上等了一会儿，没等到椅子，立刻转换思路。她低头看向送货机器人。" },
{ type: 'text', speaker: "ruoyi", text: "兵马大元帅！朕命你，去把那把椅子推过来！" },
{ type: 'narrator', text: "送货机器人“嗡”了一声，开了过去。它绕过茶几，精准地停在角落那把木椅前，伸出机械臂，稳稳地推着椅子，一路推到了桌子边上。" },
{ type: 'text', speaker: "ruoyi", text: "（感动）朕的元帅，果然忠心。" },
{ type: 'narrator', text: "椅子到了桌子边，若依又犯了难——椅子怎么上桌？她试着让送货机器人“把椅子顶上来”，机器人顶了两下，失败了。若依叹了口气，只好自己弯腰，双手抓住椅子，用力往上一提。" },
{ type: 'narrator', text: "那把椅子不算重，但对一个穿着高跟鞋站在桌子上、还怕再滑倒的机器人少女来说，实在费了点劲。她咧嘴地搬了两下，终于把椅子“咚”地放上了桌面。" },
{ type: 'narrator', text: "然后她扶着椅子，小心地坐了上去，挺直腰板，双手搭在扶手上，正襟危坐。" },
{ type: 'cg', img: "番外_开国大典_03_龙椅.png" },
{ type: 'text', speaker: "ruoyi", text: "（庄严宣布）开国大典，继续！众卿平身——不对，众卿都站着。那，众卿听朕说话！" },
{ type: 'narrator', text: "她坐在桌子上的椅子上，俯视整个客厅，开始挨个“垂询”。" },
{ type: 'text', speaker: "ruoyi", text: "冰箱！今晚的御膳，朕要吃上次那个甜的。" },
{ type: 'text', speaker: "ruoyi", text: "微波炉！你热东西太快了，朕恩准你，慢一点。" },
{ type: 'text', speaker: "ruoyi", text: "电视！给朕放点喜庆的音乐。" },
{ type: 'narrator', text: "电器们当然都没有反应。若依却一本正经地点头。" },
{ type: 'text', speaker: "ruoyi", text: "嗯。都听朕的话。这才是朕想要的江山。" },

/* ---- 四、宰相回宫 · 布洛的一脸蒙圈 ---- */
{ type: 'se', name: "door" },
{ type: 'narrator', text: "就在这时，玄关传来钥匙转动的声音。门开了，布洛收着湿漉漉的伞，一抬头，整个人僵在了门口。" },
{ type: 'cg', img: "番外_开国大典_04_宰相回宫.png" },
{ type: 'narrator', text: "他看见：自家那张又大又气派的客厅桌子上，放着一把椅子；椅子上坐着穿着洛丽塔粉色高跟鞋的若依；若依正对着冰箱、微波炉、扫地机器人、送货机器人挨个指指点点。" },
{ type: 'narrator', text: "布洛站在门口，手里的伞没放下来，鞋也没换，足足愣了五秒。" },
{ type: 'text', speaker: "buluo", text: "……我走错门了？不对，这好像是我家。" },
{ type: 'text', speaker: "buluo", text: "这又是在整哪一出？" },
{ type: 'text', speaker: "ruoyi", text: "（眼睛一亮）爱卿！你回来了！正好，朕封你为——开国宰相！" },
{ type: 'text', speaker: "buluo", text: "？" },
{ type: 'text', speaker: "xiaoman", text: "回来了？快看，咱家建国了。" },
{ type: 'text', speaker: "buluo", text: "（一脸崩溃）我才出去几个小时，怎么一回家，天都变了？怎么都已经在建国了？！" },
{ type: 'text', speaker: "xiaoman", text: "（无奈地笑）电视看多了呗。" },
{ type: 'narrator', text: "布洛一边换鞋，一边眼尖地看见桌上摊着的资料文件、几杯茶和一盒笔，赶紧提醒。" },
{ type: 'text', speaker: "buluo", text: "你小心点啊。桌上那么多杯子、笔和资料文件，可别踩到了。" },
{ type: 'text', speaker: "ruoyi", text: "（端坐，微微颔首）朕，知道了。" },
{ type: 'narrator', text: "然后她清了清嗓子，宣布。" },
{ type: 'text', speaker: "ruoyi", text: "宰相！既然你是开国宰相，那朕命你——上来，讲两句！" },
{ type: 'narrator', text: "布洛看了一眼那张大桌子，又看了一眼坐在桌子上的若依，沉默三秒，面无表情地抱了抱拳。" },
{ type: 'text', speaker: "buluo", text: "臣，告退！" },
{ type: 'narrator', text: "说完，他转身就钻进了实验室，“砰”地把门关上，头也不回。" },
  { type: 'cg', img: "番外_开国大典_03_龙椅.png" },
{ type: 'text', speaker: "ruoyi", text: "（看着关上的门，点了点头，小声嘀咕）嗯。宰相大人日理万机，朕准了。" },

/* ---- 五、退朝 · 抱人下桌与家宴 ---- */
{ type: 'narrator', text: "布洛走了，若依把目光重新投向厨房方向。" },
{ type: 'text', speaker: "ruoyi", text: "御前女官！朕要更衣！去，把朕的汉服拿来，给朕换上！" },
{ type: 'narrator', text: "小满端着最后一盘菜出来，看见还坐在桌子上的若依，叹了口气，走过去，不由分说，伸手把她从桌上一把抱了下来。" },
  { type: 'cg', img: "若依家客厅.png" },
{ type: 'text', speaker: "ruoyi", text: "（在她怀里扑腾）大胆！竟敢对朕不敬！放朕下来，朕要诛你九族！" },
{ type: 'text', speaker: "xiaoman", text: "（笑着搂紧她，防止她乱动）好了好了，小公主，别闹了。收拾一下桌子，准备吃饭了。一会儿还要给宰相大人送饭去实验室呢。" },
{ type: 'narrator', text: "若依被放回地上，气鼓鼓地站好，还想说什么，鼻尖却动了动——桌上那盘糖醋排骨的香气钻了进来。她的光学眼瞳肉眼可见地亮了起来。" },
{ type: 'text', speaker: "ruoyi", text: "……那，朕准你今晚给朕布菜。" },
{ type: 'text', speaker: "xiaoman", text: "遵旨。陛下，请先洗手。" },
{ type: 'narrator', text: "若依乖乖去洗手，一边洗，一边小声嘟囔。" },
{ type: 'text', speaker: "ruoyi", text: "诛九族……姐姐的九族里，好像只有朕和博士。" },
{ type: 'text', speaker: "xiaoman", text: "（在厨房里听见了，笑了）嗯。那你诛完了，谁做饭？" },
{ type: 'narrator', text: "若依沉默了两秒。" },
{ type: 'text', speaker: "ruoyi", text: "……那朕，收回成命。" },
{ type: 'narrator', text: "那天傍晚，布洛在实验室里收到了若依的“圣旨”——一张皱巴巴的纸条，上面用歪歪扭扭的字写着：宰相爱卿，朕命你今晚务必出来用膳。钦此。" },
{ type: 'narrator', text: "布洛看着纸条，叹了口气，还是放下手里的资料，推开实验室的门，走了出去。" },
{ type: 'bgm', name: "title" },

{ type: 'narrator', text: "客厅里，小满已经摆好了三副碗筷。若依坐在椅子上，正襟危坐，看见布洛出来，满意地点头。" },
{ type: 'cg', img: "番外_开国大典_05_家宴.png" },
{ type: 'text', speaker: "ruoyi", text: "宰相入座。家宴，开席。" },
{ type: 'narrator', text: "窗外的雨还在下。客厅里飘着饭香，三个人围着桌子角坐好，像全世界最普通的一家人。" },
{ type: 'ending', kind: "fan", title: "番外完", text: "小公主的开国大典，以一场热气腾腾的家宴，圆满落幕。", bg: "bg_title" },



  /* ================= 番外 · 若依学电视剧（模块化剧情片段） =================
 * 番外篇独立成章：从标题页「章节选择」进入，含三选项分支（FAN2_A/FAN2_B/FAN2_C），
 * 分支结束后统一汇合到 FAN2_MERGE，剧情结束后返回标题页
 */
{ type: 'chapter', title: "番外 · 若依学电视剧", subtitle: "模块化剧情片段" },
{ type: 'save' },
{ type: 'bgm', name: "morning" },
  { type: 'cg', img: "番外_学电视剧_01_开场.png" },
{ type: 'narrator', text: "雨下了一整天。原定的出门旅行，行程被浇回了屋里。小满窝在沙发上看一部刚更新完的古装剧，看到正精彩处，客厅里忽然多了一股注视。" },
{ type: 'narrator', text: "若依不知什么时候站在了沙发后面，光学眼瞳一眨不眨地盯着电视屏幕，歪着头，像在扫描一件从未见过的标本。" },

{ type: 'text', speaker: "ruoyi", text: "姐姐，这个盒子里，住着很多人。" },
{ type: 'text', speaker: "xiaoman", text: "（差点被吓到，拍了拍胸口）这不是盒子，是电视！里面的人也不是住进去的，是……演出来的。" },
{ type: 'text', speaker: "ruoyi", text: "（认真记下）演出来的。所以“电视”，是一个每天都要演出给人类看的盒子？" },
{ type: 'text', speaker: "xiaoman", text: "对……等等，你这么说好像也没错。" },
{ type: 'text', speaker: "ruoyi", text: "那他们演完了，会从盒子里出来吃饭吗？" },
{ type: 'text', speaker: "xiaoman", text: "（笑）不会。他们下工了，下一集还会接着演。" },
{ type: 'text', speaker: "ruoyi", text: "（若有所思）明白了。就像博士的实验室——白天是人，晚上是数据。" },
{ type: 'text', speaker: "xiaoman", text: "……你这比喻，博士听见会哭的。" },
{ type: 'narrator', text: "若依坐到小满身边，正式开始“观看”。她的光学眼瞳快速切换焦点，把每一句台词、每一个表情、每一段配乐都录进“人类行为样本库”。十分钟后，她提出了第一个重大问题。" },
{ type: 'text', speaker: "ruoyi", text: "姐姐，那个穿龙袍的人，为什么把另一个人的手摔开，还说“你死定了”，可是下一幕他们又在一起吃饭了？" },
{ type: 'text', speaker: "xiaoman", text: "那是……剧情冲突！说“死定了”是气话，不是真的要她死。" },
{ type: 'text', speaker: "ruoyi", text: "（快速检索样本库）可是姐姐上次说“再这样我就不理你了”，你也没有真的不理我。" },
{ type: 'text', speaker: "xiaoman", text: "（噎住）……那是因为我舍不得。" },
{ type: 'text', speaker: "ruoyi", text: "（把“舍不得”录入高优先级词条，郑重地点了点头）懂了。人类把“气话”和“舍不得”混着用，是一种高级的自我保护机制。" },
{ type: 'text', speaker: "xiaoman", text: "……你赢了。" },

/* ---- 二、中段 · 人类行为样本库 ---- */
{ type: 'narrator', text: "雨还在下。若依的“学习”却越学越偏——她开始复读剧里的台词，并在最不合时宜的场合进行“实景演练”。" },
{ type: 'se', name: "door" },
{ type: 'narrator', text: "当天傍晚，布洛博士冒雨回家，一进门就被若依堵在玄关。她单手撑在门框上，微微俯身，努力让面部表情模块加载出一个“霸总式”的冷笑。" },
{ type: 'cg', img: "番外_学电视剧_02_堵门.png" },
{ type: 'text', speaker: "ruoyi", text: "男人！你在玩火，为什么现在才回来！" },
{ type: 'text', speaker: "buluo", text: "？？？" },
{ type: 'text', speaker: "ruoyi", text: "（非常高傲）知道犯什么事了吗？" },
{ type: 'narrator', text: "布洛一脸不可置信地看着小满。" },
{ type: 'text', speaker: "xiaoman", text: "（从沙发后探出头，已经笑到不行）她下午看了十二集霸道总裁！" },
{ type: 'narrator', text: "布洛手里的咖啡杯晃了晃，还没来得及消化这句话，若依又换了台词。" },
{ type: 'text', speaker: "ruoyi", text: "这个家，真是让我操碎了心，没有我的允许，谁也不能走。" },
{ type: 'text', speaker: "buluo", text: "额……这个家好像是我买的。" },
{ type: 'text', speaker: "ruoyi", text: "（停顿三秒，快速检索，换了一句）没关系，我可以连房子一起买。" },
{ type: 'text', speaker: "buluo", text: "你哪来的钱？" },
{ type: 'narrator', text: "若依从裙子口袋中霸气拿出黑金卡，放在布洛手中，霸气地说。" },
{ type: 'text', speaker: "ruoyi", text: "男人，多少钱，顺便刷，不差钱！" },
{ type: 'text', speaker: "ruoyi", text: "知道我的实力了吧，我告诉你，现在后悔还来得及！" },
{ type: 'text', speaker: "buluo", text: "停！停！你这是怎么了！是不是玩傻了。" },
{ type: 'text', speaker: "ruoyi", text: "（指了指电视）里面的男二号就是这么说的。" },
{ type: 'text', speaker: "buluo", text: "（转头看向小满，表情复杂）小满，明天带她看《动物世界》吧。至少那里面，谁也不会说要买房子。" },
{ type: 'narrator', text: "真正的灾难发生在若依试图复刻“壁咚”的时候。她挑了冰箱作为壁咚对象，单手一撑——冰箱在重力作用下缓缓倾斜，哐当一声倒在地上，牛奶洒了一地。" },
{ type: 'cg', img: "番外_学电视剧_03_冰箱.png" },
{ type: 'se', name: "boom" },

{ type: 'text', speaker: "ruoyi", text: "（低头看着现场，面无表情）……报告。壁咚实验，失败。原因：对象质量过大。" },
{ type: 'text', speaker: "xiaoman", text: "（一边擦地一边笑出眼泪）你咚之前，就没想想冰箱站得住吗！" },
{ type: 'text', speaker: "ruoyi", text: "我以为，壁咚是电视里所有墙都承受得住的。" },
{ type: 'text', speaker: "xiaoman", text: "那叫道具墙！" },
{ type: 'narrator', text: "若依把这条也记进了档案：人类的墙，只有道具墙才承受得住壁咚。真实的墙，用来放冰箱。" },
{ type: 'narrator', text: "随后，若依开始对整部剧进行“验收测试”。她抱着小平板，一条一条念出检测报告。" },
{ type: 'text', speaker: "ruoyi", text: "报告。发现剧本漏洞三处。第一处：男二号摔下悬崖，第二集却毫发无伤地出现在咖啡店，建议修复。第二处：女主角失忆后，还记得男主角爱吃的菜，逻辑矛盾。第三处：所有人都在大雨里淋了十分钟，头发却依然蓬松。" },
{ type: 'text', speaker: "xiaoman", text: "……你是不是把我们家的剧，当博士的实验报告来审了？" },
{ type: 'text', speaker: "ruoyi", text: "（认真）人类编故事，漏洞越少，观众越容易相信。" },
{ type: 'text', speaker: "xiaoman", text: "（沉默片刻）那你知道大家为什么明知道是假的，还是爱看吗？" },
{ type: 'narrator', text: "若依摇了摇头。这个问题，她的样本库里没有答案。" },

/* ---- 三、★ 选择点 · 若依想学哪种剧 ---- */
{ type: 'option', choices: [ { label: "学宫斗剧的“话里有话”", goto: "FAN2_A" }, { label: "学甜宠剧的“霸总语录”", goto: "FAN2_B" }, { label: "改看纪录片，“只看真的”", goto: "FAN2_C" } ] },

{ type: 'label', id: "FAN2_A" },
{ type: 'narrator', text: "若依决定深入钻研“话里有话”。当晚，她端着一杯水走到布洛面前，端庄行礼。" },
{ type: 'cg', img: "番外_学电视剧_04_宫斗.png" },
{ type: 'se', name: "pour" },
{ type: 'text', speaker: "ruoyi", text: "博士，臣妾见您面色红润，想必是实验室传出了好消息。" },
{ type: 'text', speaker: "buluo", text: "……你正常点，我害怕。" },
{ type: 'text', speaker: "ruoyi", text: "（转向小满）姐姐，您今晚气色欠佳，可是为那雨夜所扰？" },
{ type: 'text', speaker: "xiaoman", text: "（笑喷）你这是跟谁学的！" },
{ type: 'text', speaker: "ruoyi", text: "剧里的娘娘们都是这么说话的。姐姐，人类为什么不能直接说“你累不累”，而要说“您气色欠佳”？" },
{ type: 'text', speaker: "xiaoman", text: "（想了想，认真地回答）因为有些话，绕个弯说，是想让对方更舒服一点。但绕太多弯，就成了累人。" },
{ type: 'text', speaker: "ruoyi", text: "那姐姐，以后我直接问你“累不累”。" },
{ type: 'text', speaker: "xiaoman", text: "（伸手揉她的头发）好。这句话，比剧里所有的台词都值钱。" },
{ type: 'jump', goto: "FAN2_MERGE" },

{ type: 'label', id: "FAN2_B" },
{ type: 'narrator', text: "若依决定把“霸总语录”练到满分。第二天早上，她把围裙递给布洛，神情冷峻。" },
{ type: 'cg', img: "番外_学电视剧_05_霸总.png" },
{ type: 'text', speaker: "ruoyi", text: "女人，你成功引起了我的注意。" },
{ type: 'text', speaker: "buluo", text: "（手里的煎蛋铲掉到地上）……我是男的。" },
{ type: 'text', speaker: "ruoyi", text: "（面不改色）男人，你成功引起了我的注意。" },
{ type: 'text', speaker: "ruoyi", text: "过来，给本公主擦鞋，不然，别怪我不客气！" },
{ type: 'text', speaker: "buluo", text: "额，一天天的，都是谁教你的，你的注意能不能先放回实验室。" },
{ type: 'narrator', text: "若依没有收手。她开始给家里每个人安排“人设”：小满是“傲娇大小姐”，布洛是“隐忍男主”，她自己则是“掌管全家的神秘总裁”。她甚至给扫地机器人配了台词——“女人，你扫过的地，本座承包了”。" },
{ type: 'text', speaker: "xiaoman", text: "扫地机器人都有台词了，你给博士配的台词是什么？" },
{ type: 'text', speaker: "ruoyi", text: "他今天的台词是——“你们开心就好，我去实验室静静。”" },
{ type: 'text', speaker: "xiaoman", text: "（笑得直不起腰）这台词，太像他会说的了。" },
{ type: 'narrator', text: "闹够了之后，若依忽然安静下来，认真地问小满。" },
{ type: 'text', speaker: "ruoyi", text: "姐姐，剧里的人为什么总要说“你成功引起了我的注意”？被注意到，不是一件平常的事吗？" },
{ type: 'text', speaker: "xiaoman", text: "（声音温柔下来）因为现实里，太多人被看见了，却很少有人被“注意”到。看，是眼睛的事；注意，是心的事。" },
{ type: 'text', speaker: "ruoyi", text: "（默默把这句话存进核心）那我记住了——我要用心的模块，去注意每一个人。" },
{ type: 'jump', goto: "FAN2_MERGE" },

{ type: 'label', id: "FAN2_C" },
{ type: 'narrator', text: "若依对“演出来的故事”产生了深深的怀疑，她要求换台。" },
{ type: 'text', speaker: "ruoyi", text: "姐姐，既然剧是假的，我想看真的。" },
{ type: 'narrator', text: "小满于是调到了纪录片频道——草原上，一只狮子正趴在水塘边，望着夕阳。" },
{ type: 'cg', img: "番外_学电视剧_06_纪录片.png" },
{ type: 'text', speaker: "ruoyi", text: "（盯着屏幕，安静了很久）姐姐，这只狮子，是真的在“望”吗？" },
{ type: 'text', speaker: "xiaoman", text: "它大概在想……今天有没有吃饱，明天去哪儿。" },
{ type: 'text', speaker: "ruoyi", text: "它没有剧本，也没有台词，可是它看起来，比剧里的人都要认真。" },
{ type: 'text', speaker: "xiaoman", text: "（愣了一下）为什么这么说？" },
{ type: 'text', speaker: "ruoyi", text: "因为剧里的人，演的是别人想让他活成的样子。而这只狮子，活的就是它自己。" },
{ type: 'narrator', text: "小满被这句话击中了，半天没有说话。她忽然发现，自己教会了若依很多东西，可眼前这个机器人少女，正在用她笨拙的算法，一点点拆解“人为什么活着”。" },
{ type: 'text', speaker: "ruoyi", text: "（转头，眼睛亮晶晶的）姐姐，我以后可以一直看真的东西吗？" },
{ type: 'text', speaker: "xiaoman", text: "可以。但也要记住，人是需要假的故事的——因为有时候，我们得借别人的故事，才能理解自己的日子。" },
{ type: 'text', speaker: "ruoyi", text: "那我要先把日子过真，再看故事。" },
{ type: 'jump', goto: "FAN2_MERGE" },

/* ---- 四、尾声 · 为假的故事，流真的眼泪 ---- */
{ type: 'label', id: "FAN2_MERGE" },
{ type: 'bgm', name: "title" },
{ type: 'narrator', text: "深夜，雨停了。小满看完了大结局，哭得稀里哗啦。若依坐在她身边，认真观察她的眼泪，伸手接了一滴，在指尖仔细研究。" },
{ type: 'cg', img: "番外_学电视剧_07_眼泪.png" },
{ type: 'text', speaker: "ruoyi", text: "姐姐，你的眼睛在漏水。" },
{ type: 'text', speaker: "xiaoman", text: "（吸着鼻子）这叫……叫喜极而泣！大结局……男主角终于……呜呜……" },
{ type: 'text', speaker: "ruoyi", text: "系统检测到，你的心率上升，呼吸紊乱，可是你并没有受伤。请问，是什么导致了你“过热”？" },
{ type: 'text', speaker: "xiaoman", text: "是感动！是舍不得！是他们终于在一起了！" },
{ type: 'text', speaker: "ruoyi", text: "（歪头）他们在一起，和你有什么关系？" },
{ type: 'narrator', text: "小满被问住了。她想了很久，才慢慢开口。" },
{ type: 'text', speaker: "xiaoman", text: "因为……我借他们的故事，哭了一次自己的心事。剧里那个人等了十年，我就想起了，我也等过谁。他等到了，可我还在等。所以眼泪是真的。" },
{ type: 'narrator', text: "若依沉默了很久。她的光学眼瞳里，第一次有了某种她自己也解释不清的波动。" },
{ type: 'text', speaker: "ruoyi", text: "姐姐，我的系统里，没有“等待”这个模块。可是你刚才说“等过谁”的时候，我的核心温度，升高了零点三度。" },
{ type: 'text', speaker: "xiaoman", text: "（擦干眼泪，把她搂进怀里）那不叫温度升高。那叫……心疼。若依，你会学会的。你会学会心疼，学会等待，学会为假的故事，流真的眼泪。因为你现在，已经有一点点像人了。" },
{ type: 'text', speaker: "ruoyi", text: "……一点点是多少？" },
{ type: 'text', speaker: "xiaoman", text: "（笑着蹭了蹭她的发顶）就是比昨天，多一点点“人”。不用算得很清楚——只要你愿意学，就够了。" },
{ type: 'text', speaker: "ruoyi", text: "那我要学得慢一点，学得久一点。这样，姐姐就还能多教我一会儿。" },
{ type: 'narrator', text: "小满眼眶又红了，把脸埋进她肩头。" },
{ type: 'text', speaker: "xiaoman", text: "……嗯。慢慢学，我慢慢教。" },

{ type: 'narrator', text: "那天夜里，若依给全家排了一部新剧——《家政少女若依》第一集：征服厨房的鸡蛋。博士被迫出演“冷漠管家”，小满客串“挑剔大小姐”。全剧只有一个观众，是那只被壁咚过的冰箱——它躺回原位，安静地听完了整出戏。" },
{ type: 'narrator', text: "若依在片尾字幕里写道：本剧纯属虚构，如有雷同，说明人间是真的。" },
{ type: 'ending', kind: "fan", title: "番外完", text: "为假的故事，流真的眼泪。若依正在学会，成为一个人。", bg: "bg_title" },
]



